var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/en.json
var en_default = {
  COMPLETED_ACTIVITIES: "Completed Activities",
  AVAILABLE: "Available",
  SEE_MORE_ACTIVITIES: "See More",
  SEE_MORE_COMPLETED_ACTIVITIES_ARIA_LABEL: "See More Completed Activities",
  COMPLETED_ACTIVITIES_EMPTY_STATE: "When you complete activities, they will appear here!",
  MISSED_ACTIVITIES: "Missed Activities",
  SEE_MORE_MISSED_ACTIVITIES_ARIA_LABEL: "See More Missed Activities",
  MISSED_ACTIVITIES_EMPTY_STATE: "When you miss activities, they will appear here!",
  DISPLAYING_ACTIVITIES_FROM_DATE: "Displaying activities since {date}",
  STANDALONE_ACTIVITIES: "Standalone Activities",
  STANDALONE_ACTIVITIES_EMPTY_STATE: "Nothing to do here yet! Come back later.",
  VIEW_ALL_STANDALONE_ACTIVITIES: "View All Standalone Activities",
  MODULE_TEMPLATE_BUTTON: "Module Template Button",
  ACHIEVEMENTS: "Achievements",
  VIEW_ACHIEVEMENTS: "View achievements",
  DEPENDENT_NOTIFICATION_MESSAGE: "New dependents could be invited",
  DEPENDENT_COVERED_BY_HSA_ONLY: "Note: This dependent will be only covered under your Health Spending Account.",
  WALLET_LANDING_NAV_LABEL: "Wallet Navigation",
  VIEW_CARD_FOR_DEPENDENT: "View card for {dependentName}",
  LEARN_MORE_LEAGUE_FAMILY: "about League Family for your dependents",
  GO_TO_LIFEMARKET: "Go to Lifemarket to view order number {invoiceId}",
  GO_TO_CLAIM: "View claim details for {title}",
  GO_TO_RECEIPT: "View receipt for {title}",
  LINK_TO_TRANSACTION_DETAILS: "Link to details",
  VIEW_CLAIM_LABEL_HIDDEN: "View {vendor} claim {referenceId}",
  QLE_LINK_LABEL: "Learn more about qualifying life events",
  PLEASE_CALL: "Please call {phoneNumber}",
  BROWSE_FILES: "Browse Files",
  TOTAL_BALANCE: "Total Balance",
  LIFEMARKET: "Lifemarket",
  ABOUT: "About",
  LEAGUE_CREDIT_DESCRIPTION_1: `You can spend League Credit in {lifemarketLink} on a variety of lifestyle and wellness products and services. The only thing you can't spend it on is anything marked as a "League Partner Offer".`,
  LEAGUE_CREDIT_DESCRIPTION_2: 'To use your League Credit, select "League Credit" from the list of payment options when you checkout from Lifemarket. {learnMoreLink}',
  DID_YOU_GET_A_PROMO_CODE: "Did You Get a Promo Code?",
  DID_YOU_GET_A_PROMO_CODE_DESCRIPTION: "If you received a store credit or a promo code, you can enter it here to receive the credits. Once entered they will be automatically applied to your account.",
  GET_CARE: "Get Care",
  DISCLAIMER: "Disclaimer",
  JOINED: "Joined",
  ROLLED_OVER: "Rolled Over",
  NEED_MORE_INFO_SINGLE_CLAIM: "Your claim needs more info to be processed. View details below.",
  NEED_MORE_INFO_MULTIPLE_CLAIMS: "Your claims need more info to be processed. View details below.",
  RECENT_CLAIMS: "Recent Claims",
  IF_YOU_HAVE_AN_URGENT_CLAIM_PLEASE_CONTACT_CUSTOMER_SUPPORT: "If you have an urgent claim, please contact <a>Customer Support</a>.",
  ABOUT_THIS_BENEFIT: "About this Benefit",
  ABOUT_THIS_BENEFIT_DESCRIPTION: "This benefit is made available to you by your employer. For questions or detailed information, please reach out to your HR administrator.",
  ID_LIKE_TO_DOTDOTDOT: "I'd like to ...",
  HAS_DEPENDENTS_DESCRIPTION: "Your dependents for this benefit are listed below. If you recently experienced a life event, you may be eligible to make changes to your dependents. Click the button below to check if you qualify in just a few steps.",
  HAS_NO_DEPENDENTS_DESCRIPTION: "You don't have any dependents associated with this benefit. If you recently experienced a life event, you may be eligible to add or change your dependents. Click the button below to check if you qualify in just a few steps.",
  ADD_A_DEPENDENT_CAPITAL: "Add a Dependent",
  WALLET_FEEDBACK_TITLE: "Help us improve the Wallet experience",
  WALLET_FEEDBACK_SUBTITLE_BENEFIT: "How helpful is the information provided for your \u201C{benefitName}\u201D benefit?",
  WALLET_FEEDBACK_SUBTITLE_OTHER: "How helpful is the information provided for your {cardName}?",
  GO_BACK: "Go back",
  WALLET_LANDING_TITLE: "Your benefits and coverage info, all in one place.",
  WALLET_LANDING_BODY: "Your digital wallet is home to your employer benefits, programs and coverage details. Find what you need in a quick tap.",
  POLICY_ACTIVE: "Policy Active",
  REMAINING_BALANCE: "Remaining Balance",
  CONTACT_CUSTOMER_CARE: "contact Customer Care",
  UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG: "Uh oh, looks like something went wrong",
  WERE_HAVING_TROUBLE: "We\u2019re having trouble loading this information, please try to refresh the page. If the problem persists, please {custCareLink}.",
  IN_NETWORK: "In-Network",
  OUT_OF_NETWORK: "Out-of-Network",
  PROGRAMS: "Programs",
  PROGRAM_CREATED_BY: "Program Created by",
  TOP_FOCUS_AREA: "Top focus area",
  DIMENSION_OF_HEALTH: "DIMENSION OF HEALTH",
  READING_MORE_ABOUT_DIMENSIONS: "Interested in reading more about how dimensions impact your overall health?",
  READ_OUR_ARTICLE: "Read Our Article",
  HEALTH_PROGRAMS_FOR_YOU: "Health Programs for you",
  COMPLETE_ACTIVITIES: "Complete activities to reach your health goals. Recommended based on your Health Profile.",
  FT: "ft",
  CM: "cm",
  IN: "in",
  LB: "lb",
  KG: "kg",
  LETS_BEGIN: "Let\u2019s Begin!",
  KEEP_GOING: "Keep Going",
  SKIP: "Skip",
  HP_ONBOARDING_SUBMIT: "Let's begin",
  FOR_PROVIDERS_AND_PHARMACISTS: "For Providers/Pharmacists",
  WEVE_PICKED_UP: "We've picked up where you left off.",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NUMBER: "You're only a few questions away from earning {points} points.",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NOR_POINTS: "You're only a few questions away from completing the assessment.",
  PRESS_ENTER: "Press Enter",
  SELECT_ALL_THAT_APPLY: "Select all that apply",
  SELECT_UP_TO: "Select up to {number}",
  AMOUNT_QUESTIONS: "{amount} questions",
  QUESTION_PROGRESS: "QUESTION {questionNumber} OF {totalQuestions}",
  COMPLETE: "Complete",
  VIEW_MORE: "View More",
  DOWNLOAD_APP_STORE: "Download on the App Store",
  DOWNLOAD_PLAY_STORE: "Get it on Google Play",
  WE_RE_SORRY_REQUESTED_PAGE_EXPIRED_OR_NOT_VALID: "We\u2019re sorry, the page you\u2019ve requested has either expired or is no longer valid.",
  EARNED_X_TIMES: "Earned {amount}X",
  EARNED: "Earned",
  YOUVE_EARNED_TOTAL: "You've earned a total of",
  YOUVE_EARNED_GRAND_TOTAL: "You've earned a grand total of",
  YOUVE_EARNED_ACHIEVEMENT_BADGE: "You've earned a Achievement Badge",
  CONGRATS_COMPLETED: "Congrats! You've completed",
  VIEW_MY_HEALTH_DASHBOARD: "View My Health Dashboard",
  LATEST_INSIGHTS_METRICS_AND_MORE: "Latest insights, metrics, and more",
  FEEDBACK_TITLE: "How helpful was this information?",
  FEEDBACK_MIN_SCALE: "Unhelpful",
  FEEDBACK_MAX_SCALE: "Very helpful",
  HAVE_YOU_RECENTLY_EXPERIENCED_CHANGES: "Have you recently experienced changes in your life or family?",
  DID_YOU_RECENTLY: "Did you recently get married or have a baby? Certain life events may qualify you for re-enrollment.",
  LEARN_MORE: "Learn More",
  VIEW_ACTIVITY: "View Activity",
  CONTINUE: "Continue",
  ARIA_CIRCLED_CHECKMARK: "White checkmark enclosed within a circle",
  NOT_NOW: "Not Now",
  VAL_POINTS: "{points} points",
  ACTIONS: "Actions",
  VIEW_ALL_CLAIMS: "View All Claims",
  THIS_BOX_MUST_BE_CHECKED_TO_CONTINUE: "This box must be checked to continue",
  PLEASE_NOTE: "Please Note",
  COPY: "Copy",
  STATUS: "Status",
  STARTED: "Started",
  APPROVED: "Approved",
  CANCELLED: "Cancelled",
  UPLOADED_DOCUMENT: "Uploaded {date} \u2022 Uploaded by {user}",
  MORE_INFORMATION_NEEDED: "Needs Info",
  PAID: "Paid",
  PENDING_EXTERNAL_REVIEW: "Sent for External Review",
  PREAPPROVAL_MORE_INFORMATION_NEEDED: "Pre-approval More Info",
  PREAPPROVAL_REJECTED: "Pre-approval Rejected",
  PREAPPROVED: "Pre-approved",
  REJECTED: "Rejected",
  SUBMITTED_FOR_PREAPPROVAL: "Submitted for Pre-approval",
  SUBMITTED: "Submitted",
  WALLET: "Wallet",
  AMOUNT: "Amount",
  ADD: "Add",
  EDIT: "Edit",
  DETAILS: "Details",
  AND: "and",
  TODAY: "Today",
  CLAIMS: "Claims",
  GROUP_ID: "Group ID",
  ZIP_CODE: "Zip Code",
  CITY: "City",
  STATE: "State",
  REMOVE: "Remove",
  HEALTH_SPENDING_ACCOUNT: "Health Spending Account",
  HSA: "HSA",
  LIFESTYLE_SPENDING_ACCOUNT: "Lifestyle Spending Account",
  LSA: "LSA",
  HEALTH_REIMBURSEMENT_ARRANGEMENT: "Health Reimbursement Arrangement",
  DRUGS: "Drugs",
  TRAVEL: "Travel",
  HEALTH_INSURANCE: "Health Insurance",
  SETTINGS: "Settings",
  ACTIVE: "Active",
  ENDED: "Ended",
  SUSPENDED: "Suspended",
  PENDING: "Pending",
  LOADING: "Loading",
  ERROR_STATE_TITLE: "Something went wrong",
  HELP_EMAIL: "help@league.com",
  SUBMIT: "Submit",
  EARN_NUMBER_POINTS_FULL: "Earn {points} points",
  CLOSE: "Close",
  THIS_CHALLENGE_RUNS_YEAR_ROUND: "This challenge runs year-round",
  END_DAY_AT_TIME: "Ends {day}",
  ENDED_DAY_AT_TIME: "Ended {day}",
  START_DAY_AT_TIME: "Starts {day}",
  SPONSOR_LOGO: "{name} logo",
  START_AND_END_DATES: "Starts {startDate} \u2022 Ends {endDate}",
  SIGN_UP_BY_DATE: "Sign up by {date}",
  SIGN_UP_BEGINS_DATE: "Sign-up begins {date}",
  SIGN_UP_DATE_PASSED: "Sign-up date passed",
  SIGN_UP_PERIOD_PASSED: "Sign-up period passed",
  CHALLENGE_DETAILS: "Challenge Details",
  CHALLENGE_PROGRESS: "Challenge Progress",
  X_PERCENT_COMPLETE: "{number}% Complete",
  SIGN_UP_FOR_CHALLENGE: "Sign Up",
  GROUP_CHALLENGE: "Group Challenge",
  SOLO_CHALLENGE: "Solo Challenge",
  TRACK_WEARABLES_ALT_TEXT: "Person looking at smart watch data",
  CONNECT_A_DEVICE: "Connect a Device",
  DEVICES_CONNECTED_TITLE: "Looks like you\u2019re already connected!",
  DEVICES_CONNECTED_DESCRIPTION: "We\u2019re already syncing your data. If you choose to track automatically, we can automatically mark activities as complete using your device's {dataPoint}.",
  DEVICES_UNCONNECTED_TITLE: "Let\u2019s connect your device!",
  DEVICES_UNCONNECTED_TRACK_AUTOMATICALLY_SUBTITLE: "Tracking automatically",
  DEVICES_UNCONNECTED_TRACK_MANUALLY_SUBTITLE: "Tracking manually",
  DEVICES_UNCONNECTED_DESCRIPTION: "Connect your favorite health apps and devices to automatically mark activities as complete.",
  TRACK_CHALLENGE_AUTOMATICALLY: "Track automatically",
  TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION: "If you choose to track automatically, after you\u2019ve signed up, {instructionsLink} to connect your device using the League mobile app.",
  TRACK_CHALLENGE_AUTOMATICALLY_INSTRUCTION: "follow these steps",
  TRACK_CHALLENGE_MANUALLY: "Track manually instead",
  TRACK_CHALLENGE_MANUALLY_CHANGE_LATER: "If you choose to track manually, you can still connect a device later. {learnMoreLink} about tracking your progress manually.",
  TRACK_CHALLENGE_MANUALLY_LEARN_MORE: "Learn more",
  TRACK_HEALTH_DATA_ALT: "Dashboard with graph tracking health data",
  TRACK_MANUALLY_CONFIRM_TITLE: "Are you sure you want to track manually?",
  TRACK_MANUALLY_CONFIRM_CONNECT_LATER_DESCRIPTION: "You will still be able to connect a device at a later time",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_TITLE: "Are you sure you want to exit?",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_DESCRIPTION: "If you choose to exit, your changes may not be saved.",
  EXIT: "Exit",
  CHALLENGE: "Challenge",
  CHALLENGES: "Challenges",
  CHALLENGE_PROGRAM_LIBRARY_DESCRIPTION: "Sign up for a challenge to complete daily activities and compete against your peers!",
  THIS_CHALLENGE_HAS_ENDED: "This challenge has ended",
  COMPLETED_ON_DATE: "Completed on {date}",
  ENDED_ON_DATE: "Ended on {date}",
  LEAVE_CHALLENGE: "Leave Challenge",
  LEAVE_CHALLENGE_QUESTION: "Leave Challenge?",
  LEAVE_CHALLENGE_DETAIL: "Are you sure you want to remove this challenge from your journey? Any progress in this challenge will be reset.",
  LEAVE: "Leave",
  SIGN_UP_FOR_THE_CHALLENGE: "Sign Up for the Challenge",
  CHALLENGE_SENSITIVE_DATA: "Your health data and personal information are highly sensitive and it\u2019s our responsibility to keep it private and secure. We take this responsibility very seriously.",
  CHALLENGE_USING_DATA_TO: "When you sign up for a challenge, we are using your data to:",
  COMPLETE_ACTIVITIES_SHORT: "Complete activities",
  SHARE_CHALLENGE_PROGRESS_WITH_EMPLOYER: "Share your challenge progress with your employer",
  SHARE_CHALLENGE_PROGRESS: "Share your challenge progress with your peers (and employer)",
  RANK_SCORE: "Rank your score in a leaderboard",
  DETERMINE_CHALLENGE_WINNERS: "Determine challenge winners",
  ACCEPT_BEFORE_CONTINUE: "You must accept the privacy policy before continuing.",
  CHECK_TO_CONFIRM_PRIVACY_POLICY: "By checking this box, I agree to the <a>privacy policy.</a>",
  LEARN_MORE_ABOUT_PRIVACY_POLICY: "Learn more about how League manages and uses your data in our <a>privacy policy.</a>",
  PRIZE: "Prize",
  RULES: "Rules",
  LEADERBOARD: "Leaderboard",
  TOOLTIP_ACTION_DESCRIPTION: "See leaderboard ranking criterion",
  MARK_AS_DONE: "Mark as done",
  CLOSE_ACTIVITY: "Close Activity",
  GOAL_INCOMPLETE: "You must complete the goal before continuing.",
  PROGRESS_RECORD_ERROR: "There was an issue recording your last progress.",
  YOUVE_COMPLETED: "You completed",
  ACTIVITY_COMPLETE: "Activity complete",
  PAGE_NOT_FOUND_HEADER: "Page Not Found",
  PAGE_NOT_FOUND_CONTENT: "Looks like you got a little lost!",
  PAGE_NOT_FOUND_CONTENT_SECONDARY: "Let's help you find yourself.",
  PAGE_NOT_FOUND_BUTTON: "Return Home",
  REWARD_POINTS: "Reward Points",
  REWARD_POINTS_EARNED: "Reward Points Earned",
  REWARD_POINTS_MISSED: "Reward Points Missed",
  X_REWARD_POINTS: "{points} Reward Points",
  X_LEAGUE_POINTS: "{points} League Points",
  REWARDS_PROGRAM_ELIGIBLE: "Rewards Program Eligible",
  EXPIRY_DATE: "Expiry date",
  NO_EXPIRY_DATE: "No expiry date",
  POINTS_BALANCE: "Points Balance",
  REDEEM_NEXT_TIER_POINTS: "You\u2019re {points} away from redeeming {value}.",
  VIEW_YOUR_REWARDS: "View Your Rewards",
  REDEEMABLE: "Redeemable for {value}.",
  ACTIVATION_PENDING: "Activation Pending",
  EXPIRED: "Expired",
  YOUR_ACCOUNT_IS_ACTIVE_AND_IN_THE_PROCESS_OF_BEING_SET_UP: "Your account is active and in the process of being set up.",
  PLEASE_TRY_AGAIN_SHORTLY: "Please try again shortly",
  MANAGE_DEPENDENTS: "Manage Dependents",
  VIEW_CARD: "View Card",
  MEMBER_ID: "Member ID",
  SPOUSE: "Spouse",
  COMMON_LAW: "Common-law",
  CHILD: "Child",
  PARENT: "Parent",
  GRANDPARENT: "Grandparent",
  GRANDCHILD: "Grandchild",
  UNCLE_AUNT: "Uncle / Aunt",
  NEPHEW_NIECE: "Nephew / Niece",
  INELIGIBLE_CHILD: "Ineligible Child",
  SIBLING: "Sibling",
  OTHER: "Other",
  DEPENDENT_CARD_HOLDER: "{dependentName}'s card for",
  DATE: "Date",
  DESCRIPTION: "Description",
  TYPE: "Type",
  ID: "ID",
  CLAIM: "Claim",
  TOP_UP: "Top Up",
  ADJUSTMENT: "Adjustment",
  REFUND: "Refund",
  LEAGUE_CREDIT: "League Credit",
  CREDIT_CARD: "Credit Card",
  CGA: "CGA",
  NO_TRANSACTIONS_YET: "No transactions yet",
  NO_MORE_TRANSACTIONS: "No more transactions",
  PROMO_CODE: "Promo code",
  PROMO_CODE_NOT_FOUND: "Invalid promo code",
  PROMO_CODE_SUCCESS: "Promo code redeemed!",
  TOTAL_CREDIT: "Total Credit:",
  CREDIT_INFORMATION: "Credit Information",
  ENTER_CODE: "Enter Code",
  DOCUMENT_NAME: "Document name",
  REQUIRED: "Required",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  ALLOCATION: "Allocation",
  COVERED: "Covered",
  NOT_COVERED: "Not covered",
  COVERED_WITH_RESTRICTIONS: "Covered with restrictions",
  EXPAND_ALL: "Expand All",
  COLLAPSE_ALL: "Collapse All",
  EXAMPLES: "Examples: ",
  RESTRICTIONS: "Restrictions",
  SEARCH_COVERAGE: "Search your coverage",
  COVERAGE_SEARCH_BEHAVIOUR_DESCRIPTION: "Search results will update automatically as you type",
  INDIVIDUAL: "individual",
  INDIVIDUAL_CAP: "Individual",
  DEPENDENTS: "Dependents",
  SELECT_ONE: "Select one",
  MORE_OPTIONS: "More Options",
  VENDOR: "Vendor",
  FLEX_DOLLAR_INFO_TEXT_SINGLE: "they will automatically be added to your {benefitName}.",
  FLEX_DOLLAR_INFO_TEXT_MULTIPLE: "<strong>{percent}%</strong> will be added to your <strong>{benefitName}</strong>",
  LEFTOVER_FLEX_DOLLAR_INFO_TEXT_SINGLE: "<strong>{percent}%</strong> of it will be added to your <strong>{benefitName}</strong>.",
  DOCUMENT_TITLE: "{title} - League",
  MEDICAL: "Medical",
  TOTAL: "Total",
  PROFILE_UPDATE_FAILED: "Profile Update Failed",
  PROFILE_PHOTO: "Profile photo",
  PROFILE_PHOTO_DESCRIPTION: "This photo shows up on your user profile",
  SELECT_AVATAR: "Select Avatar",
  SELECT_AVATAR_ERROR: "You must choose an avatar before continuing.",
  GET_AVATARS_ERROR: "Oops! There was an issue loading the avatars. Please go back and select a different option.",
  ADDRESS_LINE_1: "Address Line 1",
  ADDRESS_LINE_2: "Address Line 2",
  LANGUAGE_SELECTOR_ENGLISH: "English",
  LANGUAGE_SELECTOR_FRENCH: "Fran\xE7ais",
  LANGUAGE_SELECTOR_SPANISH: "Espa\xF1ol",
  DOMESTIC_PARTNERSHIP: "Domestic Partnership",
  YES: "Yes",
  NO: "No",
  WHY_DO_YOU_ASK: "Why do you ask?",
  LAST_DAY_OF_ENROLLMENT: "Last day of enrollment period: {lastDay}",
  WALLET_WELCOME: "Welcome to your Wallet!",
  WALLET_DESCRIPTION: "Your wallet is where you'll be able to access your benefits, submit claims, and check your coverage.  You will be able to submit claims for costs incurred during the enrollment period once your wallet becomes active. In the meantime, {healthProgramLink}!",
  HEALTH_PROGRAM_LINK_COPY: "try one of our health programs",
  FINALIZE_SELECTIONS_HEADER_COPY: "Do you want access to your benefits sooner?",
  FINALIZE_SELECTIONS_COPY_1: "By finalizing your selections, we\u2019ll be able to send your plan details to the carrier right away! This means you won't have to wait until the end of your enrollment period to view your wallet.",
  FINALIZE_SELECTIONS_COPY_2: "This also means that you won\u2019t be able to make any changes to your plan after clicking submit.",
  FINALIZE_SELECTIONS_ACKNOWLEDGEMENT: "I understand I won't be able to change my selections",
  FINALIZE_PLAN_SELECTIONS: "Finalize Plan Selections",
  ERROR_FINALIZING_SELECTIONS: "There was an error submitting your selections.",
  ERROR_FINALIZING_SELECTIONS_INVALID_SELECTIONS: "Looks like your selections are incomplete. Please complete enrollment and try again.",
  SELECTIONS_FINALIZED_SUCCESS: "Selections finalized!",
  TOTAL_REWARDS_LABEL: "Coverage Summary",
  TOTAL_REWARDS_DESCRIPTION: "Review the plan selections that you made during your enrollment.",
  TOTAL_REWARDS_LINK: "View Coverage Summary",
  CHANGE_PLAN_LABEL: "Change Plan Selections",
  CHANGE_PLAN_DESCRIPTION: "Want to make changes to your plan or personal information?",
  CHANGE_PLAN_LINK: "Change Plan Selections",
  DISMISS_TOAST: "Dismiss notification",
  UPLOAD_DOCUMENT: "Upload Document",
  REQUIRED_FORM: "Required",
  PERCENTAGE_USED: "{percentage} used.",
  SUCCESS: "Success!",
  ERROR: "Error",
  OVERVIEW: "Overview",
  THIS_FIELD_IS_REQUIRED: "This field is required",
  INVALID_ZIP_CODE_NO_FORMAT: "Invalid zip code",
  INVALID_DAY_ERROR_MESSAGE: "The day you selected is invalid.",
  UNIQUE_IDENTIFIER_MAX_LENGTH_ERROR: "Must be at most {length} characters",
  COMPLETED_STATE_TITLE: "Completed",
  DRAG_OR_UPLOAD_PHOTO: "Upload a photo of this document",
  ADD_IMAGE: "Add more pages to this document (if applicable)",
  IDENTIFICATION_TYPE_TWO_FILES: "Identification documents can only have up to 2 supporting images.",
  WELCOME: "Welcome",
  GOT_IT: "Got It!",
  SAVE: "Save",
  VIEW_MORE_DETAILS_SENTENCE_CASE: "View more details",
  LAST_UPDATED: "Last Updated",
  CLAIM_REF_NUMBER: "Claim #",
  VIEW_ALL: "View All",
  HRA: "HRA",
  SEARCH: "Search",
  DAY: "Day",
  MONTH: "Month",
  YEAR: "Year",
  BACK: "Back",
  NEXT: "Next",
  PREVIOUS: "Previous",
  HELP_CENTER: "Help Center",
  LIVE_CHAT_TOP_BAR_MINIMIZE: "Minimize chat",
  LIVE_CHAT_FEED_NEW_CHIPS_ALT: "Suggested replies available",
  LIVE_CHAT_AGENT_TYPING_BUBBLE_ALT: "Chat participant is typing",
  VIEW_DOCUMENT: "View Document:",
  CATEGORIES: "Categories",
  ACTIVE_PROGRAM: "Active {length, plural, one {Program} other {Programs}}",
  ACTIVE_CHALLENGE: "Active {length, plural, one {Challenge} other {Challenges}}",
  PROGRAM_PROGRESS: "Program Progress",
  MULTI_SELECT_DEFAULT_CAN_CREATE: "You can also type to create a new option!",
  MULTI_SELECT_DEFAULT_PLACEHOLDER: "Select your options",
  COVERAGE: "Coverage",
  HEALTH_PROFILE: "Health Profile",
  HEALTH_PROGRAM: "Health Program",
  HEALTH_PROGRAMS: "Health Programs",
  STEPS: "steps",
  ACTIVE_DURATION: "active minutes",
  MINDFUL_DURATION: "mindful minutes",
  FLOORS_CLIMBED: "flights climbed",
  DISTANCE: "distance traveled",
  ENERGY_BURNED: "calories burned",
  METRIC_DETAILS: "Metric Details",
  HEALTH_PROGRAMS_SYNC_DEVICE: "Sync your {device} for the optimal program experience.",
  HEALTH_PROGRAMS_CONNECTED_PROGRAM: "Connected health program",
  TRACK_AUTOMATICALLY: "Track Your Progress Automatically",
  SYNC_ISSUE: "SYNC ISSUE",
  FIX_SYNC_ISSUE: "Fix this issue",
  DATAPOINT_SYNC_ISSUE: "There was an issue syncing your {dataPoint}.",
  CONNECT_TO_TRACK: "Connect your favourite health apps and devices to automatically mark activities as complete.",
  CONNECT_APPS_DEVICES: "Connect apps & devices",
  ADD_APPS_DEVICES: "View Apps & Devices",
  MANAGE_UNITS: "Change units of measurement",
  DONT_CONNECT_APPS_DEVICES: "Don't track my progress automatically",
  CONNECTING_UNAVAILABLE: "Connecting apps and devices is not available on the web",
  CONNECTING_UNAVAILABLE_DETAILS: "For now, please visit the League mobile app to connect your favourite health apps and devices.",
  CONNECTING_UNAVAILABLE_DETAILS_WITH_LINK: "For now, please visit the League mobile app to connect your favourite health apps and devices. If you\u2019d like to learn more, you can find a full list of the",
  CONNECT_DEVICES_LEARN_MORE: "Learn More",
  APPS_AND_DEVICES_CURRENTLY_SUPPORTED: "apps and devices currently supported",
  DONT_HAVE_THE_APP: "Don\u2019t have the League mobile app?",
  WHAT_DEVICES_CAN_CONNECT: "What apps and devices are supported?",
  CONNECTED_DEVICES_IMAGE_ALT: "Person reviewing data from connected device",
  MORE_GREAT_RESOURCES: "More great resources",
  HISTORY: "History",
  TOP_MATCH: "Top match",
  CHAT: "Chat",
  END_CHAT: "End Chat",
  BECOMES_ACTIVE_ON_DATE: "Becomes active on {date}",
  BECOMES_ACTIVE_IN_X_DAYS: "This benefit becomes active in {days} days",
  YOU_CAN_ONLY_SUBMIT_CLAIMS_IN_DATE_RANGE: "You can only submit claims with a purchase/service date between <strong>{dateRange}</strong> for this benefit. View your coverage details for more info.",
  SUBMIT_PAST_CLAIMS_BY_DATE: "Submit past claims by {date}",
  THIS_POLICY_HAS_EXPIRED: "This policy period has expired, but you have {days} days left to submit past claims for this benefit",
  THIS_POLICY_EXPIRES_TOMORROW: "This policy period has expired, but today is your last day to submit past claims for this benefit",
  YOU_HAVE_UNTIL_DATE_TO_SUBMIT_PAST_CLAIMS: "You have until <strong>{inactiveDate}</strong> to submit past claims with a purchase/service date on or before <strong>{endDate}</strong>",
  EXPIRES_ON_DATE: "Expires on {date}",
  ASSIGNED: "Assigned",
  ASSIGNED_ON: "on {date}",
  ASSIGNED_TODAY: "today",
  YOU_HAVE_X_DAYS_BEFORE_EXPIRY: "You have {days} days left to use this benefit before the policy period expires",
  AFTER_EXPIRY_YOU_HAVE_UNTIL_DATE_TO_SUBMIT: "After expiry, you\u2019ll have until <strong>{inactiveDate}</strong> to submit claims with a purchase/service date on or before <strong>{endDate}</strong>",
  LOAD_MORE: "Load more",
  SHOW_MORE: "Show more",
  LINK_OUT_MESSAGE: "Must See",
  THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM: "Oops, there seems to have been a problem.",
  TRY_AGAIN: "Try Again",
  WARNING_OPENS_NEW_TAB: "Opens in a new tab",
  ANY_HEALTH_CHANGES: "Have there been any recent changes in your health?",
  LAST_UPDATED_DATE: "Last updated {date}",
  UPDATE_HEALTH_PROFILE: "Update your Health Profile",
  HEALTH_PROFILE_COMPLETION_POINTS: "You've earned {points} points",
  OPENS_IN_A_NEW_TAB: "Opens in a new tab",
  COMPLETED: "Completed",
  COMPLETED_X_TIMES: "Completed {amount} times",
  REMOVE_FROM_JOURNEY: "Remove from journey",
  GO_TO_JOURNEY: "Go to Journey",
  ABOUT_THIS_PROGRAM: "About this program",
  HEALTH_JOURNEY: "Health Journey",
  REMOVE_ACTIVITY: "Remove Activity?",
  REMOVE_ACTIVITY_PROMPT: "Remove Activity",
  REMOVE_ACTIVITY_BUTTON: "Remove",
  ARE_YOU_SURE_REMOVE_ACTIVITY: "Are you sure you want to remove this activity from your journey? This action can\u2019t be undone.",
  YOU_WILL_NO_LONGER_SEE_IN_JOURNEY: "You will no longer see it in your journey",
  DISCOVER_ACTIVITIES: "Discover new activities",
  DISCOVER_ACTIVITIES_CAPTION: "Browse activities we think you\u2019ll love",
  ACTIVITIES: "Activities",
  ACTIVITIES_PLURALIZATION: "{count, plural, one {Activity} other {Activities}}",
  ACTIVITIES_PILL: "Activities",
  PROGRAM_LIBRARY: "Program Library",
  BROWSE_PROGRAMS: "Browse Programs",
  BACK_TO_JOURNEY: "Back to Journey",
  GO_TO_HEALTH_JOURNEY: "Go to health journey",
  ADD_TO_JOURNEY: "Add to Journey",
  REQUEST_WAIT: "Please wait while we complete your request",
  JOURNEY_DELIGHT_1: "Motivation gets you started. Habit keeps you going. You got this!",
  JOURNEY_DELIGHT_2: "Active. Focused. Staying in your lane. We love to see it.",
  JOURNEY_DELIGHT_3: "Small steps can make a big difference. You are making that step!",
  TOOLBOX_INPUT_OPTION_FREE_TEXT: "This is a free-text option; use the text box to enter your own value. The current value is: {hasValue, select, true {{value}} other {empty}}",
  TOOLBOX_INPUT_OPTION_EXCLUSIVE: "This option is exclusive; selecting it will deselect all others",
  ANIMATION_ACCESSIBILITY_PLAYBACK: "Play or pause the currently selected animation",
  CENTIMETERS: "Centimeters",
  FEET: "Feet",
  INCHES: "Inches",
  KILOGRAMS: "Kilograms",
  POUNDS: "Pounds",
  EARN_UP_TO_X_POINTS: "Earn up to {points} points",
  EXPIRES_TODAY: "Expires today",
  PROGRAM_DETAILS: "Program Details",
  PROGRESS: "Progress",
  X_OF_Y_COMPLETE: "{completed}/{total} complete",
  X_OF_Y_COMPLETED_WITH_UNIT: "<span>{progress}</span> / {goal} {unit}",
  X_MISSED: "{missed} missed",
  MISSED: "Missed",
  SCROLL_CAROUSEL_RIGHT: "Scroll the carousel to the right",
  SCROLL_CAROUSEL_LEFT: "Scroll the carousel to the left",
  YOU_HAVENT_STARTED_PROGRAMS: "You haven't started any health programs",
  ADD_PROGRAM: "Add Program",
  TAP_ADD_PROGRAM_BUTTON: "Tap the \u2018Add Program\u2019 button to browse programs.",
  YOUVE_REACHED_PROGRAM_LIMIT: "You've reached your program limit!",
  START_X_MORE_PROGRAMS: "Start {duration, plural, one {# more program} other {# more programs}}. Keep the momentum.",
  OK: "Ok",
  COMPLETE_ONE_OF_ACTIVE_PROGRAMS: "Complete one of your active programs to add this to your journey.",
  SHOW_LESS: "Show Less",
  LOOKS_LIKE_REACHED_PROGRAM_LIMIT: "Looks like you\u2019ve reached your program limit!",
  COMPLETE_ACTIVE_PROGRAM_BEFORE_NEW_ONE: "Complete an active program before adding a new one. <strong>{ctaText}</strong>",
  REMOVE_PROGRAM: "Remove program?",
  REMOVE_PROGRAM_BUTTON: "Remove",
  ARE_YOU_SURE_REMOVE_PROGRAM: "Are you sure you want to remove this program from your journey? Any progress in this program will be reset and you will have to start over from the beginning.",
  PROGRAM_REMOVED: "Program removed",
  PROGRAM_ADDED: "Program added",
  THE_PROGRAM_WILL_APPEAR_IN_JOURNEY: "The program will now appear in your journey",
  PROGRAM_ADD_ERROR: "We were unable to add the program at this time. Please try again or choose another program.",
  PROGRAM_REMOVE_ERROR: "We were unable to remove the program at this time. Please try again.",
  SKIP_TO_CONTENT_MESSAGE: "Skip to content",
  MAIN_NAVIGATION_LIST_LABEL: "League navigation items",
  PAGE_TITLE_ACTIVITY_DETAILS: "Activity details",
  X_OF_Y: "{current} of {total}",
  ACTIVITY_COUNT_EDIT: "Edit {unit}",
  ACTIVITY_COUNT_GOAL: "Goal: {goal, number} {unit}",
  ACTIVITY_COMPLETE_PROMPT: 'To complete this activity, click "Mark as Done".',
  ACTIVITY_COMPLETE_LATER_PROMPT: 'To keep going, click "Back to Journey" and come back later to mark it done.',
  ACTIVITY_COMPLETE_ERROR: "We were unable to complete the activity at this time. Please try again.",
  ACTIVITY_DISMISS_ERROR: "We were unable to remove the activity at this time. Please try again.",
  TOOLBOX_VALIDATION_DAY_MONTH_YEAR: "Please select a day, month and year",
  TOOLBOX_VALIDATION_MONTH_YEAR: "Please select a month and year",
  TOOLBOX_VALIDATION_MAXIMUM_CHARACTERS: "Characters limit is {limit}",
  TOOLBOX_VALIDATION_NUMBER_MINIMUM: "Enter a number equal to or greater than {value}",
  TOOLBOX_VALIDATION_NUMBER_MAXIMUM: "Enter a number equal to or less than {value}",
  TOOLBOX_VALIDATION_REQUIRED_FIELD: "This is a required field",
  TOOLBOX_VALIDATION_DATE_INPUT_REQUIRED: "Please make a selection",
  TOOLBOX_VALIDATION_MULTI_SELECT_REQUIRED: "Please make a selection",
  TOOLBOX_VALIDATION_SELECT_DATE_LATER: "Select a date later than {date, date, medium}",
  TOOLBOX_VALIDATION_SELECT_DATE_EARLIER: "Select a date earlier than {date, date, medium}",
  TOOLBOX_VALIDATION_ENTER_WHOLE_NUMBER: "Enter a whole number",
  TOOLBOX_VALIDATION_SELECT_MAX_SELECTION: "Select a maximum of {integer} options",
  TOOLBOX_VALIDATION_SELECT_OPTIONS_TO_CONTINUE: "Select {integer} options to continue",
  TOOLBOX_VALIDATION_FIELD_CANNOT_BE_EMPTY: "Field can\u2019t be empty when selected",
  TOOLBOX_VALIDATION_WEIGHT_MINIMUM: "Weight needs to be at least {value}{unit}",
  TOOLBOX_VALIDATION_WEIGHT_MAXIMUM: "Weight needs to be at most {value}{unit}",
  TOOLBOX_VALIDATION_HEIGHT_MINIMUM: "Height needs to be at least {value}{unit}",
  TOOLBOX_VALIDATION_HEIGHT_MAXIMUM: "Height needs to be at most {value}{unit}",
  ENTER_YOUR_WEIGHT_IN_KILOGRAMS: "Enter your weight in kilograms",
  ENTER_YOUR_WEIGHT_IN_POUNDS: "Enter your weight in pounds",
  ENTER_YOUR_HEIGHT_IN_CENTIMETERS: "Enter your height in centimeters",
  ENTER_YOUR_HEIGHT_IN_FEET: "Enter your height in feet",
  ENTER_YOUR_HEIGHT_IN_INCHES: "Enter your height in inches",
  GOAL_REACHED: "You hit the goal!",
  COMPLETE_ACTIVITY: "Complete Activity",
  EXIT_ACTIVITY_TITLE: "Are you sure you want to leave this activity?",
  EXIT_ACTIVITY_BODY: "Your progress won\u2019t be saved and you will have to restart the activity from the beginning.",
  EXIT_ACTIVITY_CTA: "Leave Activity",
  ACTIVITY_NEXT_STEP: "Continue activity",
  ACTIVITY_PREV_STEP: "Return to the previous step",
  PAGE_TITLE_HEALTH_PROGRAM_CATEGORY: "Health Program Category",
  NEXT_STEP: "Next Step",
  YOU_EARNED: "You earned",
  YOU_EARNED_X_POINTS: "You earned {points} points!",
  CREATE: "Create {label}",
  TOMORROW: "Tomorrow",
  YESTERDAY: "Yesterday",
  BACK_TO_TODAY: "Back to today",
  PREVIOUS_DAY: "Previous day",
  NEXT_DAY: "Next day",
  ACTIVITY_STATUS: "Activity status: ",
  ACTIVITY_STATUS_EXPIRED: "Expired",
  ACTIVITY_STATUS_REMOVED: "Skipped",
  ACTIVITY_STATUS_UPCOMING: "Available Soon",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_OR_FUTURE_HEADING: "Nothing planned - yet!",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_DESCRIPTION: "Tap the \u2018Add\u2019 button to find new programs or browse curated list of activities below.",
  NO_ACTIVITIES_COMPLETED_TODAY_HEADING: "Well done, you\u2019re on a roll!",
  NO_ACTIVITIES_COMPLETED_TODAY_DESCRIPTION: "Come back tomorrow for more or browse through new programs and suggested activities.",
  NO_ACTIVITIES_FUTURE_DESCRIPTION: "You don\u2019t have any activities scheduled for this day.",
  NO_ACTIVITIES_PAST_HEADING: "Rest Day",
  NO_ACTIVITIES_PAST_DESCRIPTION: "Looks like you took this day to relax and recover.",
  BUTTON_BROWSE_PROGRAMS: "Browse Programs",
  IMG_ALT_HIGH_FIVE_HANDS: "Two hands slapping a high five",
  IMG_ALT_EMPTY_STATE_PROGRAMS: "Woman standing and scrolling a wall-sized list of programs",
  IMG_ALT_EMPTY_STATE_REST: "Man resting in a comfy chair with a warm mug and headphones",
  THIS_IS_JUST_A_SNEAK_PEAK: "This is just a sneak peek!",
  COME_BACK_COMPLETE_ACTIVITY_ON_DATE: "Come back and complete this activity on {date}.",
  COME_BACK_COMPLETE_ACTIVITY_LATER: "Come back later to complete this activity.",
  LOOKS_LIKE_YOU_MISSED_THIS_ONE: "Looks like you missed this one!",
  THIS_ACTIVITY_EXPIRED_ON_DATE: "This activity expired on {date}.",
  LOOKS_LIKE_THIS_WASNT_MEANT_FOR_YOU: "Looks like this one wasn\u2019t meant for you",
  YOU_SKIPPED_THIS_ACTIVITY: "You skipped this activity.",
  NO_PROGRAMS: "Nothing to see here just yet",
  NO_ACTIVITY_TITLE: "Nothing here (yet!)",
  NO_LEADERBOARD_ACTIVITY_DESCRIPTION: "We'll display your ranking here once the challenge starts.",
  NO_HIGHLIGHTS_ACTIVITY_DESCRIPTION: "Check back here to see challenge highlights soon.",
  LEADERBOARD_ALL_TIME_RANKING: "All Time Ranking",
  LEADERBOARD_CURRENT_USER_NAME: "{user} (You)",
  ACTIVITY_PROGRESS: "Activity Progress",
  YOUR_JOURNEY: "Your journey",
  SUGGESTED_FOR_YOU: "Suggested For You",
  NO_ACHIEVEMENTS_DESCRIPTION: "Complete activities in your Journey to start unlocking achievements.",
  UNLOCK_ACHIEVEMENTS: "Unlock an achievement for completing all activities in this program.",
  MEMBERS: "Members",
  SIGN_UP_PERIOD_PASSED_DETAIL: "You can't sign up for this challenge anymore because the sign-up period has passed.",
  REFERENCES: "References",
  SIGN_UP_BY: "Sign up by {date}",
  YOURE_GOOD_TO_GO: "You're good to go!",
  CHECK_CHALLENGE_DETAILS: "Check out the challenge details to familiarize yourself with the activities",
  CHALLENGE_LETS_START_TEAMS_ENABLED: "You're ready to start the challenge. Do you want to join or create a team?",
  CHALLENGE_ABOUT_TO_START: "Your challenge is about to start!",
  ACTIVITIES_APPEAR_HERE_WHEN_CHALLENGE_STARTS: "Daily activities will appear here when your challenge starts on <strong>{date}</strong>.",
  NO_CHALLENGE_ACTIVITIES_TODAY: "There are no challenge activities for you today.",
  COVERAGE_SEARCH_QUERY_NOT_FOUND: '"{query}" could not be found.',
  COVERAGE_SEARCH_TRY_AGAIN: "Try searching again using a different keyword.",
  EARN: "Earn",
  WORD_WITH_EXCLAMATION_POINT: "{word}!",
  UPDATED: "Updated",
  YOUR_PROGRESS: "Your progress",
  YOUR_PROGRESS_IN_NUMBERS: "{current} of {total} {unit} or {percentage} percent complete",
  OUTCOMES_FRICTION_SCREEN_TITLE: "Personalizing suggestions...",
  OUTCOMES_FRICTION_SCREEN_DESCRIPTION: "Give us a moment to find some helpful resources for you based on your answers",
  RELOAD_MY_SUGGESTIONS: "Reload my suggestions",
  YOUR_RANKING: "Your ranking",
  TOP_RANKED: "Top Ranked",
  VIEW_CHALLENGE_DETAILS: "View Challenge Details",
  LEAGUE_FAMILY_EDUCATION_BANNER_HEADER: "Wondering why it's beneficial to add your dependents?",
  LEAGUE_FAMILY_EDUCATION_BANNER_SUBHEADER: "Your dependents can access League and enjoy a healthier life too!",
  UNABLE_TO_LEAVE_CHALLENGE: "Unable to leave the challenge, please try again!",
  SUCCESSFULLY_LEFT_CHALLENGE: "You have successfully left the challenge.",
  UNABLE_TO_JOIN_CHALLENGE: "Unable to join the challenge, please try again!",
  JOIN_TEAM: "Join Team",
  X_TEAM_MEMBERS: "{memberTotal, plural, one {# team member} other {# team members}}",
  X_SPOTS_AVAILABLE: "{spotsAvailable, plural, one {# spot available} other {# spots available}}",
  HIGHLIGHTS: "Highlights",
  CURRENT_RANK: "Current Rank",
  X_LIKES: "{activityLikes, plural, one {# Like} other {# Likes}}",
  LIKE: "Like",
  LIKED: "Liked",
  TEAM_INVITE_HEADING: "We're better together!",
  TEAM_INVITE_DESCRIPTION: "Invite friends to join your team to complete activities together.",
  TEAM_INVITE_LINK_DESCRIPTION: "The more the merrier! Share this link with friends so they can join your team.",
  TEAM_INVITE_LINK: "Team invite link",
  INVITE: "Invite",
  LEAVE_TEAM: "Leave Team",
  INVITE_FRIENDS: "Invite Friends",
  PRIVACY: "Privacy Settings",
  JOIN_TEAM_SUCCESS_TITLE: "Welcome to the team!",
  JOIN_TEAM_SUCCESS_DETAIL: "Let\u2019s conquer these activities together.",
  JOIN_TEAM_SUCCESS_BUTTON: "Go to Team Details",
  CANT_JOIN_TEAM_TITLE: "Unable to join {teamName}",
  CANT_JOIN_TEAM_DETAIL: "Please try again! If you've already joined a team, you'll need to leave your current team before you can join {teamName}.",
  CANT_JOIN_TEAM_JOIN_CHALLENGE_DETAIL: "Looks like you haven't signed up for the challenge yet. You'll need to sign up before you can join {teamName}.",
  LEAVE_TEAM_QUESTION: "Leave {teamName}?",
  LEAVE_TEAM_DESCRIPTION: "Are you sure you want to leave {teamName}? Your score will no longer be considered as part of the team\u2019s average.",
  CHALLENGE_ACTIVITY_DETAIL: "Allow others to see your activity in this challenge.",
  SHOW_MY_ACTIVITY: "Show My Activity",
  YOUR_TEAM: "Your team",
  JOIN_OR_CREATE_TEAM: "Join or Create a Team",
  TEAMS: "Teams",
  CHALLENGE_TEAMS_DESCRIPTION: "Join an existing team or create your own to compete in the challenge together!",
  JOIN_A_TEAM: "Join a Team",
  JOIN_TEAM_DESCRIPTION: "Search for an existing team to join and compete together!",
  SEARCH_FOR_TEAM: "Search for a team",
  CREATE_A_TEAM: "Create a Team",
  CREATE_TEAM_DESCRIPTION: "Customize your team by setting your own avatar and team name. Invite others to join you!",
  UP_YOUR_GAME: "Level up your game",
  UP_YOUR_GAME_DESCRIPTION: "There's strength in numbers. Join a team or create your own.",
  XTH_PLACE: "{currentRank, selectordinal, one {#st} two {#nd} few {#rd} other {#th} } Place",
  LEADERBOARD_RANKING: "Ranking",
  LEADERBOARD_USERNAME: "Username",
  INVITE_LINK_COPIED_TO_CLIPBOARD: "Invite link copied to clipboard!",
  DATE_AND_TIME: "Date and Time",
  SELECT_TEAM_AVATAR: "Select Team Avatar",
  CHANGE_TEAM_AVATAR: "Change Team Avatar",
  TEAM_NAME_LABEL: "Team Name",
  CREATE_TEAM: "Create Team",
  TEAM_NAME_ERROR: "Please enter a name for your team.",
  SLIDE_OF_TOTAL: "Slide {key} of {total}",
  PAGE_OF_TOTAL: "Page {current} of {total}",
  NO_SOLUTIONS_AVAILABLE: "We're sorry, there are no solutions available at the moment.",
  SEE_ALL_ACHIEVEMENTS: "See all achievements",
  VIEW_ALL_ACHIEVEMENTS: "View All Achievements",
  TAKE_ME_BACK: "Take Me Back",
  TEAMS_SELECT_AVATAR_DESCRIPTION: "This avatar shows up on your team\u2019s profile and on the leaderboard.",
  CREATE_TEAM_SUCCESS: "Your team is ready!",
  CREATE_TEAM_SUCCESS_DESCRIPTION: "Start building your team. Share this link with others so you can complete activities together.",
  VIEW_TEAM_DETAILS: "View Team Details",
  FEATURES_HIGHLIGHT_CAROUSEL_LABEL: "Features highlight carousel",
  CHALLENGE_FAQ_HEADING: "Have questions about Challenges?",
  CHALLENGE_FAQ_CONTENT: "Check out our {helpCenterLink} for all your frequently asked questions.",
  VIEW_THIS_RESOURCE: "View This Resource",
  RECOMMENDED_NEXT_STEP: "Recommended Next Step",
  CARE_COLLECTIONS: "Care Collections",
  PLAN_PROGRESS: "Plan Progress",
  SINCE_LAST_WEEK: "since last week",
  INSIGHT_CARD_HEADER_DISTANCE: "Distance",
  INSIGHT_CARD_HEADER_STEPS: "Steps",
  MIN: "min",
  CAL: "Cal",
  KM: "km",
  INSIGHT_CARD_UNIT_STEPS: "{count, plural, one {step} other {steps}}",
  INSIGHT_CARD_HEADER_FLOORS_CLIMBED: "Flights Climbed",
  INSIGHT_CARD_UNIT_FLOORS_CLIMBED: "{count, plural, one {flight} other {flights}}",
  INSIGHT_CARD_HEADER_ACTIVE_DURATION: "Active Minutes",
  INSIGHT_CARD_HEADER_ENERGY_BURNED: "Energy Burned",
  INSIGHT_CARD_HEADER_WEIGHT: "Weight",
  INSIGHT_CARD_HEADER_HEIGHT: "Height",
  INSIGHT_CARD_HEADER_MINDFUL_DURATION: "Mindful Minutes",
  INSIGHT_CARD_HEADER_WAIST_CIRCUMFERENCE: "Waist Circumference",
  DAY_OF_THE_WEEK: "DAY OF THE WEEK",
  DAY_OF_THE_MONTH: "DAY OF THE MONTH",
  INSIGHT_CHART_WEEK_TITLE: "Weekly {type} bar chart",
  INSIGHT_CHART_MONTH_TITLE: "Monthly {type} bar chart",
  INSIGHT_CHART_DISTANCE_WEEK_DESCRIPTION: "The number of {unit} you've walked each day of the week.",
  INSIGHT_CHART_DISTANCE_MONTH_DESCRIPTION: "The number of {unit} you've walked each day of the month.",
  INSIGHT_CHART_DISTANCE_DATUM_LABEL: "You've walked {distance} {unit} on {date}",
  INSIGHT_CHART_STEPS_WEEK_DESCRIPTION: "The number of steps you've walked each day of the week.",
  INSIGHT_CHART_STEPS_MONTH_DESCRIPTION: "The number of steps you've walked each day of the month.",
  INSIGHT_CHART_STEPS_DATUM_LABEL: "You've walked {distance} {unit} on {date}",
  INSIGHT_CHART_ENERGY_BURNED_WEEK_DESCRIPTION: "The number of {unit} you've burned each day of the week.",
  INSIGHT_CHART_ENERGY_BURNED_MONTH_DESCRIPTION: "The number of {unit} you've burned each day of the month.",
  INSIGHT_CHART_ENERGY_BURNED_DATUM_LABEL: "You've burned {energy} {unit} on {date}",
  INSIGHT_CHART_ACTIVE_DURATION_WEEK_DESCRIPTION: "The number of active minutes for each day of the week.",
  INSIGHT_CHART_ACTIVE_DURATION_MONTH_DESCRIPTION: "The number of active minutes each day of the month.",
  INSIGHT_CHART_ACTIVE_DURATION_DATUM_LABEL: "You had {value} active minutes on {date}",
  INSIGHT_CHART_FLOORS_CLIMBED_WEEK_DESCRIPTION: "The number of flights you've climbed each day of the week.",
  INSIGHT_CHART_FLOORS_CLIMBED_MONTH_DESCRIPTION: "The number of flights you've climbed each day of the month.",
  INSIGHT_CHART_FLOORS_CLIMBED_DATUM_LABEL: "You've climbed {value} flights of stairs on {date}",
  INSIGHT_CHART_MINDFUL_DURATION_WEEK_DESCRIPTION: "The number of mindful minutes for each day of the week.",
  INSIGHT_CHART_MINDFUL_DURATION_MONTH_DESCRIPTION: "The number of mindful minutes each day of the month.",
  INSIGHT_CHART_MINDFUL_DURATION_DATUM_LABEL: "You had {value} mindful minutes on {date}",
  DATAPOINT_CATEGORY_ACTIVITY: "Activity",
  DATAPOINT_CATEGORY_BODY: "Body",
  MANAGE_UNITS_APPLYING_CHANGES: "Applying changes...",
  MANAGE_UNITS_CHANGES_SAVED: "Changes saved at {time}",
  START_TRACKING_HEALTH_HEADER: "Start tracking your health",
  START_TRACKING_HEALTH_BODY: "Easily track your metrics over time to see how far you've come and how you can work towards your health goals.",
  BROWSE_SUPPORTED_DATA: "What can I track?",
  LAST_UPDATED_CARRIER_DATE: "Last updated: {date} from {carrier}",
  ACCUMULATION_PERIOD: "Accumulation period: {start} - {end}",
  NO_DATA_AVAILABLE: "No data available",
  LAST_7_DAYS: "Last 7 Days",
  LAST_30_DAYS: "Last 30 Days",
  OLDER: "Older",
  GET_ASSISTANCE_NOW: "Chat with your care team",
  GET_ASSISTANCE_NOW_SUBHEADING: "Chat with our certified health professionals and customer care staff. They can help you save money by directing you to the most affordable, highest quality care in your area as well as answer any questions about your benefits.",
  HOW_CAN_WE_HELP: "How Can We Help?",
  LIVE_BALANCE_SPEND: "{spentAmount} of {totalAmount} spent",
  LIVE_BALANCE_REMAINING: "{amount} left",
  UPDATING_UNITS_OF_MEASURE: "Updating units of measure",
  CHANGING_YOUR_UNITS: "Changing your units will affect how they are displayed in the app.",
  MESSAGES: "Messages",
  MESSAGING_MESSAGES_LANDING_PAGE_TITLE: "Messages",
  SEND_NEW_MESSAGE: "Send new message",
  NEW_MESSAGE_DEFAULT: "This is the start of a new message",
  NETWORK_MISSING_COVERAGE: "Your plan doesn't have {network} coverage.",
  CARD_FRONT_FILENAME: "{benefitName}-front",
  CARD_BACK_FILENAME: "{benefitName}-back",
  START_A_VISIT: "Start a Visit",
  UNREAD: "Unread",
  NO_MESSAGES_HEADING: "No messages yet",
  NO_MESSAGES_DESCRIPTION: "Get started by sending a new message!",
  RETURN_TO: "Return to {location}",
  NO_RECOMENDATIONS: "Sorry, we don\u2019t have any recommendations for this health area right now.",
  CHALLENGES_LEGAL_DISCLAIMER: "This Challenge is intended to be a fun way for everyone to participate and get a fair chance at winning. At times, cash or other prizes may be offered by the Challenge organizer. League doesn't design the Challenge structure or decide whether to offer prizes. If you have concerns about the structure of this Challenge or believe you've been excluded from the chance to win, please talk to the Challenge organizer.",
  ALL_RECORDED_DATA: "All Recorded Data",
  NEW_MESSAGE: "New Message",
  MESSAGE_SUBJECT: "Message subject (optional)",
  THREAD_SUBJECT_MAX_LENGTH_ERROR: "You are over the maximum character limit ({maximum})",
  CHAR_LIMIT_EXCEEDED: "Character limit exceed ({maximum})",
  MESSAGE_SUBJECT_PLACEHOLDER: "Set the message topic",
  TO: "To",
  CREATE_MESSAGE: "Create Message",
  MEMBER_LABEL: "Member",
  RESULT_COUNT: "{count, plural, one {# result} other {# results}}",
  USER_COLON: "{user}:",
  JOINED_CHALLENGE_HIGHLIGHT: "Joined <strong>{challengeTitle}</strong>!",
  CREATED_TEAM_HIGHLIGHT: "Created <strong>{teamName}</strong>!",
  JOINED_TEAM_HIGHLIGHT: "Joined <strong>{teamName}</strong>!",
  STEPS_WALKED_HIGHLIGHT: "<strong>Walked {total} steps!</strong>",
  ACTIVE_MINUTES_HIGHLIGHT: "<strong>Moved {total} minutes!</strong>",
  MINDFUL_MINUTES_HIGHLIGHT: "<strong>Completed {total} minutes!</strong>",
  EARNED_ACHIEVEMENT_HIGHLIGHT: "<strong>Earned {achievement} Achievement!</strong>",
  COMPLETED_ACTIVITY_HIGHLIGHT: "<strong>Completed an activity!</strong>",
  NO_CARE_COLLECTIONS: "Sorry, there are no care collections available.",
  WRITE_A_MESSAGE: "Write a message...",
  UPLOAD_MULTIPLE_FILES: "Upload multiple files",
  SEND: "Send",
  SEND_MESSAGE: "Send message",
  DATA_SOURCES: "Data Sources",
  SOURCES_CAN_UPDATE: "The following sources are allowed to update your",
  WHEN_MULTIPLE_SOURCES_AVAILABLE: "When multiple sources are available, the data source with the largest value will be recorded at the end of the day (11:59pm).",
  APPLE_HEALTH: "Apple Health",
  GOOGLE_FIT: "Google Fit",
  FITBIT: "Fitbit",
  GARMIN: "Garmin",
  POLAR: "Polar",
  WITHINGS: "Withings",
  HEALTH_PLAN: "Health Plan",
  OMRON: "Omron",
  STRAVA: "Strava",
  IHEALTH: "iHealth",
  UPDATE_UNITS_OF_MEASURE_MODAL_TITLE: "Updating units of measurement",
  UPDATE_UNITS_OF_MEASURE_MODAL_DESCRIPTION: "Changing your units will affect how they are displayed in the app",
  DOCUMENTS: "Documents",
  DOCUMENTS_DOCUMENTS_LANDING_PAGE_TITLE: "Documents",
  SHOW_RESULTS: "Show Results",
  AVERAGE: "Average",
  VIEW_ALL_METRIC_DATA: "View all {metric} data",
  EDIT_METRIC_DATA: "Edit {metric} data",
  NEXT_WEEK: "Next week",
  PREVIOUS_WEEK: "Previous week",
  NEXT_30_DAYS: "Next 30 Days",
  PREVIOUS_30_DAYS: "Previous 30 Days",
  UNABLE_TO_CREATE_TEAM: "Unable to create a new team - please try again! If you've already joined a team, you'll need to leave your current team before creating a new one.",
  START_TRACKING_METRIC: "Start tracking {metric}",
  CURRENTLY_NOT_SHARING_DATA: "You\u2019re currently not sharing any data for {metric}",
  SUCCESSFULLY_LEFT_TEAM: "You have successfully left {teamName}",
  LEAVE_TEAM_FAILURE: "Something went wrong, please try again!",
  VIEW_DATA_SOURCES: "View data sources",
  OR_CALL_PHONE: "or call {phoneNumber}{extension}",
  DOCUMENTS_NO_FILTERED_RESULTS_EMPTY_STATE_HEADING: "No documents matching your filters",
  DOCUMENTS_NO_FILTERED_RESULTS_EMPTY_STATE_DESCRIPTION: "Try removing some of your filters to get more results",
  DOCUMENTS_EMPTY_STATE_HEADING: "No documents here (yet!)",
  DOCUMENTS_EMPTY_STATE_DESCRIPTION: "One place to view and organize all your documents",
  LEADERBOARD_CURRENT_TEAM_NAME: "{team} (Your team)",
  YOUR_CARE_ADVISOR: "Your Care Guide",
  COMPOSE: "Compose",
  COMPOSE_NEW_MESSAGE: "Compose a new message",
  POLICY_INFORMATION_UNAVAILABLE: "There is no information available for this policy period.",
  POLICY_INFORMATION_UNAVAILABLE_DEPENDENTS: "There's no information for this member. Please try another member.",
  MESSAGE_THREADS_LIST_SUBTITLE: "It may take up to 2 business days for our team to respond. If this is a medical emergency, call 911.",
  ALL_MESSAGES_FOR_THREAD_BANNER: "Please do not send us specific information about your health conditions through this chat.",
  TROUBLE_DISPLAYING_DATA: "We're having trouble displaying your data",
  RETRY: "Retry",
  YOU: "You",
  MESSAGES_IN_CONVERSATION_TITLED: "Messages in conversation titled {subject}",
  TEAM_AVERAGE: "Team Average",
  YOUR_METRICS: "My Metrics",
  YOUR_METRICS_SUBTITLE: "The most recent health data from your connected apps and devices.",
  APPS_AND_DEVICES: "Apps & Devices",
  APP_AND_DEVICE_METRICS: "App & Device Metrics",
  VIEW_ALL_METRICS: "View apps & devices metrics",
  RENAME: "Rename",
  ENTER_DOCUMENT_NAME: "Please enter a document name",
  LOW_PRIORITY_ACTIVITY_ALT_TEXT: "This is a low priority activity",
  MEDIUM_PRIORITY_ACTIVITY_ALT_TEXT: "This is a medium priority activity",
  HIGH_PRIORITY_ACTIVITY_ALT_TEXT: "This is a high priority activity",
  ACTIVITY_EXPIRY_DATE: "Expires {date}",
  GENERIC_MESSAGING_ERROR: "Looks like there was a problem, please refresh the page and try again.",
  VIEW_THE_ACTIVITIES: "View the Activities",
  DRAG_FILES_HERE_OR: "Drag files here or",
  ADD_A_DOCUMENT: "Add a document",
  ADD_DOCUMENT: "Add document",
  REMOVE_FILE: "Remove file",
  REMOVE_FILE_FILENAME: "Remove file: {filename} ({fileSize})",
  UNABLE_TO_SEND: "Unable to send, please try again",
  ERROR_HEADING: "Something went wrong on our end.",
  FILE_TYPE_NOT_SUPPORTED: "File type not supported",
  USE_FILE_IN_ONE_OF_THESE_FORMATS: "Use a file in one of these formats: {fileTypes}",
  RECENT_MESSAGES: "Recent messages",
  NO_MESSAGES_YET: "You have no messages (yet!)",
  NO_MESSAGES_DETAIL: "Your assigned Care Guide will assist you in making smarter health care decisions, every step of the way.",
  START_A_NEW_MESSAGE: "Start a new message",
  USER_ADDED_DOCUMENT: "{user} added a document",
  ERROR_SAVING_TRY_AGAIN: "Error saving changes. Please try again",
  MODIFIED_ON_DATE: "Modified on {date}",
  FILE_TYPE_TOO_LARGE: "File size is too large",
  MAXIMUM_FILE_SIZE_IS: "Maximum file size is {fileSize}.",
  FILE_TOO_LARGE: "Oops. That file is too large.",
  FILE_SHOULD_BE_UNDER: "Your file must be under {fileSize}",
  ATTACHMENT_LIMIT_REACHED: "Oops. That\u2019s too many files.",
  MAXIMUM_NUM_OF_ATTACHMENTS_ALLOWED: "You can attach up to {maxNumberOfDocs, plural, one {# file} other {# files}}.",
  OOPS_FILE_TYPE_ISNT_SUPPORTED: "Oops. That file type isn\u2019t supported.",
  ATTACHMENT_TYPES_ALLOWED: "You can attach your file in these formats: {fileTypes}",
  MESSAGES_PAGINATION_ERROR: "Unable to load messages. <button>Try again.</button>",
  TRANSACTION_TABLE_CAPTION: "Transaction History",
  SELECT_PARTICIPANT_ERROR: "Select someone to send a message to",
  PREVIEW_OF_FILE: "Preview of {fileName}",
  VIEW_DOCUMENT_ACTIONS: "View {documentName} actions.",
  VISIT_LINK: "Visit Link",
  COMPLETE_BY_DATE: "Complete by {date}",
  ERROR_UPLOADING_YOUR_FILE: "Error uploading your file. Try again.",
  DOCUMENT_SUBMITTED: "Document submitted",
  YOUR_DOCUMENT_WILL_BE_AVAILABLE_SOON: "Your document will be available soon. Please wait a few moments and refresh the page.",
  ERROR_RENAMING_YOUR_DOCUMENT: "Error renaming your document. Try again.",
  DOCUMENT_RENAMED_SUCCESSFULLY: "Document renamed successfully.",
  ERROR_HEADING_GENERIC: "Something went wrong",
  ERROR_HEADING_NO_CONNECTION: "No internet connection",
  ERROR_CAPTION_BACKEND: "There was a problem connecting to our server.\n Please try again later.",
  ERROR_CAPTION_NO_CONNECTION: "There was a problem loading data.\n Check your internet and try again.",
  SURE_YOU_WANT_TO_DELETE: "Are you sure you want to delete {name}",
  CANNOT_BE_UNDONE: "This action cannot be undone",
  DELETE_DOCUMENT: "Delete document",
  DOCUMENT_DELETED: "Document deleted",
  ERROR_DELETING_YOUR_DOCUMENT: "Error deleting your document",
  ABOUT_ME: "About Me",
  SEE_MORE: "SEE MORE",
  UNABLE_TO_LOAD_PAGE_TRY_AGAIN: "We're unable to load this page. Check your internet and try again.",
  WHO_IS_THIS_DOCUMENT_ABOUT: "Who is this document about?",
  SELECT_A_USER: "Select a user",
  SELECT_DOCUMENT: "Select document",
  THIS_HELPS_IDENTIFY_PERSON_DOCUMENT_RELATES_TO: "This helps your Care Guide identify the person this document relates to.",
  VIEW_ALL_MESSAGE_THREADS: "View all message threads",
  TOGGLE_MENU: "Toggle message list",
  METRICS: "Metrics",
  UNREAD_MESSAGES: "Unread Messages",
  WITH_DOCUMENT: "with document",
  X_TOKENS: "{tokenCount, plural, one {# token} other {# tokens}}",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_EYEBROW: "Programs & Challenges",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_HEADING: "Ready for something new?",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_DESCRIPTION: "Find Health Programs and Challenges that match your personal goals.",
  EXPLORE_LIBRARY: "Explore Library",
  YOUVE_GOT_THIS: "You've got this!",
  YOUVE_GOT_THIS_NAME: "You've got this, {firstName}!",
  CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE: "Welcome to your health journey!",
  HEALTH_JOURNEY_PAGE: "Health Journey Page",
  VIEW_DETAILS: "View Details",
  NEXT_ACTIVITY: "Next Activity",
  X_OF_Y_ACTIVITIES: "{completed} of {total} activities",
  X_PERCENTAGE: "{percent}%",
  SOLUTIONS: "Solutions",
  EXPLORE: "Explore",
  DOCUMENT_NAME_TOO_LONG: "You are over the maximum character limit ({maximum})",
  CLAIM_PATIENT_NAME: "For: {patientName}",
  STANDALONE_ACTIVITIES_DESCRIPTION: "No Programs. No Challenges. Just one-off activities.",
  FEEDBACK_LINK_LABEL: "Rate information {value} out of {maximum} in helpfulness",
  RECENT_ACHIEVEMENTS: "Recent Achievements",
  ACHIEVEMENTS_BANNER_HEADER: "Congrats on earning these badges!",
  SINGLE_ACHIEVEMENT_DESCRIPTION: "We love to see you prioritizing your health and well-being! Check out other achievements you're working towards.",
  MULTIPLE_ACHIEVEMENT_DESCRIPTION: "We love to see you prioritizing your health and well-being! Check out other achievements you've earned and those you're working towards.",
  ACHIEVEMENTS_EMPTY_STATE_HEADER: "No achievements (yet!)",
  ACHIEVEMENTS_EMPTY_STATE_DESCRIPTION: "Complete activities in your Journey to start earning achievements.",
  HISTORY_EMPTY_STATE_HEADER: "Nothing here - yet!",
  HISTORY_EMPTY_STATE_DESCRIPTION: "When you complete an activity, program, or challenge it will appear here.",
  INDIVIDUAL_BALANCE: "{membersFullName}'s {balance}",
  FAMILY_BALANCE: "Family {balance}",
  UPCOMING: "Upcoming",
  REMOVED: "Removed",
  COMPLETED_TODAY: "Completed",
  CLAIMS_BENEFIT_CARD_TITLE: "Insurance Claims",
  CLAIMS_BENEFIT_CARD_SUBTITLE: "Keep track of what you owe for your care and how much insurance will cover",
  CLAIMS_FILTER_PROPERTY_TYPE: "Service Type",
  CLAIMS_FILTER_PROPERTY_STATUS: "Claim Status",
  CLAIMS_FILTER_PROPERTY_PATIENTNAME: "Member",
  CLAIMS_FILTER_VALUE_ORAL: "Dental",
  CLAIMS_FILTER_VALUE_INSTITUTIONAL: "Medical",
  CLAIMS_FILTER_VALUE_VISION: "Vision",
  CLAIMS_FILTER_VALUE_PHARMACY: "Pharmacy",
  CLAIMS_FILTER_VALUE_PROFESSIONAL: "Professional",
  CLAIMS_FILTER_VALUE_APPROVED: "We'll Pay Our Part",
  CLAIMS_FILTER_VALUE_PENDING: "Processing",
  CLAIMS_FILTER_VALUE_PARTIALLY_PAID: "Partially Covered",
  CLAIMS_FILTER_VALUE_NOT_COVERED: "Not Covered",
  CLAIMS_FILTER_VALUE_ADJUSTED: "Adjusted",
  DRINKS_PER_WEEK: "Drinks per week",
  OR_SELECT_BETWEEN_THESE: "or select between these",
  CLAIMS_FILTER_PROPERTY_SERVICEDATE: "Date Range",
  CLAIMS_FILTER_VALUE_YEAR_TO_DATE: "Year to Date",
  CLAIMS_FILTER_VALUE_PRIOR_YEAR: "Prior Year",
  CLAIMS_FILTER_VALUE_LAST_12_MONTHS: "Last 12 Months",
  CLAIMS_FILTER_VALUE_LAST_2_YEARS: "Last 2 Years",
  CHALLENGE_TYPE_GROUP_TAG: "Group",
  CHALLENGE_TYPE_SOLO_TAG: "Solo",
  VIEW_ALL_GROUP_CHALLENGES_HEADING: "Group Challenges",
  VIEW_ALL_SOLO_CHALLENGES_HEADING: "Solo Challenges",
  VIEW_ALL_CHALLENGES_DESCRIPTION_GROUP: "Stay accountable as you challenge yourself with mindfulness work, healthy eating initiatives, fitness competitions, stress reduction activities, step challenges, and more.",
  VIEW_ALL_CHALLENGES_DESCRIPTION_SOLO: "Go solo and challenge yourself to complete groups of activities focused on physical fitness, nutrition, mental health, stress management, and more.",
  HELPFUL_LINKS: "Helpful Links",
  HOW_CLAIMS_WORK: "How Claims Work",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TITLE: "Understanding how your claims work",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TEXT: "<p>When you visit one of the doctors in your network, they request payment. If you have a copay, they collect it from you and then they submit a claim to the insurance company.</p><p>We then review your insurance plan, also known as your benefit contract, to determine if the service is covered. If it is, we will approve it based on the terms of the benefit contract. If it is not covered as part of your benefit plan, you are responsible for paying for the service.</p>",
  CLAIMS_STATUS_DEFINITIONS: "Claim Status Definitions",
  CLAIMS_STATUS_DEFINITION_APPROVED: "We'll pay our part means the claim is approved and we agree to pay some or all of the claim based on your plan.",
  CLAIMS_STATUS_DEFINITION_PENDING: "Processing means we're figuring out who owes what.",
  CLAIMS_STATUS_DEFINITION_PARTIALLY_PAID: "Partially covered means we will cover a portion of your claim.",
  CLAIMS_STATUS_DEFINITION_NOT_COVERED: "Not covered means that the service is not covered in your benefit plan and you will have to pay for it.",
  CLAIMS_STATUS_DEFINITION_ADJUSTED: "Adjusted means something changed here, so we had to take another look at this claim.",
  YOUR_COST: "Your Cost:",
  CLAIMS_SERVICE_TYPE: "{type, select, institutional {Medical Claim} oral {Dental Claim} vision {Vision Claim} pharmacy {Pharmacy Claim} professional {Professional Claim} other {Claim}}",
  FILTER_BY: "Filter By",
  CLAIMS_LIST_EMPTY_HEADING: "Nothing here, yet!",
  CLAIMS_LIST_EMPTY_MESSAGE: "Claims that are submitted will show up here.",
  CLAIMS_GENERIC_ERROR_HEADING: "Something went wrong",
  CLAIMS_GENERIC_ERROR_MESSAGE: "There was a technical problem on our end.{br}Please try again in a few minutes.",
  CLAIMS_SUMMARY_PAGE_SUB_HEADING: "View what your insurance has covered, and what you may still owe your provider. You can access your claims submitted within two years to today's date.",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING: "No results",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE: "No claims match the {filterCount, plural, one {filter} other {filters}} you\u2019ve chosen",
  VIEW_MY_PROFILE: "View My Profile",
  PLAN_PROGRESS_COST_COVERAGE: "Plan progress and costs",
  PLAN_PROGRESS_POP_UP_LABEL: "What is a {title}?",
  RECENT_CLAIMS_LIST_EMPTY: "Claims submitted within the past 90 days will show up here. You can access all claims by selecting \u2018View all\u2019. ",
  DOWNLOAD_CLAIMS: "Download Claims",
  PLAIN_SOMETHING_WENT_WRONG: "Something went wrong",
  CLAIMS_SUMMARY_DOWNLOAD_ERROR: "There was a problem downloading your claims.",
  WALLET_WITH_CLAIMS_LANDING_TITLE: "Your benefits, claims, and wellness info, all in one place.",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_HEADING: "Ready to Get Started?",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_BODY: "Browse our library to find Health Programs and Challenges that match your personal goals.",
  USER_DROPDOWN_BTN_LABEL: "Profile Menu",
  PROVIDER_SERVICE_POPOVER_BUTTON_NAME: "What is a copay and coinsurance?",
  ANSWERS_NOT_SAVED: "We're not able to save your answers right now. Please try again later",
  SESSION_ABOUT_TO_TIMEOUT: "You\u2019ve been inactive for a while and your session is about to time out. Do you want to continue your session?",
  SESSION_TIMEOUT: "Session Timeout",
  CONTINUE_SESSION: "Continue Session",
  SESSION_LOG_OUT: "Log Out",
  ORDER_NEW_CARD_ADDRESS_SELECT_HEADING: "Select a delivery address",
  ORDER_NEW_CARD_MEMBER_SELECT_HEADING: "Who needs a new card?",
  ORDER_NEW_CARD_MEMBER_SELECT_HELP_TEXT: "Select one or more members.",
  DEFAULT_ADDRESS: "Default Address",
  CHOOSE_NEW_ADDRESS: "Choose a new address",
  CHOOSE_NEW_ADDRESS_HINT: "Provide a different mailing address for card delivery. This will not change your account's default address.",
  CARD_ACTIONS: "Card actions",
  EARN_ACHIEVEMENT_COMPLETING_ACTIVITIES_CHALLENGE: "Earn an achievement for completing all activities in this challenge",
  CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER: "Nothing here - yet!",
  CHALLENGE_ACTIVITY_UP_NEXT: "Up Next",
  CHALLENGE_ACTIVITY_UP_NEXT_EMPTY_STATE: "Come back when the challenge starts!",
  CHALLENGE_ACTIVITY_COMPLETED: "Completed",
  CHALLENGE_ACTIVITY_COMPLETED_EMPTY_STATE: "Activities you complete will show up here.",
  CHALLENGE_ACTIVITY_MISSED: "Missed",
  CHALLENGE_ACTIVITY_MISSED_EMPTY_STATE: "Activities you miss will show up here.",
  CHALLENGE_COMPLETED_TITLE: "That's a wrap!",
  CHALLENGE_COMPLETED_BODY: "There are no more activities to complete. Nicely done!",
  ACHIEVEMENT_EARNED: "Achievement earned celebration",
  ACHIEVEMENT_PROGRESS: "Achievement progress",
  ADD_DATA: "Add Data",
  CONFIRM_DETAILS: "Confirm your details",
  MEDICAL_ID_CARD: "Medical ID card",
  NEW_ADDRESS: "New delivery address",
  MESSAGE_CENTER: "Message Center",
  MESSAGING_MESSAGING_QUESTIONNAIRE_PAGE_TITLE: "Messaging",
  CHOOSE_NEW_ADDRESS_DESC: "Provide a different mailing address for card delivery. This will not change your account's default address. Mailing address must be within the United States.",
  SELECT_STATE: "Select a state",
  REQUIRED_FIELD: "{field} is a required field",
  CLAIMS_YOUR_COST: "Your cost",
  CLAIMS_PROCESSING_DESCRIPTION: "We\u2019re still processing this claim. You\u2019ll be notified when its ready for you to review.",
  DOWNLOAD_BENEFITS_EXPLANATION: "Download Explanation of Benefits",
  DATA_COLLECTED: "Data collected {date}",
  MEMBER_CARD_ON_ITS_WAY: "Your new member ID card is on its way.",
  MEMBER_CARD_ARRIVAL: "The new member ID card(s) will arrive in approximately 10 business days.",
  TRY_LATER: "Please try again later.",
  RESUBMIT: "Resubmit",
  ORDER_NEW_CARD_HEADING: "Order a new card",
  CANCEL_ORDER_NEW_CARD_TITLE: "Are you sure you want to cancel your order?",
  CANCEL_ORDER_NEW_CARD_DESC: "You can always come back later.",
  CANCEL_ORDER: "Cancel order",
  STEP: "Step",
  ORDER_CARD: "Order card",
  PLEASE_MAKE_A_SELECTION: "Please make a selection",
  TOTAL_COST_OVERVIEW: "Total Cost Overview",
  TOTAL_COST_DESCRIPTION: "The sum of costs from your claim\u2019s services.",
  SUPPORT: "Support",
  GET_SUPPORT: "Get Support",
  MESSAGE_WITH_A_MEMBER: "Contact a member advocate for questions about your claim.",
  CLAIMS_SERVICE_DETAILS_HEADING: "Service Details",
  CLAIMS_ADDITIONAL_RESOURCES_HEADING: "Additional Resources",
  CLAIMS_SERVICE_DETAILS_SUBHEADING: "A breakdown of the individual services you received and the costs associated with them.",
  CLAIMS_SERVICE_DETAILS_SERVICE: "Service",
  CLAIMS_SERVICE_DETAILS_PHARMACY_SERVICE: "Name of Rx",
  CLAIMS_SERVICE_DETAILS_DATE: "Date of Service",
  CLAIMS_SERVICE_DETAILS_SERVICE_PROCEDURE_CODE: "Procedure Code",
  CLAIMS_SERVICE_DETAILS_SERVICE_RX_NUMBER: "Rx Number",
  CLAIMS_SERVICE_DETAILS_SERVICE_YOUR_COST: "Your Cost",
  CLAIMS_SERVICE_DETAILS_SERVICE_COST_DETAILS: "Cost Details",
  CLAIMS_SERVICE_DETAILS_SHOW_COST_DETAILS: "Show Cost Details",
  CLAIMS_SERVICE_DETAILS_HIDE_COST_DETAILS: "Hide Cost Details",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_HEADING: "Breakdown of your cost",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_SUBHEADING: "The amounts below go towards your plan progress",
  WALLET_ORDER_NEW_CARD_SELECT_MEMBER_ERROR: "Select one or more members to continue",
  WALLET_INVALID_CHARACTER_ERROR_MESSAGE: "Field contains invalid characters",
  CLAIMS_COST_DETAILS_PROVIDER_CHARGED: "Provider Charged",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE: "Other Insurance Paid",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT: "Your Member Discount",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP: "Your plan negotiated with your provider to give you a discounted rate.",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP_LABEL: "Your member discount explanation",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP: "The amount your other insurance pays.",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP_LABEL: "Other insurance paid explanation",
  CLAIMS_COST_DETAILS_WE_PAID_ON: "{paymentDate, select, other {Your Plan Paid on {paymentDate}} undefined {Your Plan Paid}}",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP: "The amount your plan covered for health care services.",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP_LABEL: "Your plan paid explanation",
  CLAIMS_COST_DETAILS_YOUR_COST: "Your Cost",
  CLAIMS_SERVICE_DETAILS_SERVICE_REMARK: "Service Remark",
  CLAIMS_SERVICE_NETWORK_IN_NETWORK: "In-Network",
  CLAIMS_SERVICE_NETWORK_OUT_OF_NETWORK: "Out-Of-Network",
  WALLET_ORDER_NEW_CARD_SELECT_ADDRESS_OPTION_ERROR: "Select an address option to continue",
  WALLET_ORDER_NEW_CARD_NO_CITY_NUMBERS_ERROR: "City can not contain numbers",
  MESSAGE_CLOSED_TEXT: "This message has been delivered.",
  CLAIMS_PLAN_PROGRESS_DESCRIPTION: "Get an overview of your accumulated costs, cost-share, and more.",
  VIEW_PLAN_PROGRESS: "View Plan Progress",
  CLAIMS_BILL_PROVIDER_DESCRIPTION: "You\u2019ll receive a bill associated with this claim from your provider.",
  CLAIMS_EXPLANATION_OF_BENEFITS_DOWNLOAD_ERROR: "There was a problem downloading your explanation of benefits.",
  END_CHAT_MODAL_DESCRIPTION: "Continuing will end the chat. You will not be able to return to this conversation in the future.",
  RETURN_TO_CHAT: "Return to Chat",
  CHATS_IN_CONVERSATION: "Chats in conversation",
  LIVE_CHAT_CHARACTER_LIMIT: "Character limit reached ({characterLimit})",
  CHAT_MESSAGE_INPUT: "Chat message input",
  CLAIMS_SERVICE_LINE_ITEM_LABEL: "{code, select, deductible {Deductible} non_covered {Non Covered} copayment {Copayment} coinsurance {Coinsurance} may_be_billed {You May Be Billed} amount_exceeding_maximum {Amount Exceeding Maximum} additional_member_liability {Additional Member Liability} special_processing {Special Processing} paid_to_member {Paid To Member} plan_paid_to_you {Plan Paid To You} other {Other}}",
  QUESTIONNAIRE_FLOW_NEW_MESSAGE: "New Message",
  QUESTIONNAIRE_FLOW_CLOSE: "Close",
  QUESTIONNAIRE_FLOW_GO_BACK: "Go Back",
  QUESTIONNAIRE_FLOW_CONTINUE: "Continue",
  QUESTIONNAIRE_FLOW_RETRY: "Retry",
  CLEAR_ALL: "Clear All",
  HEALTH_REPORT_PAGE_HEADING: "Your Health Report",
  USERNAME_HAS_JOINED_THE_CHAT: "{username} has joined the chat",
  USERNAME_HAS_LEFT_THE_CHAT: "{username} has left the chat",
  PERVIOUS_MONTH: "Previous month button",
  NEXT_MONTH: "Next month button",
  CHAT_CLOSED: "This chat has been closed.",
  CONNECTING_YOU_WITH_AN_AGENT: "Connecting you with an agent...",
  LAST_DAY_TO_USE_BALANCE: "Last day to use balance",
  LAST_DAY_TO_SUBMIT_CLAIMS: "Last day to submit claims",
  LIVE_CHAT_GENERIC_ERROR_TITLE: "Something went wrong",
  LIVE_CHAT_GENERIC_ERROR_DESCRIPTION: "There was an issue, please try again",
  LIVE_CHAT_GENERIC_TOAST_ERROR_TITLE: "Something went wrong",
  LIVE_CHAT_GENERIC_TOAST_ERROR_DESCRIPTION: "There was an issue, please try again",
  LIVE_CHAT_GENERIC_ERROR_BUTTON: "Close",
  LIVE_CHAT_LANDING_PAGE_TITLE: "Chat",
  LIVE_CHAT_DELIVERY_FAILURE: "Not delivered",
  LIVE_CHAT_RESEND_MESSAGE: "Resend message",
  LIVE_CHAT_MESSAGE_FAILED_TITLE: "Message failed to send",
  LIVE_CHAT_MESSAGE_FAILED_BODY: "Sorry about that, it looks like your message didn\u2019t make it to our team.",
  VIEW_TOOLTIP: "view {tooltipLabel} tooltip",
  NO_DATA_SOURCES: "No Data Sources",
  MAX_VALUE_ERROR_MESSAGE: "Please enter a value lower than {max}",
  MIN_VALUE_ERROR_MESSAGE: "Please enter a value higher than {min}",
  NO_VALUE_SELECTED_ERROR_MESSAGE: "Please Select a value",
  START_DATE_MUST_BE_EARLIER_ERROR_MESSAGE: "The start date must be earlier than the end date",
  DURATION_EXCEEDS_24_HOURS_ERROR_MESSAGE: "The duration cannot exceed 24 hours",
  NO_FUTURE_DATES: "Date can't be in the future",
  CLAIMS_REMOVE_FILTER: "Remove {label} filter.",
  REMOVE_X_FILTER: "Remove {label} filter.",
  WALLET_BENEFIT_STATUS_PENDING: "Pending",
  WALLET_BENEFIT_STATUS_ACTIVE: "Active",
  WALLET_BENEFIT_STATUS_PAST: "Past",
  WALLET_LANDING_BENEFITS_EMPTY_STATE_TITLE: "Nothing here, yet!",
  WALLET_LANDING_BENEFITS_EMPTY_STATE_DESCRIPTION: "Benefits that are active will show up here.",
  BENEFITS_BENEFITS_LANDING_PAGE_TITLE: "Benefits",
  CLAIMS_CLAIMS_SUMMARY_PAGE_TITLE: "Claims",
  CLAIMS_CLAIMS_DETAIL_PAGE_TITLE: "Claim Details",
  CLAIMS_CLAIMS_DETAIL_WITH_TITLE_PAGE_TITLE: "Claim Details - {title}",
  SHOW: "Show",
  NUMBER_OF_ENTRIES: "{ number } entries",
  WAIST_CIRCUMFERENCE: "Waist Circumference",
  BMI: "BMI",
  BLOOD_PRESSURE: "Blood Pressure",
  TOTAL_CHOLESTEROL: "Total Cholesterol",
  TRIGLYCERIDES: "Triglycerides",
  CHOLESTEROL_HDL: "Cholesterol HDL",
  CHOLESTEROL_LDL: "Cholesterol LDL",
  FASTING_BLOOD_GLUCOSE: "Fasting Blood Glucose",
  NON_FASTING_BLOOD_GLUCOSE: "Non Fasting Blood Glucose"
};

// src/fr-CA.json
var fr_CA_default = {
  COMPLETED_ACTIVITIES: "Activit\xE9s termin\xE9es",
  AVAILABLE: "Disponible",
  SEE_MORE_ACTIVITIES: "Voir plus",
  SEE_MORE_COMPLETED_ACTIVITIES_ARIA_LABEL: "Voir plus d\u2019activit\xE9s termin\xE9es",
  COMPLETED_ACTIVITIES_EMPTY_STATE: "Lorsque vous r\xE9alisez des activit\xE9s, elles apparaissent ici !",
  MISSED_ACTIVITIES: "Activit\xE9s manqu\xE9es",
  SEE_MORE_MISSED_ACTIVITIES_ARIA_LABEL: "Voir plus d\u2019activit\xE9s manqu\xE9es",
  MISSED_ACTIVITIES_EMPTY_STATE: "Si vous manquez des activit\xE9s, elles appara\xEEtront ici !",
  DISPLAYING_ACTIVITIES_FROM_DATE: "Affichage des activit\xE9s depuis {date}",
  STANDALONE_ACTIVITIES: "Activit\xE9s autonomes",
  STANDALONE_ACTIVITIES_EMPTY_STATE: "Il n'y a rien \xE0 faire ici pour l'instant ! Revenez plus tard.",
  VIEW_ALL_STANDALONE_ACTIVITIES: "Voir toutes les activit\xE9s autonomes",
  MODULE_TEMPLATE_BUTTON: "Bouton de mod\xE8le de module",
  ACHIEVEMENTS: "R\xE9alisations",
  VIEW_ACHIEVEMENTS: "Voir les r\xE9alisations",
  DEPENDENT_NOTIFICATION_MESSAGE: "De nouvelles personnes \xE0 charge pourraient \xEAtre invit\xE9es",
  DEPENDENT_COVERED_BY_HSA_ONLY: "Remarque : Cette personne \xE0 charge sera uniquement couverte par votre compte soins de sant\xE9.",
  WALLET_LANDING_NAV_LABEL: "Navigation dans le portefeuille",
  VIEW_CARD_FOR_DEPENDENT: "Voir la carte pour {dependentName}",
  LEARN_MORE_LEAGUE_FAMILY: "\xE0 propos de League Famille pour vos personnes \xE0 charge",
  GO_TO_LIFEMARKET: "Rendez-vous sur le March\xE9vie pour voir la commande num\xE9ro {invoiceId}",
  GO_TO_CLAIM: "Voir les d\xE9tails de la demande pour {title}",
  GO_TO_RECEIPT: "Voir les re\xE7us pour {title}",
  LINK_TO_TRANSACTION_DETAILS: "Lien vers les d\xE9tails",
  VIEW_CLAIM_LABEL_HIDDEN: "Afficher la demande {vendor} {referenceId}",
  QLE_LINK_LABEL: "En apprendre plus sur les \xE9v\xE9nements de vie admissibles",
  PLEASE_CALL: "Veuillez appeler {phoneNumber}",
  BROWSE_FILES: "Parcourir les fichiers",
  TOTAL_BALANCE: "Solde total",
  LIFEMARKET: "March\xE9vie",
  ABOUT: "\xC0 propos",
  LEAGUE_CREDIT_DESCRIPTION_1: "Vous pouvez d\xE9penser votre Cr\xE9dit League dans le {lifemarketLink} pour payer une vari\xE9t\xE9 de produits et de services bien-\xEAtre. Vous ne pouvez pas d\xE9penser votre Cr\xE9dit League sur les produits indiqu\xE9s comme \xAB Offre partenaire League \xBB.",
  LEAGUE_CREDIT_DESCRIPTION_2: "Pour utiliser votre Cr\xE9dit League, s\xE9lectionnez  \xAB Cr\xE9dit League \xBB dans la liste des options de paiement lorsque vous \xEAtes pr\xEAt \xE0 payer sur March\xE9vie.\n{learnMoreLink}",
  DID_YOU_GET_A_PROMO_CODE: "Avez-vous un Code de promotion?",
  DID_YOU_GET_A_PROMO_CODE_DESCRIPTION: "Si vous avez re\xE7u du cr\xE9dit ou un code de promotion, vous pouvez le renseigner ici pour recevoir vos cr\xE9dits. Ils seront automatiquement ajout\xE9s \xE0 votre compte.",
  GET_CARE: "Soutien et soins",
  DISCLAIMER: "Avis de non-responsabilit\xE9",
  JOINED: "Rejoint",
  ROLLED_OVER: "Report\xE9",
  NEED_MORE_INFO_SINGLE_CLAIM: "Votre demande n\xE9cessite besoin de plus d'informations pour \xEAtre trait\xE9e. Voir les d\xE9tails ci-dessous",
  NEED_MORE_INFO_MULTIPLE_CLAIMS: "Vos demandes n\xE9cessitent plus d'informations pour \xEAtre trait\xE9es. Voir les d\xE9tails ci-dessous.",
  RECENT_CLAIMS: "Demandes r\xE9centes",
  IF_YOU_HAVE_AN_URGENT_CLAIM_PLEASE_CONTACT_CUSTOMER_SUPPORT: "Si votre demande de remboursement est urgente, veuillez communiquer avec le <a>service \xE0 la client\xE8le</a>.",
  ABOUT_THIS_BENEFIT: "\xC0 propos de cette prestation",
  ABOUT_THIS_BENEFIT_DESCRIPTION: "Cette prestation est mise \xE0 votre disposition par votre employeur. Pour toute question ou information d\xE9taill\xE9e, veuillez vous adresser \xE0 votre administrateur RH.",
  ID_LIKE_TO_DOTDOTDOT: "J'aimerais...",
  HAS_DEPENDENTS_DESCRIPTION: "Les personnes \xE0 votre charge pour cette prestation sont \xE9num\xE9r\xE9es ci-dessous. Si vous avez r\xE9cemment v\xE9cu un \xE9v\xE9nement de vie, vous pourriez \xEAtre autoris\xE9 \xE0 apporter des modifications \xE0 vos personnes \xE0 charge. Cliquez sur le bouton ci-dessous pour v\xE9rifier en quelques \xE9tapes si vous y avez droit.",
  HAS_NO_DEPENDENTS_DESCRIPTION: "Vous n'avez pas de personnes \xE0 charge associ\xE9es \xE0 cette prestation. Si vous avez r\xE9cemment v\xE9cu un \xE9v\xE9nement de vie, vous pourriez avoir le droit d'ajouter ou de modifier vos personnes \xE0 charge.  Cliquez sur le bouton ci-dessous pour v\xE9rifier en quelques \xE9tapes si vous y avez droit.",
  ADD_A_DEPENDENT_CAPITAL: "Ajouter une personne \xE0 charge",
  WALLET_FEEDBACK_TITLE: "Aidez-nous \xE0 am\xE9liorer l'exp\xE9rience portefeuille",
  WALLET_FEEDBACK_SUBTITLE_BENEFIT: "Avez-vous trouv\xE9 l'information \xE0 propos de la garantie \u201C{benefitName}\u201D utile?",
  WALLET_FEEDBACK_SUBTITLE_OTHER: "Les informations fournies pour {cardName} vous ont-elles \xE9t\xE9 utiles?",
  GO_BACK: "Retour",
  WALLET_LANDING_TITLE: "Les informations sur votre couverture et vos avantages sociaux r\xE9unies dans un seul et m\xEAme endroit.",
  WALLET_LANDING_BODY: "Votre portefeuille \xE9lectronique contient les avantages sociaux de votre employeur, programmes et les d\xE9tails de votre couverture. Trouvez ce dont vous avez besoin en un clin d'\u0153il.",
  POLICY_ACTIVE: "Police active",
  REMAINING_BALANCE: "Solde",
  CONTACT_CUSTOMER_CARE: "communiquer avec le service \xE0 la client\xE8le",
  UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG: "Oh oh! Une erreur est survenue",
  WERE_HAVING_TROUBLE: "Nous avons du mal \xE0 charger cette information. Veuillez actualiser la page. Si le probl\xE8me persiste, veuillez contacter {custCareLink}.",
  IN_NETWORK: "Au sein du r\xE9seau",
  OUT_OF_NETWORK: "Hors-R\xE9seau",
  PROGRAMS: "Programmes",
  PROGRAM_CREATED_BY: "Programme cr\xE9\xE9 par",
  TOP_FOCUS_AREA: "Domaine prioritaire",
  DIMENSION_OF_HEALTH: "DIMENSION DE LA SANT\xC9",
  READING_MORE_ABOUT_DIMENSIONS: "Vous souhaitez en savoir plus sur l'impact des dimensions sur votre sant\xE9 g\xE9n\xE9rale?",
  READ_OUR_ARTICLE: "Lisez notre article",
  HEALTH_PROGRAMS_FOR_YOU: "Programmes sant\xE9 pour vous",
  COMPLETE_ACTIVITIES: "Compl\xE9tez les activit\xE9s pour atteindre vos objectifs de sant\xE9. Recommand\xE9 en fonction de votre profil de sant\xE9.",
  FT: "pi",
  CM: "cm",
  IN: "po",
  LB: "lb",
  KG: "kg",
  LETS_BEGIN: "Commen\xE7ons!",
  KEEP_GOING: "Continuez!",
  SKIP: "Sauter",
  HP_ONBOARDING_SUBMIT: "Commen\xE7ons!",
  FOR_PROVIDERS_AND_PHARMACISTS: "Pour les fournisseurs/pharmaciens",
  WEVE_PICKED_UP: "Nous reprenons l\xE0 o\xF9 vous \xE9tiez.",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NUMBER: "Il ne vous reste plus que quelques questions avant d'accumuler {points} points.",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NOR_POINTS: "Il ne vous reste plus que quelques questions pour compl\xE9ter l'\xE9valuation.",
  PRESS_ENTER: "Suivant",
  SELECT_ALL_THAT_APPLY: "S\xE9lectionner tout ce qui s'applique.",
  SELECT_UP_TO: "S\xE9lectionnez jusqu'\xE0 {number}",
  AMOUNT_QUESTIONS: "{amount} questions",
  QUESTION_PROGRESS: "QUESTION {questionNumber} DE {totalQuestions}",
  COMPLETE: "Termin\xE9",
  VIEW_MORE: "Voir plus",
  DOWNLOAD_APP_STORE: "T\xE9l\xE9charger sur l'App Store",
  DOWNLOAD_PLAY_STORE: "T\xE9l\xE9charger sur Google Play",
  WE_RE_SORRY_REQUESTED_PAGE_EXPIRED_OR_NOT_VALID: "Nous sommes d\xE9sol\xE9s, la page demand\xE9e a expir\xE9 ou n\u2019est plus valide.",
  EARNED_X_TIMES: "Gagn\xE9 {amount}X",
  EARNED: "accumul\xE9",
  YOUVE_EARNED_TOTAL: "Vous avez accumul\xE9 un total de",
  YOUVE_EARNED_GRAND_TOTAL: "Vous avez accumul\xE9 un grand total de",
  YOUVE_EARNED_ACHIEVEMENT_BADGE: "Vous avez gagn\xE9 un badge de r\xE9alisation",
  CONGRATS_COMPLETED: "F\xE9licitations, vous avez compl\xE9t\xE9",
  VIEW_MY_HEALTH_DASHBOARD: "Consulter le tableau de bord de ma sant\xE9",
  LATEST_INSIGHTS_METRICS_AND_MORE: "Derni\xE8rs aper\xE7us, mesures et plus encore",
  FEEDBACK_TITLE: "Est-ce que cette information \xE9tait utile?",
  FEEDBACK_MIN_SCALE: "Inutile",
  FEEDBACK_MAX_SCALE: "Tr\xE8s utile",
  HAVE_YOU_RECENTLY_EXPERIENCED_CHANGES: "Avez-vous r\xE9cemment v\xE9cu des changements dans votre vie ou votre famille?",
  DID_YOU_RECENTLY: "Vous \xEAtes-vous r\xE9cemment mari\xE9 ou avez-vous r\xE9cemment eu un enfant? Certains \xE9v\xE9nements de la vie sont admissibles pour une r\xE9inscription.",
  LEARN_MORE: "En savoir plus",
  VIEW_ACTIVITY: "Voir l'activit\xE9",
  CONTINUE: "Poursuivre",
  ARIA_CIRCLED_CHECKMARK: "Coche blanche entour\xE9e d'un cercle",
  NOT_NOW: "Pas maintenant",
  VAL_POINTS: "{points} points",
  ACTIONS: "Actions",
  VIEW_ALL_CLAIMS: "Voir toutes les demandes",
  THIS_BOX_MUST_BE_CHECKED_TO_CONTINUE: "Cochez cette case pour continuer",
  PLEASE_NOTE: "Veuillez noter",
  COPY: "Copier",
  STATUS: "Statut",
  STARTED: "Commenc\xE9",
  APPROVED: "Approuv\xE9e",
  CANCELLED: "Annul\xE9e",
  UPLOADED_DOCUMENT: "Import\xE9 le {date} \u2022 Import\xE9 par {user}",
  MORE_INFORMATION_NEEDED: "A besoin de renseignements",
  PAID: "Pay\xE9e",
  PENDING_EXTERNAL_REVIEW: "Envoy\xE9 pour \xE9valuation externe",
  PREAPPROVAL_MORE_INFORMATION_NEEDED: "Pr\xE9approbation \u2013 Renseignements compl\xE9mentaires",
  PREAPPROVAL_REJECTED: "Pr\xE9approbation refus\xE9e",
  PREAPPROVED: "Pr\xE9approuv\xE9e",
  REJECTED: "Refus\xE9e",
  SUBMITTED_FOR_PREAPPROVAL: "Soumise pour approbation pr\xE9alable",
  SUBMITTED: "Soumise",
  WALLET: "Portefeuille",
  AMOUNT: "Montant",
  ADD: "Ajouter",
  EDIT: "Modifier",
  DETAILS: "D\xE9tails",
  AND: "et",
  TODAY: "Aujourd'hui",
  CLAIMS: "Demandes",
  GROUP_ID: "Identifiant du groupe",
  ZIP_CODE: "Code ZIP",
  CITY: "Ville",
  STATE: "\xC9tat",
  REMOVE: "Retirer",
  HEALTH_SPENDING_ACCOUNT: "Compte soins de sant\xE9",
  HSA: "CSS",
  LIFESTYLE_SPENDING_ACCOUNT: "Compte de d\xE9penses bien-\xEAtre",
  LSA: "CDB",
  HEALTH_REIMBURSEMENT_ARRANGEMENT: "Compte de remboursement des frais de sant\xE9",
  DRUGS: "M\xE9dicaments",
  TRAVEL: "Voyage",
  HEALTH_INSURANCE: "Assurance maladie",
  SETTINGS: "Param\xE8tres",
  ACTIVE: "Actif",
  ENDED: "Termin\xE9",
  SUSPENDED: "Suspendu",
  PENDING: "En attente",
  LOADING: "Chargement",
  ERROR_STATE_TITLE: "Une erreur est survenue",
  HELP_EMAIL: "aide@league.com",
  SUBMIT: "Soumettre",
  EARN_NUMBER_POINTS_FULL: "Accumulez {points} points",
  CLOSE: "Fermer",
  THIS_CHALLENGE_RUNS_YEAR_ROUND: "Ce d\xE9fi se d\xE9roule toute l'ann\xE9e",
  END_DAY_AT_TIME: "Se termine le {day}",
  ENDED_DAY_AT_TIME: "Termin\xE9 le {day}",
  START_DAY_AT_TIME: "Commence le {day}",
  SPONSOR_LOGO: "logo {name}",
  START_AND_END_DATES: "Commence le {startDate} - Se termine le {endDate}",
  SIGN_UP_BY_DATE: "Inscrivez-vous avant {date}",
  SIGN_UP_BEGINS_DATE: "L'inscription commence le {date}",
  SIGN_UP_DATE_PASSED: "La date d'inscription est pass\xE9e",
  SIGN_UP_PERIOD_PASSED: "Date d'inscription d\xE9pass\xE9e",
  CHALLENGE_DETAILS: "D\xE9tails du d\xE9fi",
  CHALLENGE_PROGRESS: "Progression du d\xE9fi",
  X_PERCENT_COMPLETE: "{number}% termin\xE9",
  SIGN_UP_FOR_CHALLENGE: "S'inscrire au d\xE9fi",
  GROUP_CHALLENGE: "D\xE9fi de groupe",
  SOLO_CHALLENGE: "D\xE9fi solo",
  TRACK_WEARABLES_ALT_TEXT: "Une personne regardant les donn\xE9es de sa montre connect\xE9e",
  CONNECT_A_DEVICE: "Connecter un appareil",
  DEVICES_CONNECTED_TITLE: "On dirait que vous \xEAtes d\xE9j\xE0 connect\xE9!",
  DEVICES_CONNECTED_DESCRIPTION: "Nous synchronisons d\xE9j\xE0 vos donn\xE9es. Si vous choisissez le suivi automatique, nous pourrons automatiquement marquer les activit\xE9s comme faites en utilisant {dataPoint} de votre appareil.",
  DEVICES_UNCONNECTED_TITLE: "Connexion de votre appareil",
  DEVICES_UNCONNECTED_TRACK_AUTOMATICALLY_SUBTITLE: "Suivre automatiquement",
  DEVICES_UNCONNECTED_TRACK_MANUALLY_SUBTITLE: "Suivre manuellement",
  DEVICES_UNCONNECTED_DESCRIPTION: "Connectez vos applications et appareils de suivi de sant\xE9 pr\xE9f\xE9r\xE9s pour marquer automatiquement les activit\xE9s comme faites.",
  TRACK_CHALLENGE_AUTOMATICALLY: "Suivre automatiquement",
  TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION: "Si vous d\xE9cidez de faire le suivi automatiquement, apr\xE8s votre adh\xE9sion, {instructionsLink} pour connecter votre appareil en utilisant l'application mobile League.",
  TRACK_CHALLENGE_AUTOMATICALLY_INSTRUCTION: "suivez ces \xE9tapes",
  TRACK_CHALLENGE_MANUALLY: "Suivre manuellement \xE0 la place",
  TRACK_CHALLENGE_MANUALLY_CHANGE_LATER: "Si vous choisissez d'effectuer un suivi manuel, vous pourrez toujours connecter un appareil ult\xE9rieurement. {learnMoreLink} sur le suivi manuel de votre progression.",
  TRACK_CHALLENGE_MANUALLY_LEARN_MORE: "En savoir plus",
  TRACK_HEALTH_DATA_ALT: "Tableau de bord avec un graphique de suivi des donn\xE9es de sant\xE9",
  TRACK_MANUALLY_CONFIRM_TITLE: "Voulez-vous vraiment faire le suivi manuellement?",
  TRACK_MANUALLY_CONFIRM_CONNECT_LATER_DESCRIPTION: "Vous pouvez toujours connecter un appareil ult\xE9rieurement",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_TITLE: "Vous \xEAtes s\xFBr de vouloir sortir ?",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_DESCRIPTION: "Si vous choisissez de quitter, il se peut que vos modifications ne soient pas enregistr\xE9es.",
  EXIT: "Sortie",
  CHALLENGE: "D\xE9fi",
  CHALLENGES: "D\xE9fis",
  CHALLENGE_PROGRAM_LIBRARY_DESCRIPTION: "Inscrivez-vous \xE0 un d\xE9fi pour r\xE9aliser des activit\xE9s quotidiennes et rivalisez avec vos coll\xE8gues!",
  THIS_CHALLENGE_HAS_ENDED: "Ce d\xE9fi est termin\xE9",
  COMPLETED_ON_DATE: "Compl\xE9t\xE9 le {date}",
  ENDED_ON_DATE: "Termin\xE9 le {date}",
  LEAVE_CHALLENGE: "Quitter le d\xE9fi",
  LEAVE_CHALLENGE_QUESTION: "Quitter le d\xE9fi?",
  LEAVE_CHALLENGE_DETAIL: "\xCAtes-vous s\xFBr de vouloir supprimer ce d\xE9fi de votre parcours? Toute progression dans ce d\xE9fi sera remise \xE0 z\xE9ro.",
  LEAVE: "Quitter",
  SIGN_UP_FOR_THE_CHALLENGE: "Inscrivez-vous pour le d\xE9fi",
  CHALLENGE_SENSITIVE_DATA: "Vos donn\xE9es de sant\xE9 et vos renseignements personnels sont extr\xEAmement sensibles et il nous incombe de les prot\xE9ger et de les pr\xE9server. Nous prenons cette responsabilit\xE9 tr\xE8s au s\xE9rieux.",
  CHALLENGE_USING_DATA_TO: "Lorsque vous vous inscrivez \xE0 un d\xE9fi, nous utilisons vos donn\xE9es pour :",
  COMPLETE_ACTIVITIES_SHORT: "Activit\xE9s compl\xE8tes",
  SHARE_CHALLENGE_PROGRESS_WITH_EMPLOYER: "Partagez les progr\xE8s de votre d\xE9fi avec votre employeur",
  SHARE_CHALLENGE_PROGRESS: "Partagez les progr\xE8s de votre d\xE9fi avec vos coll\xE8gues (et votre employeur).",
  RANK_SCORE: "Classez votre score dans un tableau de classement",
  DETERMINE_CHALLENGE_WINNERS: "D\xE9terminer les gagnants du d\xE9fi",
  ACCEPT_BEFORE_CONTINUE: "Vous devez accepter avant de continuer.",
  CHECK_TO_CONFIRM_PRIVACY_POLICY: "En cochant cette case, j'accepte la <a>politique de confidentialit\xE9.</a>",
  LEARN_MORE_ABOUT_PRIVACY_POLICY: "Pour en savoir plus sur la fa\xE7on dont League g\xE8re et utilise vos donn\xE9es, consultez notre <a>politique de confidentialit\xE9.</a>",
  PRIZE: "Prix",
  RULES: "R\xE8gles",
  LEADERBOARD: "Tableau de classement",
  TOOLTIP_ACTION_DESCRIPTION: "Voir le crit\xE8re de classement",
  MARK_AS_DONE: "Marquer comme fait",
  CLOSE_ACTIVITY: "Fermer l'activit\xE9",
  GOAL_INCOMPLETE: "Vous devez compl\xE9ter l'objectif avant de continuer.",
  PROGRESS_RECORD_ERROR: "Un probl\xE8me est survenu lors de l'enregistrement de votre derni\xE8re progression.",
  YOUVE_COMPLETED: "Vous avez termin\xE9",
  ACTIVITY_COMPLETE: "Activit\xE9 termin\xE9e",
  PAGE_NOT_FOUND_HEADER: "Page introuvable",
  PAGE_NOT_FOUND_CONTENT: "Vous avez l'air un peu perdu!",
  PAGE_NOT_FOUND_CONTENT_SECONDARY: "Laissez-nous vous aider \xE0 retrouver votre chemin.",
  PAGE_NOT_FOUND_BUTTON: "Retour \xE0 la page d'accueil",
  REWARD_POINTS: "Points de r\xE9compense",
  REWARD_POINTS_EARNED: "Points de r\xE9compense accumul\xE9s",
  REWARD_POINTS_MISSED: "Points de r\xE9compense manqu\xE9s",
  X_REWARD_POINTS: "{points} points de r\xE9compense",
  X_LEAGUE_POINTS: "{points} points League",
  REWARDS_PROGRAM_ELIGIBLE: "Admissible au programme de r\xE9compenses",
  EXPIRY_DATE: "Date d'expiration",
  NO_EXPIRY_DATE: "Aucune date d'expiration",
  POINTS_BALANCE: "Solde de points",
  REDEEM_NEXT_TIER_POINTS: "Il vous reste {points} avant de pouvoir \xE9changer {value}.",
  VIEW_YOUR_REWARDS: "Voir vos r\xE9compenses",
  REDEEMABLE: "\xC9changeable contre {value}.",
  ACTIVATION_PENDING: "En attente d'activation",
  EXPIRED: "Expir\xE9e",
  YOUR_ACCOUNT_IS_ACTIVE_AND_IN_THE_PROCESS_OF_BEING_SET_UP: "Votre compte est actif et en cours de cr\xE9ation.",
  PLEASE_TRY_AGAIN_SHORTLY: "Veuillez r\xE9essayer sous peu",
  MANAGE_DEPENDENTS: "G\xE9rer mes personnes \xE0 charge",
  VIEW_CARD: "Voir la carte",
  MEMBER_ID: "Identifiant du membre",
  SPOUSE: "Conjoint",
  COMMON_LAW: "Conjoint de fait",
  CHILD: "Enfant",
  PARENT: "Parent",
  GRANDPARENT: "Grand-parent",
  GRANDCHILD: "Petit-enfant",
  UNCLE_AUNT: "Oncle / tante",
  NEPHEW_NIECE: "Neveu / ni\xE8ce",
  INELIGIBLE_CHILD: "Enfant non admissible",
  SIBLING: "Fr\xE8re ou s\u0153ur",
  OTHER: "Autre",
  DEPENDENT_CARD_HOLDER: "Carte de {dependentName} pour",
  DATE: "Date",
  DESCRIPTION: "Description",
  TYPE: "Type",
  ID: "Identifiant",
  CLAIM: "Demande",
  TOP_UP: "Recharger",
  ADJUSTMENT: "Modification",
  REFUND: "Remboursement",
  LEAGUE_CREDIT: "Cr\xE9dit League",
  CREDIT_CARD: "Carte de cr\xE9dit",
  CGA: "CBF",
  NO_TRANSACTIONS_YET: "Aucune transaction n'a encore \xE9t\xE9 effectu\xE9e",
  NO_MORE_TRANSACTIONS: "Aucune autre transaction",
  PROMO_CODE: "Code promotionnel",
  PROMO_CODE_NOT_FOUND: "Code de promotion invalide",
  PROMO_CODE_SUCCESS: "Le code de promotion a \xE9t\xE9 \xE9chang\xE9!",
  TOTAL_CREDIT: "Cr\xE9dit total :",
  CREDIT_INFORMATION: "Renseignements sur le cr\xE9dit",
  ENTER_CODE: "Entrez un code",
  DOCUMENT_NAME: "Nom du document",
  REQUIRED: "Requis",
  CANCEL: "Annuler",
  CONFIRM: "Confirmer",
  ALLOCATION: "Allocation",
  COVERED: "Couvert",
  NOT_COVERED: "Non couvert",
  COVERED_WITH_RESTRICTIONS: "Couvert, sous r\xE9serve de restrictions",
  EXPAND_ALL: "Tout afficher",
  COLLAPSE_ALL: "Tout r\xE9duire",
  EXAMPLES: "Exemples : ",
  RESTRICTIONS: "Restrictions",
  SEARCH_COVERAGE: "Rechercher votre couverture",
  COVERAGE_SEARCH_BEHAVIOUR_DESCRIPTION: "Les r\xE9sultats de la recherche s'actualisent automatiquement au fur et \xE0 mesure que vous tapez",
  INDIVIDUAL: "Individuel",
  INDIVIDUAL_CAP: "Individuel",
  DEPENDENTS: "Personnes \xE0 charge",
  SELECT_ONE: "S\xE9lectionnez en une",
  MORE_OPTIONS: "Plus d'options",
  VENDOR: "Fournisseur",
  FLEX_DOLLAR_INFO_TEXT_SINGLE: "ils seront automatiquement ajout\xE9s \xE0 votre {benefitName}.",
  FLEX_DOLLAR_INFO_TEXT_MULTIPLE: "<strong>{percent}%</strong> sera ajout\xE9 \xE0 votre <strong>{benefitName}</strong>",
  LEFTOVER_FLEX_DOLLAR_INFO_TEXT_SINGLE: "<strong>{percent}%</strong> sera ajout\xE9 \xE0 votre  <strong>{benefitName}</strong>.",
  DOCUMENT_TITLE: "{title} - League",
  MEDICAL: "Soins m\xE9dicaux",
  TOTAL: "Total",
  PROFILE_UPDATE_FAILED: "\xC9chec de la mise \xE0 jour du profil",
  PROFILE_PHOTO: "Photo de profil",
  PROFILE_PHOTO_DESCRIPTION: "Cette photo appara\xEEt sur votre profil d'utilisateur et votre profil Sant\xE9",
  SELECT_AVATAR: "S\xE9lectionnez un avatar",
  SELECT_AVATAR_ERROR: "Vous devez choisir un avatar avant de continuer.",
  GET_AVATARS_ERROR: "Oups! Il y a eu un probl\xE8me pour charger les avatars. Veuillez rafra\xEEchir et r\xE9essayer.",
  ADDRESS_LINE_1: "Adresse ligne 1",
  ADDRESS_LINE_2: "Adresse ligne 2",
  LANGUAGE_SELECTOR_ENGLISH: "Anglais",
  LANGUAGE_SELECTOR_FRENCH: "Fran\xE7ais",
  LANGUAGE_SELECTOR_SPANISH: "Espa\xF1ol",
  DOMESTIC_PARTNERSHIP: "Partenariat domestique",
  YES: "Oui",
  NO: "Non",
  WHY_DO_YOU_ASK: "Pourquoi avez-vous besoin de cette information?",
  LAST_DAY_OF_ENROLLMENT: "Dernier jour de la p\xE9riode d\u2019inscription : {lastDay}",
  WALLET_WELCOME: "Bienvenue dans votre portefeuille!",
  WALLET_DESCRIPTION: "Votre portefeuille est l\u2019endroit o\xF9 vous pourrez acc\xE9der \xE0 vos avantages sociaux, soumettre des demandes et v\xE9rifier votre couverture. Vous pourrez soumettre des demandes pour frais engag\xE9s durant la p\xE9riode d\u2019inscription une fois que votre portefeuille sera activ\xE9. En attendant, {healthProgramLink}!",
  HEALTH_PROGRAM_LINK_COPY: "essayez l\u2019un de nos programmes de sant\xE9",
  FINALIZE_SELECTIONS_HEADER_COPY: "Souhaitez-vous acc\xE9der \xE0 vos avantages sociaux plus t\xF4t?",
  FINALIZE_SELECTIONS_COPY_1: "En finalisant vos s\xE9lections, nous pourrons imm\xE9diatement envoyer les d\xE9tails de votre r\xE9gime \xE0 l\u2019assureur! Cela signifie que vous ne devrez pas attendre la fin de votre p\xE9riode d\u2019inscription pour consulter votre portefeuille.",
  FINALIZE_SELECTIONS_COPY_2: "Cela signifie \xE9galement qu'une fois que vous aurez cliqu\xE9 sur soumettre, vous ne pourrez plus modifier votre r\xE9gime.",
  FINALIZE_SELECTIONS_ACKNOWLEDGEMENT: "Je comprends que je ne pourrai plus modifier mes s\xE9lections.",
  FINALIZE_PLAN_SELECTIONS: "Finaliser les s\xE9lections de mon r\xE9gime.",
  ERROR_FINALIZING_SELECTIONS: "Une erreur est survenue, nous n\u2019avons pas pu soumettre vos s\xE9lections.",
  ERROR_FINALIZING_SELECTIONS_INVALID_SELECTIONS: "Vos s\xE9lections semblent incompl\xE8tes. Veuillez r\xE9aliser votre inscription et r\xE9essayer.",
  SELECTIONS_FINALIZED_SUCCESS: "S\xE9lection termin\xE9e!",
  TOTAL_REWARDS_LABEL: "R\xE9capitulatif de votre couverture",
  TOTAL_REWARDS_DESCRIPTION: "R\xE9viser la s\xE9lection du r\xE9gime effectu\xE9e pendant l\u2019inscription.",
  TOTAL_REWARDS_LINK: "Voir le r\xE9capitulatif de votre couverture",
  CHANGE_PLAN_LABEL: "Changer les s\xE9lections du r\xE9gime",
  CHANGE_PLAN_DESCRIPTION: "Souhaitez-vous modifier votre r\xE9gime ou vos renseignements personnels?",
  CHANGE_PLAN_LINK: "Modifier la s\xE9lection du r\xE9gime",
  DISMISS_TOAST: "Ignorer la notification",
  UPLOAD_DOCUMENT: "T\xE9l\xE9verser un document",
  REQUIRED_FORM: "Requis",
  PERCENTAGE_USED: "{percentage} utilis\xE9.",
  SUCCESS: "C'est r\xE9ussi!",
  ERROR: "Erreur",
  OVERVIEW: "Aper\xE7u",
  THIS_FIELD_IS_REQUIRED: "Ce champs est obligatoire",
  INVALID_ZIP_CODE_NO_FORMAT: "Code postal invalide",
  INVALID_DAY_ERROR_MESSAGE: "Le jour que vous avez s\xE9lectionn\xE9 est invalide.",
  UNIQUE_IDENTIFIER_MAX_LENGTH_ERROR: "Doit comporter {length} caract\xE8res au maximum",
  COMPLETED_STATE_TITLE: "Compl\xE9t\xE9",
  DRAG_OR_UPLOAD_PHOTO: "T\xE9l\xE9versez une photo de ce document",
  ADD_IMAGE: "Ajoutez plus de pages \xE0 ce document (le cas \xE9ch\xE9ant)",
  IDENTIFICATION_TYPE_TWO_FILES: "Les documents d\u2019identification ne peuvent comporter que 2 images.",
  WELCOME: "Bienvenue",
  GOT_IT: "J'ai compris",
  SAVE: "Sauvegarder",
  VIEW_MORE_DETAILS_SENTENCE_CASE: "Voir plus de d\xE9tails",
  LAST_UPDATED: "Derni\xE8re mise \xE0 jour",
  CLAIM_REF_NUMBER: "Num\xE9ro de demande",
  VIEW_ALL: "Voir tout",
  HRA: "ERSS",
  SEARCH: "Rechercher",
  DAY: "Jour",
  MONTH: "Mois",
  YEAR: "Ann\xE9e",
  BACK: "Retour",
  NEXT: "Suivant",
  PREVIOUS: "Pr\xE9c\xE9dent",
  HELP_CENTER: "Centre d'assistance",
  LIVE_CHAT_TOP_BAR_MINIMIZE: "R\xE9duire le clavardage",
  LIVE_CHAT_FEED_NEW_CHIPS_ALT: "R\xE9ponses sugg\xE9r\xE9es disponibles",
  LIVE_CHAT_AGENT_TYPING_BUBBLE_ALT: "Un participant au clavardage est en train d'\xE9crire",
  VIEW_DOCUMENT: "Afficher le document\xA0:",
  CATEGORIES: "Cat\xE9gories",
  ACTIVE_PROGRAM: "{length, plural, one {Programmes actifs} other {Programmes actifs}}",
  ACTIVE_CHALLENGE: "{length, plural, one {D\xE9fi en cours} other {D\xE9fis en cours}}",
  PROGRAM_PROGRESS: "Progr\xE8s des programmes",
  MULTI_SELECT_DEFAULT_CAN_CREATE: "Vous pouvez aussi \xE9crire quelque chose pour cr\xE9er une nouvelle option!",
  MULTI_SELECT_DEFAULT_PLACEHOLDER: "S\xE9lectionnez vos options",
  COVERAGE: "Couverture",
  HEALTH_PROFILE: "Profil sant\xE9",
  HEALTH_PROGRAM: "Programme sant\xE9",
  HEALTH_PROGRAMS: "Programmes sant\xE9",
  STEPS: "pas",
  ACTIVE_DURATION: "minutes actives",
  MINDFUL_DURATION: "minutes de pleine conscience",
  FLOORS_CLIMBED: "\xE9tages mont\xE9s",
  DISTANCE: "distance parcourue",
  ENERGY_BURNED: "calories br\xFBl\xE9es",
  METRIC_DETAILS: "D\xE9tails des mesures",
  HEALTH_PROGRAMS_SYNC_DEVICE: "Synchronisez votre {device} pour une exp\xE9rience optimale du programme.",
  HEALTH_PROGRAMS_CONNECTED_PROGRAM: "Programme sant\xE9 connect\xE9",
  TRACK_AUTOMATICALLY: "Suivez vos progr\xE8s automatiquement",
  SYNC_ISSUE: "PROBL\xC8ME DE SYNCHRONISATION",
  FIX_SYNC_ISSUE: "R\xE9soudre ce probl\xE8me",
  DATAPOINT_SYNC_ISSUE: "Un probl\xE8me est survenu lors de la synchronisation de votre {dataPoint}.",
  CONNECT_TO_TRACK: "Connectez vos applications et appareils de sant\xE9 pr\xE9f\xE9r\xE9s pour marquer automatiquement les activit\xE9s comme termin\xE9es.",
  CONNECT_APPS_DEVICES: "Connecter des applis et des appareils",
  ADD_APPS_DEVICES: "Voir les applications et les appareils",
  MANAGE_UNITS: "Modifier les unit\xE9s de mesure",
  DONT_CONNECT_APPS_DEVICES: "Ne pas suivre mes progr\xE8s automatiquement",
  CONNECTING_UNAVAILABLE: "La connexion d'applications et d'appareils n'est pas disponible sur le Web",
  CONNECTING_UNAVAILABLE_DETAILS: "Pour l'instant, veuillez consulter l'application mobile League pour connecter vos applications et appareils de sant\xE9 pr\xE9f\xE9r\xE9s.",
  CONNECTING_UNAVAILABLE_DETAILS_WITH_LINK: "Pour l'instant, veuillez consulter l'application mobile League pour connecter vos applications et appareils de sant\xE9 pr\xE9f\xE9r\xE9s. Si vous souhaitez en savoir plus, vous pouvez trouver une liste compl\xE8te des",
  CONNECT_DEVICES_LEARN_MORE: "En savoir plus",
  APPS_AND_DEVICES_CURRENTLY_SUPPORTED: "applications et appareils actuellement pris en charge",
  DONT_HAVE_THE_APP: "Vous n'avez pas l'application mobile League ?",
  WHAT_DEVICES_CAN_CONNECT: "Quelles sont les applications et les appareils pris en charge ?",
  CONNECTED_DEVICES_IMAGE_ALT: "Personne examinant les donn\xE9es d'un appareil connect\xE9",
  MORE_GREAT_RESOURCES: "Encore plus de ressources",
  HISTORY: "Historique",
  TOP_MATCH: "Meilleurs r\xE9sultats",
  CHAT: "Clavarder",
  END_CHAT: "Terminer le clavardage",
  BECOMES_ACTIVE_ON_DATE: "Devient actif le {date}",
  BECOMES_ACTIVE_IN_X_DAYS: "Cette garantie s'active dans {days} jours",
  YOU_CAN_ONLY_SUBMIT_CLAIMS_IN_DATE_RANGE: "Vous pouvez seulement soumettre des demandes avec date d'achat/du service entre {dateRange} pour cette prestation. Voir les d\xE9tails de votre couverture pour plus de renseignements",
  SUBMIT_PAST_CLAIMS_BY_DATE: "Soumettre des demandes ant\xE9rieures avant le {date}",
  THIS_POLICY_HAS_EXPIRED: "Cette p\xE9riode contractuelle est expir\xE9e, mais vous avez encore {days} jours pour soumettre des demandes ant\xE9rieures au titre de cet avantage.",
  THIS_POLICY_EXPIRES_TOMORROW: "Cette p\xE9riode contractuelle est expir\xE9e et aujourd'hui est votre dernier jour pour pr\xE9senter des demandes ant\xE9rieures au titre de cet avantage",
  YOU_HAVE_UNTIL_DATE_TO_SUBMIT_PAST_CLAIMS: "Vous avez jusqu'\xE0 <strong>{inactiveDate}</strong> pour soumettre des anciennes demandes d'achats/services effectu\xE9es avant le <strong>{endDate}</strong>.",
  EXPIRES_ON_DATE: "Expire le {date}",
  ASSIGNED: "Attribu\xE9",
  ASSIGNED_ON: "le {date}",
  ASSIGNED_TODAY: "aujourd'hui",
  YOU_HAVE_X_DAYS_BEFORE_EXPIRY: "Vous avez {days} jours pour utiliser cette prestation avant que la p\xE9riode contractuelle arrive \xE0 terme",
  AFTER_EXPIRY_YOU_HAVE_UNTIL_DATE_TO_SUBMIT: "Apr\xE8s l'expiration, vous aurez jusqu'au {inactiveDate} pour soumettre des demandes avec une date d'achat/de service le ou avant le {endDate}",
  LOAD_MORE: "Charger plus de r\xE9sultats",
  SHOW_MORE: "Afficher plus",
  LINK_OUT_MESSAGE: "\xC0 voir",
  THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM: "Oups, il semble y avoir eu un probl\xE8me.",
  TRY_AGAIN: "R\xE9essayer",
  WARNING_OPENS_NEW_TAB: "S'ouvre dans un nouvel onglet",
  ANY_HEALTH_CHANGES: "Y a-t-il eu des changements r\xE9cents dans votre sant\xE9?",
  LAST_UPDATED_DATE: "Derni\xE8re mise \xE0 jour le {date}",
  UPDATE_HEALTH_PROFILE: "Mettre \xE0 jour votre profil sant\xE9",
  HEALTH_PROFILE_COMPLETION_POINTS: "Vous avez accumul\xE9 {points} points",
  OPENS_IN_A_NEW_TAB: "S'ouvre dans un nouvel onglet",
  COMPLETED: "Compl\xE9t\xE9",
  COMPLETED_X_TIMES: "Compl\xE9t\xE9 {amount} fois",
  REMOVE_FROM_JOURNEY: "Retirer du parcours",
  GO_TO_JOURNEY: "Aller au parcours",
  ABOUT_THIS_PROGRAM: "\xC0 propos de ce programme",
  HEALTH_JOURNEY: "Parcours sant\xE9",
  REMOVE_ACTIVITY: "Supprimer l'activit\xE9?",
  REMOVE_ACTIVITY_PROMPT: "Supprimer l'activit\xE9",
  REMOVE_ACTIVITY_BUTTON: "Retirer",
  ARE_YOU_SURE_REMOVE_ACTIVITY: "Voulez-vous vraiment supprimer cette activit\xE9 de votre parcours sant\xE9? Cette action est irr\xE9versible.",
  YOU_WILL_NO_LONGER_SEE_IN_JOURNEY: "Vous ne le verrez plus dans votre parcours",
  DISCOVER_ACTIVITIES: "D\xE9couvrir de nouvelles activit\xE9s",
  DISCOVER_ACTIVITIES_CAPTION: "Parcourez les activit\xE9s qui devraient vous plaire",
  ACTIVITIES: "Activit\xE9s",
  ACTIVITIES_PLURALIZATION: "{count, plural, one {Activit\xE9} other {Activit\xE9s}}",
  ACTIVITIES_PILL: "Activit\xE9s",
  PROGRAM_LIBRARY: "Tous les programmes",
  BROWSE_PROGRAMS: "Parcourir les programmes",
  BACK_TO_JOURNEY: "Revenir au parcours",
  GO_TO_HEALTH_JOURNEY: "Aller au Parcours sant\xE9",
  ADD_TO_JOURNEY: "Ajouter au parcours",
  REQUEST_WAIT: "Veuillez patienter pendant que nous traitons votre demande",
  JOURNEY_DELIGHT_1: "La motivation vous fait d\xE9marrer. L'habitude vous fait avancer. Vous \xEAtes pr\xE8s!",
  JOURNEY_DELIGHT_2: "Actif. Concentr\xE9. Dans votre voie. Nous aimons le voir.",
  JOURNEY_DELIGHT_3: "Les petits pas peuvent faire une grande diff\xE9rence. Vous faites ce pas!",
  TOOLBOX_INPUT_OPTION_FREE_TEXT: "{hasValue, select, true {Il s'agit d'une option de texte libre; utilisez la zone de texte pour saisir votre propre valeur. La valeur actuelle est\xA0: {value}} other {Il s'agit d'une option de texte libre; utilisez la zone de texte pour saisir votre propre valeur. La valeur actuelle est\xA0: vide}}",
  TOOLBOX_INPUT_OPTION_EXCLUSIVE: "Cette option est exclusive; la s\xE9lectionner d\xE9s\xE9lectionnera toutes les autres",
  ANIMATION_ACCESSIBILITY_PLAYBACK: "Lancer ou mettre en pause l'animation s\xE9lectionn\xE9e",
  CENTIMETERS: "Centim\xE8tres",
  FEET: "Pieds",
  INCHES: "Pouces",
  KILOGRAMS: "Kilogrammes",
  POUNDS: "Livres sterling",
  EARN_UP_TO_X_POINTS: "Accumulez jusqu'\xE0 {points} points",
  EXPIRES_TODAY: "Expire aujourd'hui",
  PROGRAM_DETAILS: "D\xE9tails du programme",
  PROGRESS: "Progr\xE8s",
  X_OF_Y_COMPLETE: "{completed} / {total} termin\xE9",
  X_OF_Y_COMPLETED_WITH_UNIT: "<span>{progress}</span> / {goal} {unit}",
  X_MISSED: "{missed} manqu\xE9",
  MISSED: "Manqu\xE9",
  SCROLL_CAROUSEL_RIGHT: "Faites d\xE9filer le carrousel vers la droite",
  SCROLL_CAROUSEL_LEFT: "Faites d\xE9filer le carrousel vers la gauche",
  YOU_HAVENT_STARTED_PROGRAMS: "Vous n\u2019avez pas commenc\xE9 de programmes sant\xE9",
  ADD_PROGRAM: "Ajouter un programme",
  TAP_ADD_PROGRAM_BUTTON: 'Cliquez sur le bouton "Ajouter un programme" pour parcourir les programmes.',
  YOUVE_REACHED_PROGRAM_LIMIT: "Vous avez atteint la limite de votre programme!",
  START_X_MORE_PROGRAMS: "{duration, plural, one {Commencez {duration,number} plus de programmes. Maintenez l'\xE9lan.} other {Commencez {duration,number} plus de programmes. Maintenez l'\xE9lan.}}",
  OK: "D'accord",
  COMPLETE_ONE_OF_ACTIVE_PROGRAMS: "Terminez l\u2019un de vos programmes actifs pour ajouter celui-ci \xE0 votre parcours.",
  SHOW_LESS: "Voir moins",
  LOOKS_LIKE_REACHED_PROGRAM_LIMIT: "Il semble que vous avez atteint la limite de votre programme!",
  COMPLETE_ACTIVE_PROGRAM_BEFORE_NEW_ONE: "Terminez un programme en cours avant d'en ajouter un nouveau. <strong>{ctaText}</strong>",
  REMOVE_PROGRAM: "Retirer le programme?",
  REMOVE_PROGRAM_BUTTON: "Retirer",
  ARE_YOU_SURE_REMOVE_PROGRAM: "Voulez-vous vraiment retirer ce programme de votre parcours? Tous les progr\xE8s faits dans ce programme seront perdus et vous devrez recommencer.",
  PROGRAM_REMOVED: "Programme retir\xE9",
  PROGRAM_ADDED: "Programme ajout\xE9",
  THE_PROGRAM_WILL_APPEAR_IN_JOURNEY: "Le programme appara\xEEtra d\xE9sormais dans votre parcours",
  PROGRAM_ADD_ERROR: "Nous n'avons pas \xE9t\xE9 en mesure d'ajouter le programme pour le moment. Veuillez r\xE9essayer ou choisir un autre programme.",
  PROGRAM_REMOVE_ERROR: "Nous n'avons pas \xE9t\xE9 en mesure de supprimer le programme pour le moment. Veuillez r\xE9essayer.",
  SKIP_TO_CONTENT_MESSAGE: "Aller au contenu",
  MAIN_NAVIGATION_LIST_LABEL: "\xC9l\xE9ments de navigation de League",
  PAGE_TITLE_ACTIVITY_DETAILS: "D\xE9tails de l'activit\xE9",
  X_OF_Y: "{current} sur {total}",
  ACTIVITY_COUNT_EDIT: "Modifier {unit}",
  ACTIVITY_COUNT_GOAL: "Objectif: {goal,number} {unit}",
  ACTIVITY_COMPLETE_PROMPT: `Cette activit\xE9 ne sera pas termin\xE9e tant que vous n'aurez pas "marquer comme fait".`,
  ACTIVITY_COMPLETE_LATER_PROMPT: 'Pour continuer, cliquez sur "Retour au parcours" et revenez plus tard pour le marquer comme fait.',
  ACTIVITY_COMPLETE_ERROR: "Nous n'avons pas \xE9t\xE9 en mesure de compl\xE9ter l'activit\xE9 pour le moment. Veuillez r\xE9essayer.",
  ACTIVITY_DISMISS_ERROR: "Nous n'avons pas \xE9t\xE9 en mesure de supprimer l'activit\xE9 pour le moment. Veuillez r\xE9essayer.",
  TOOLBOX_VALIDATION_DAY_MONTH_YEAR: "Veuillez s\xE9lectionner un jour, un mois et une ann\xE9e",
  TOOLBOX_VALIDATION_MONTH_YEAR: "Veuillez s\xE9lectionner un mois et une ann\xE9e",
  TOOLBOX_VALIDATION_MAXIMUM_CHARACTERS: "La limite de caract\xE8res est {limit}",
  TOOLBOX_VALIDATION_NUMBER_MINIMUM: "Entrez un nombre \xE9gal ou sup\xE9rieur \xE0 {value}",
  TOOLBOX_VALIDATION_NUMBER_MAXIMUM: "Entrez un nombre \xE9gal ou inf\xE9rieur \xE0 {value}",
  TOOLBOX_VALIDATION_REQUIRED_FIELD: "Ce champ est obligatoire",
  TOOLBOX_VALIDATION_DATE_INPUT_REQUIRED: "Veuillez faire une s\xE9lection",
  TOOLBOX_VALIDATION_MULTI_SELECT_REQUIRED: "Veuillez faire une s\xE9lection",
  TOOLBOX_VALIDATION_SELECT_DATE_LATER: "S\xE9lectionnez une date post\xE9rieure \xE0 {date,date,medium}",
  TOOLBOX_VALIDATION_SELECT_DATE_EARLIER: "S\xE9lectionnez une date ant\xE9rieure \xE0 {date,date,medium}",
  TOOLBOX_VALIDATION_ENTER_WHOLE_NUMBER: "Entrez un nombre entier",
  TOOLBOX_VALIDATION_SELECT_MAX_SELECTION: "S\xE9lectionnez un maximum de {integer} options",
  TOOLBOX_VALIDATION_SELECT_OPTIONS_TO_CONTINUE: "S\xE9lectionnez {integer} options pour continuer",
  TOOLBOX_VALIDATION_FIELD_CANNOT_BE_EMPTY: "Le champ ne peut pas \xEAtre vide lorsqu'il est s\xE9lectionn\xE9",
  TOOLBOX_VALIDATION_WEIGHT_MINIMUM: "Le poids doit \xEAtre d'au moins {value}{unit}",
  TOOLBOX_VALIDATION_WEIGHT_MAXIMUM: "Le poids doit \xEAtre au maximum {value}{unit}",
  TOOLBOX_VALIDATION_HEIGHT_MINIMUM: "La hauteur doit \xEAtre d'au moins {value}{unit}",
  TOOLBOX_VALIDATION_HEIGHT_MAXIMUM: "La hauteur doit \xEAtre au maximum {value}{unit}",
  ENTER_YOUR_WEIGHT_IN_KILOGRAMS: "Entrez votre poids en kilogrammes",
  ENTER_YOUR_WEIGHT_IN_POUNDS: "Entrez votre poids en livres",
  ENTER_YOUR_HEIGHT_IN_CENTIMETERS: "Entrez votre taille en centim\xE8tres",
  ENTER_YOUR_HEIGHT_IN_FEET: "Entrez votre taille en pieds",
  ENTER_YOUR_HEIGHT_IN_INCHES: "Entrez votre taille en pouces",
  GOAL_REACHED: "Vous avez atteint l'objectif!",
  COMPLETE_ACTIVITY: "Activit\xE9 termin\xE9e",
  EXIT_ACTIVITY_TITLE: "\xCAtes-vous certain de vouloir quitter cette activit\xE9?",
  EXIT_ACTIVITY_BODY: "Votre progression ne sera pas sauvegard\xE9e et vous devrez recommencer l'activit\xE9 depuis le d\xE9but.",
  EXIT_ACTIVITY_CTA: "Quitter l'activit\xE9",
  ACTIVITY_NEXT_STEP: "Continuer l'activit\xE9",
  ACTIVITY_PREV_STEP: "\u2190 Retour \xE0 l'\xE9tape pr\xE9c\xE9dente",
  PAGE_TITLE_HEALTH_PROGRAM_CATEGORY: "Cat\xE9gorie du programme sant\xE9",
  NEXT_STEP: "\xC9tape suivante",
  YOU_EARNED: "Vous avez accumul\xE9",
  YOU_EARNED_X_POINTS: "Vous avez accumul\xE9 {points} points!",
  CREATE: "Cr\xE9er {label}",
  TOMORROW: "Demain",
  YESTERDAY: "Hier",
  BACK_TO_TODAY: "Retour \xE0 aujourd'hui",
  PREVIOUS_DAY: "Jour pr\xE9c\xE9dent",
  NEXT_DAY: "Jour suivant",
  ACTIVITY_STATUS: "Statut de l'activit\xE9 : ",
  ACTIVITY_STATUS_EXPIRED: "Expir\xE9e",
  ACTIVITY_STATUS_REMOVED: "Ignor\xE9",
  ACTIVITY_STATUS_UPCOMING: "Disponible prochainement",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_OR_FUTURE_HEADING: "Rien de pr\xE9vu pour l'instant",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_DESCRIPTION: `Appuyez sur le bouton "Ajouter" pour trouver de nouveaux programmes ou parcourir une liste d'activit\xE9s s\xE9lectionn\xE9es juste pour vous.`,
  NO_ACTIVITIES_COMPLETED_TODAY_HEADING: "Bravo, vous \xEAtes sur une lanc\xE9e!",
  NO_ACTIVITIES_COMPLETED_TODAY_DESCRIPTION: "Revenez demain pour en savoir plus ou parcourez les activit\xE9s propos\xE9es.",
  NO_ACTIVITIES_FUTURE_DESCRIPTION: "Vous n'avez pas d'activit\xE9s pr\xE9vues pour ce jour.",
  NO_ACTIVITIES_PAST_HEADING: "Jour de repos",
  NO_ACTIVITIES_PAST_DESCRIPTION: "On dirait que vous avez pris cette journ\xE9e pour vous d\xE9tendre et r\xE9cup\xE9rer.",
  BUTTON_BROWSE_PROGRAMS: "Parcourir les programmes",
  IMG_ALT_HIGH_FIVE_HANDS: "Deux mains font un tape m'en cinq.",
  IMG_ALT_EMPTY_STATE_PROGRAMS: "Femme debout faisant d\xE9filer une liste de programmes de la taille d'un mur.",
  IMG_ALT_EMPTY_STATE_REST: "Homme se reposant dans un fauteuil confortable avec une boisson chaude et des \xE9couteurs.",
  THIS_IS_JUST_A_SNEAK_PEAK: "Ce n'est qu'un avant-go\xFBt!",
  COME_BACK_COMPLETE_ACTIVITY_ON_DATE: "Revenez et terminez cette activit\xE9 le {date}.",
  COME_BACK_COMPLETE_ACTIVITY_LATER: "Revenez plus tard pour compl\xE9ter cette activit\xE9.",
  LOOKS_LIKE_YOU_MISSED_THIS_ONE: "On dirait que vous avez manqu\xE9 cette activit\xE9!",
  THIS_ACTIVITY_EXPIRED_ON_DATE: "Cette activit\xE9 a expir\xE9 le {date}.",
  LOOKS_LIKE_THIS_WASNT_MEANT_FOR_YOU: "On dirait que cette activit\xE9 n'\xE9tait pas faite pour toi.",
  YOU_SKIPPED_THIS_ACTIVITY: "Vous avez saut\xE9 cette activit\xE9.",
  NO_PROGRAMS: "Rien \xE0 voir ici pour l'instant",
  NO_ACTIVITY_TITLE: "Il n\u2019y a rien \xE0 voir par ici (pour le moment!)",
  NO_LEADERBOARD_ACTIVITY_DESCRIPTION: "Rendez-vous ici pour voir votre classement lorsque le d\xE9fi commencera.",
  NO_HIGHLIGHTS_ACTIVITY_DESCRIPTION: "Rendez-vous ici pour voir les highlights de vos d\xE9fis.",
  LEADERBOARD_ALL_TIME_RANKING: "Classement de tous les temps",
  LEADERBOARD_CURRENT_USER_NAME: "{user} (Vous)",
  ACTIVITY_PROGRESS: "Progression de l'activit\xE9",
  YOUR_JOURNEY: "Votre parcours",
  SUGGESTED_FOR_YOU: "Sugg\xE9r\xE9 pour vous",
  NO_ACHIEVEMENTS_DESCRIPTION: "Terminez les activit\xE9s de votre parcours pour commencer \xE0 d\xE9bloquer des R\xE9alisations.",
  UNLOCK_ACHIEVEMENTS: "D\xE9bloquez une r\xE9alisation pour avoir termin\xE9 toutes les activit\xE9s de ce programme.",
  MEMBERS: "Membres",
  SIGN_UP_PERIOD_PASSED_DETAIL: "Vous ne pouvez plus vous inscrire \xE0 ce d\xE9fi car la date d'inscription est pass\xE9e.",
  REFERENCES: "R\xE9f\xE9rences",
  SIGN_UP_BY: "Inscrivez-vous avant {date}",
  YOURE_GOOD_TO_GO: "Vous \xEAtes pr\xEAt \xE0 partir!",
  CHECK_CHALLENGE_DETAILS: "Consultez les d\xE9tails du d\xE9fi pour vous familiariser avec les activit\xE9s",
  CHALLENGE_LETS_START_TEAMS_ENABLED: "Vous \xEAtes pr\xEAt \xE0 commencer votre d\xE9fi. Voulez-vous rejoindre ou cr\xE9er une \xE9quipe?",
  CHALLENGE_ABOUT_TO_START: "Votre d\xE9fi est sur le point de commencer!",
  ACTIVITIES_APPEAR_HERE_WHEN_CHALLENGE_STARTS: "Les activit\xE9s quotidiennes appara\xEEtront ici au d\xE9but de votre d\xE9fi, le <strong>{date}</strong>.",
  NO_CHALLENGE_ACTIVITIES_TODAY: "Il n'y a pas d'activit\xE9s dans ce d\xE9fi pour vous aujourd'hui.",
  COVERAGE_SEARCH_QUERY_NOT_FOUND: '"{query}" introuvable.',
  COVERAGE_SEARCH_TRY_AGAIN: "Essayez de rechercher \xE0 nouveau avec un mot-cl\xE9 diff\xE9rent.",
  EARN: "Accumuler",
  WORD_WITH_EXCLAMATION_POINT: "{word}!",
  UPDATED: "Actualis\xE9",
  YOUR_PROGRESS: "Votre progr\xE8s",
  YOUR_PROGRESS_IN_NUMBERS: "{current} of {total} {unit} ou {percentage}\xA0pourcentage termin\xE9",
  OUTCOMES_FRICTION_SCREEN_TITLE: "Des suggestions de personnalisation...",
  OUTCOMES_FRICTION_SCREEN_DESCRIPTION: "Laissez-nous le temps de trouver des ressources utiles pour vous en fonction de vos r\xE9ponses.",
  RELOAD_MY_SUGGESTIONS: "Rechargez mes suggestions",
  YOUR_RANKING: "Votre classement",
  TOP_RANKED: "Mieux class\xE9",
  VIEW_CHALLENGE_DETAILS: "Afficher les d\xE9tails du d\xE9fi",
  LEAGUE_FAMILY_EDUCATION_BANNER_HEADER: "Demandez-vous la raison pour laquelle il est avantageux d'ajouter vos personnes \xE0 charge?",
  LEAGUE_FAMILY_EDUCATION_BANNER_SUBHEADER: "Vos personnes \xE0 charge peuvent acc\xE9der League et profiter elles aussi d'une vie plus saine!",
  UNABLE_TO_LEAVE_CHALLENGE: "Impossible de quitter le d\xE9fi, veuillez r\xE9essayer!",
  SUCCESSFULLY_LEFT_CHALLENGE: "Vous avez quitt\xE9 le d\xE9fi avec succ\xE8s!",
  UNABLE_TO_JOIN_CHALLENGE: "Impossible de rejoindre le d\xE9fi, veuillez r\xE9essayer!",
  JOIN_TEAM: "Rejoindre une \xE9quipe",
  X_TEAM_MEMBERS: "{memberTotal, plural, one {{memberTotal,number} membre de l'\xE9quipe} other {{memberTotal,number} membres de l'\xE9quipe}}",
  X_SPOTS_AVAILABLE: "{spotsAvailable, plural, one {{spotsAvailable,number} place disponible} other {{spotsAvailable,number} places disponibles}}",
  HIGHLIGHTS: "Points saillants",
  CURRENT_RANK: "Rang actuel",
  X_LIKES: "{activityLikes, plural, one {{activityLikes,number} J'aime} other {{activityLikes,number} J'aime}}",
  LIKE: "Aimer",
  LIKED: "Aim\xE9",
  TEAM_INVITE_HEADING: "Nous sommes meilleurs ensemble!",
  TEAM_INVITE_DESCRIPTION: "Invitez des amis \xE0 se joindre \xE0 votre \xE9quipe pour r\xE9aliser des activit\xE9s ensemble.",
  TEAM_INVITE_LINK_DESCRIPTION: "Plus on est de fous, plus on rit! Partagez ce lien avec vos amis pour qu'ils puissent se joindre \xE0 votre \xE9quipe.",
  TEAM_INVITE_LINK: "Lien d'invitation pour l'\xE9quipe",
  INVITE: "Invitation",
  LEAVE_TEAM: "Quitter l'\xE9quipe",
  INVITE_FRIENDS: "Inviter des amis",
  PRIVACY: "Confidentialit\xE9",
  JOIN_TEAM_SUCCESS_TITLE: "Bienvenue dans l'\xE9quipe!",
  JOIN_TEAM_SUCCESS_DETAIL: "Conqu\xE9rons ces activit\xE9s ensemble.",
  JOIN_TEAM_SUCCESS_BUTTON: "Afficher les d\xE9tails de l'\xE9quipe",
  CANT_JOIN_TEAM_TITLE: "Vous ne pouvez pas encore rejoindre {teamName}",
  CANT_JOIN_TEAM_DETAIL: "Veuillez vous inscrire au d\xE9fi afin de rejoindre {teamName}",
  CANT_JOIN_TEAM_JOIN_CHALLENGE_DETAIL: "Il semble que vous ne vous soyez pas encore inscrit au d\xE9fi. Vous devez vous inscrire avant de pouvoir rejoindre {teamName}.",
  LEAVE_TEAM_QUESTION: "Voulez-vous quitter {teamName}?",
  LEAVE_TEAM_DESCRIPTION: "Voulez-vous vraiment quitter {teamName}? Votre score ne sera plus consid\xE9r\xE9 comme faisant partie de la moyenne de l\u2019\xE9quipe.",
  CHALLENGE_ACTIVITY_DETAIL: "Permettez aux utilisateurs de voir quand vous terminez une activit\xE9 ou gagnez une r\xE9alisation en participant \xE0 un d\xE9fi.",
  SHOW_MY_ACTIVITY: "Afficher mon activit\xE9",
  YOUR_TEAM: "Votre \xE9quipe",
  JOIN_OR_CREATE_TEAM: "Rejoindre/cr\xE9er une \xE9quipe",
  TEAMS: "\xC9quipes",
  CHALLENGE_TEAMS_DESCRIPTION: "Rejoignez-vous \xE0 une \xE9quipe existante ou cr\xE9ez v\xF4tre propre \xE9quipe pour relever le d\xE9fi ensemble!",
  JOIN_A_TEAM: "Rejoindre une \xE9quipe",
  JOIN_TEAM_DESCRIPTION: "Recherchez une \xE9quipe existante \xE0 rejoindre et participez \xE0 la comp\xE9tition ensemble!",
  SEARCH_FOR_TEAM: "Rechercher une \xE9quipe",
  CREATE_A_TEAM: "Cr\xE9er une \xE9quipe",
  CREATE_TEAM_DESCRIPTION: "Personnalisez votre \xE9quipe en d\xE9finissant votre propre avatar et votre propre nom. Invitez d'autres personnes \xE0 se joindre \xE0 vous!",
  UP_YOUR_GAME: "Am\xE9liorez votre niveau!",
  UP_YOUR_GAME_DESCRIPTION: "Rejoignez une \xE9quipe ou cr\xE9ez la v\xF4tre pour relever le d\xE9fi ensemble.",
  XTH_PLACE: "{currentRank, selectordinal, one {#\xE8re} other {#e} } place",
  LEADERBOARD_RANKING: "Classement",
  LEADERBOARD_USERNAME: "Nom d'utilisateur",
  INVITE_LINK_COPIED_TO_CLIPBOARD: "Le lien de l'invitation a \xE9t\xE9 copi\xE9 dans le presse-papiers!",
  DATE_AND_TIME: "Date et heure",
  SELECT_TEAM_AVATAR: "S\xE9lectionner l'avatar de l'\xE9quipe",
  CHANGE_TEAM_AVATAR: "Modifier l'avatar de l'\xE9quipe",
  TEAM_NAME_LABEL: "Nom de l'\xE9quipe",
  CREATE_TEAM: "Cr\xE9er une \xE9quipe",
  TEAM_NAME_ERROR: "Veuillez entrer un nom pour votre \xE9quipe.",
  SLIDE_OF_TOTAL: "Diapositive {key} sur {total}",
  PAGE_OF_TOTAL: "Page {current} sur {total}",
  NO_SOLUTIONS_AVAILABLE: "Nous sommes d\xE9sol\xE9s, aucune solution n'est disponible pour le moment.",
  SEE_ALL_ACHIEVEMENTS: "Voir toutes les r\xE9alisations",
  VIEW_ALL_ACHIEVEMENTS: "Voir toutes les r\xE9alisations",
  TAKE_ME_BACK: "Revenir en arri\xE8re",
  TEAMS_SELECT_AVATAR_DESCRIPTION: "Cet avatar appara\xEEt sur le profil de votre \xE9quipe et dans le classement.",
  CREATE_TEAM_SUCCESS: "Votre \xE9quipe est pr\xEAte!",
  CREATE_TEAM_SUCCESS_DESCRIPTION: "Commencez \xE0 constituer votre \xE9quipe. Partagez ce lien avec d'autres personnes afin de pouvoir r\xE9aliser des activit\xE9s ensemble.",
  VIEW_TEAM_DETAILS: "Afficher les d\xE9tails de l'\xE9quipe",
  FEATURES_HIGHLIGHT_CAROUSEL_LABEL: "Caract\xE9ristiques du carrousel",
  CHALLENGE_FAQ_HEADING: "Vous avez des questions sur les D\xE9fis?",
  CHALLENGE_FAQ_CONTENT: "Consultez notre {helpCenterLink} pour toutes vos questions fr\xE9quemment pos\xE9es.",
  VIEW_THIS_RESOURCE: "Voir cette ressource",
  RECOMMENDED_NEXT_STEP: "\xC9tape suivante recommand\xE9e",
  CARE_COLLECTIONS: "Collections de soins",
  PLAN_PROGRESS: "Progression du plan",
  SINCE_LAST_WEEK: "depuis la semaine derni\xE8re",
  INSIGHT_CARD_HEADER_DISTANCE: "Distance",
  INSIGHT_CARD_HEADER_STEPS: "Pas",
  MIN: "min",
  CAL: "Cal",
  KM: "km",
  INSIGHT_CARD_UNIT_STEPS: "{count, plural, one {pas} other {pas}}",
  INSIGHT_CARD_HEADER_FLOORS_CLIMBED: "\xC9tages mont\xE9s",
  INSIGHT_CARD_UNIT_FLOORS_CLIMBED: "{count, plural, one {\xE9tage} other {\xE9tages}}",
  INSIGHT_CARD_HEADER_ACTIVE_DURATION: "Minutes actives",
  INSIGHT_CARD_HEADER_ENERGY_BURNED: "\xC9nergie br\xFBl\xE9e",
  INSIGHT_CARD_HEADER_WEIGHT: "Poids",
  INSIGHT_CARD_HEADER_HEIGHT: "Taille",
  INSIGHT_CARD_HEADER_MINDFUL_DURATION: "Minutes de pleine conscience",
  INSIGHT_CARD_HEADER_WAIST_CIRCUMFERENCE: "Tour de taille",
  DAY_OF_THE_WEEK: "JOUR DE LA SEMAINE",
  DAY_OF_THE_MONTH: "JOUR DU MOIS",
  INSIGHT_CHART_WEEK_TITLE: "Graphique \xE0 barres hebdomadaire {type}",
  INSIGHT_CHART_MONTH_TITLE: "Graphique \xE0 barres {type} mensuel",
  INSIGHT_CHART_DISTANCE_WEEK_DESCRIPTION: "Le nombre de {unit} que vous avez march\xE9 chaque jour de la semaine.",
  INSIGHT_CHART_DISTANCE_MONTH_DESCRIPTION: "Le nombre de {unit} que vous avez march\xE9 chaque jour du mois.",
  INSIGHT_CHART_DISTANCE_DATUM_LABEL: "Vous avez march\xE9 {distance} {unit} le {date}",
  INSIGHT_CHART_STEPS_WEEK_DESCRIPTION: "Le nombre de pas que vous avez march\xE9 chaque jour de la semaine.",
  INSIGHT_CHART_STEPS_MONTH_DESCRIPTION: "Le nombre de pas que vous avez march\xE9 chaque jour du mois.",
  INSIGHT_CHART_STEPS_DATUM_LABEL: "Vous avez march\xE9 {distance} {unit} le {date}",
  INSIGHT_CHART_ENERGY_BURNED_WEEK_DESCRIPTION: "Le nombre de {unit} que vous avez br\xFBl\xE9 chaque jour de la semaine.",
  INSIGHT_CHART_ENERGY_BURNED_MONTH_DESCRIPTION: "Le nombre de {unit} que vous avez br\xFBl\xE9 chaque jour du mois.",
  INSIGHT_CHART_ENERGY_BURNED_DATUM_LABEL: "Vous avez br\xFBl\xE9 {energy} {unit} le {date}",
  INSIGHT_CHART_ACTIVE_DURATION_WEEK_DESCRIPTION: "Le nombre de minutes d'activit\xE9s pour chaque jour de la semaine.",
  INSIGHT_CHART_ACTIVE_DURATION_MONTH_DESCRIPTION: "Le nombre de minutes d'activit\xE9s chaque jour du mois.",
  INSIGHT_CHART_ACTIVE_DURATION_DATUM_LABEL: "Vous avez b\xE9n\xE9fici\xE9 de {value} minutes d'activit\xE9s le {date}",
  INSIGHT_CHART_FLOORS_CLIMBED_WEEK_DESCRIPTION: "Le nombre d'\xE9tages que vous avez mont\xE9s chaque jour de la semaine.",
  INSIGHT_CHART_FLOORS_CLIMBED_MONTH_DESCRIPTION: "Le nombre d'\xE9tages que vous avez mont\xE9s chaque jour du mois.",
  INSIGHT_CHART_FLOORS_CLIMBED_DATUM_LABEL: "Vous avez mont\xE9 {value} \xE9tages le {date}",
  INSIGHT_CHART_MINDFUL_DURATION_WEEK_DESCRIPTION: "Le nombre de minutes de pleine conscience pour chaque jour de la semaine.",
  INSIGHT_CHART_MINDFUL_DURATION_MONTH_DESCRIPTION: "Le nombre de minutes de pleine conscience chaque jour du mois.",
  INSIGHT_CHART_MINDFUL_DURATION_DATUM_LABEL: "Vous avez b\xE9n\xE9fici\xE9 de {value} minutes de pleine conscience le {date}",
  DATAPOINT_CATEGORY_ACTIVITY: "Activit\xE9",
  DATAPOINT_CATEGORY_BODY: "Corps",
  MANAGE_UNITS_APPLYING_CHANGES: "Vos modifications sont en cours d'application\u2026",
  MANAGE_UNITS_CHANGES_SAVED: "Modifications enregistr\xE9es \xE0 {time}",
  START_TRACKING_HEALTH_HEADER: "Commencez \xE0 suivre votre sant\xE9",
  START_TRACKING_HEALTH_BODY: "Faites facilement le suivi de vos mesures au fil du temps pour voir o\xF9 vous en \xEAtes et comment vous pouvez atteindre vos objectifs de sant\xE9.",
  BROWSE_SUPPORTED_DATA: "Que puis-je suivre?",
  LAST_UPDATED_CARRIER_DATE: "Derni\xE8re mise \xE0 jour\xA0: {date} de {carrier}",
  ACCUMULATION_PERIOD: "P\xE9riode d'accumulation\xA0: {start} - {end}",
  NO_DATA_AVAILABLE: "Aucune donn\xE9e disponible",
  LAST_7_DAYS: "7 derniers jours",
  LAST_30_DAYS: "30 derniers jours",
  OLDER: "Plus vieux",
  GET_ASSISTANCE_NOW: "Obtenir de l'aide maintenant",
  GET_ASSISTANCE_NOW_SUBHEADING: "Clavardez avec nos professionnels de la sant\xE9 agr\xE9\xE9s et notre service \xE0 la client\xE8le. Ils peuvent vous aider \xE0 \xE9pargner de l'argent en vous dirigeant aux meilleurs soins de sant\xE9 les plus abordables dans votre r\xE9gion, ainsi qu'\xE0 r\xE9pondre \xE0 vos questions sur vos avantages sociaux.",
  HOW_CAN_WE_HELP: "Comment pouvons-nous aider?",
  LIVE_BALANCE_SPEND: "{spentAmount} sur {totalAmount} d\xE9pens\xE9",
  LIVE_BALANCE_REMAINING: "{amount} restant",
  UPDATING_UNITS_OF_MEASURE: "Mise \xE0 jour des unit\xE9s de mesure",
  CHANGING_YOUR_UNITS: "La modification de vos unit\xE9s affectera la fa\xE7on dont elles sont affich\xE9es dans l'application.",
  MESSAGES: "Messages",
  MESSAGING_MESSAGES_LANDING_PAGE_TITLE: "Messages",
  SEND_NEW_MESSAGE: "Envoyer un nouveau message",
  NEW_MESSAGE_DEFAULT: "Ceci est le d\xE9but d'un nouveau message",
  NETWORK_MISSING_COVERAGE: "Votre r\xE9gime n'inclut aucune couverture {network}",
  CARD_FRONT_FILENAME: "{benefitName}-recto",
  CARD_BACK_FILENAME: "{benefitName}-verso",
  START_A_VISIT: "Commencez une visite",
  UNREAD: "Non lu",
  NO_MESSAGES_HEADING: "Aucun message pour le moment",
  NO_MESSAGES_DESCRIPTION: "Commencez par envoyer un nouveau message!",
  RETURN_TO: "Retour \xE0 {location}",
  NO_RECOMENDATIONS: "D\xE9sol\xE9, nous n'avons pas de recommandations \xE0 vous proposer dans ce domaine de sant\xE9 pour le moment.",
  CHALLENGES_LEGAL_DISCLAIMER: "Ce d\xE9fi se veut un moyen amusant pour tous de participer et d'avoir une chance \xE9quitable de gagner. Parfois, des prix en esp\xE8ces ou autres peuvent \xEAtre offerts par l'organisateur du d\xE9fi. League ne con\xE7oit pas la structure du d\xE9fi, ni si celui-ci offre des prix. Si vous avez des pr\xE9occupations concernant la structure de ce d\xE9fi ou si vous pensez avoir \xE9t\xE9 exclu de la chance de gagner, veuillez en parler \xE0 l'organisateur du d\xE9fi.",
  ALL_RECORDED_DATA: "Toutes les donn\xE9es enregistr\xE9es",
  NEW_MESSAGE: "Nouveau message",
  MESSAGE_SUBJECT: "Objet du message (facultatif)",
  THREAD_SUBJECT_MAX_LENGTH_ERROR: "Vous avez d\xE9pass\xE9 la limite maximale de caract\xE8res ({maximum})",
  CHAR_LIMIT_EXCEEDED: "Limite de caract\xE8res d\xE9pass\xE9e ({maximum})",
  MESSAGE_SUBJECT_PLACEHOLDER: "D\xE9finissez le sujet du message",
  TO: "\xC0",
  CREATE_MESSAGE: "Cr\xE9er un message",
  MEMBER_LABEL: "Membre",
  RESULT_COUNT: "{count, plural, one {{count,number} r\xE9sultat} other {{count,number} r\xE9sultats}}",
  USER_COLON: "{user} :",
  JOINED_CHALLENGE_HIGHLIGHT: "A rejoint <strong>{challengeTitle}</strong>!",
  CREATED_TEAM_HIGHLIGHT: "A cr\xE9\xE9 <strong>{teamName}</strong>!",
  JOINED_TEAM_HIGHLIGHT: "A rejoint <strong>{teamName}</strong>!",
  STEPS_WALKED_HIGHLIGHT: "<strong>A fait {total} pas hier!</strong>",
  ACTIVE_MINUTES_HIGHLIGHT: "<strong>A boug\xE9 pendant {total} minutes aujourd'hui!</strong>",
  MINDFUL_MINUTES_HIGHLIGHT: "<strong>Termin\xE9 {total} minutes !</strong>",
  EARNED_ACHIEVEMENT_HIGHLIGHT: "<strong>Objectif {achievement} atteint!</strong>",
  COMPLETED_ACTIVITY_HIGHLIGHT: "Une activit\xE9 a \xE9t\xE9 termin\xE9e!",
  NO_CARE_COLLECTIONS: "D\xE9sol\xE9, il n'y a aucune collection de soins disponible.",
  WRITE_A_MESSAGE: "\xC9crivez un message...",
  UPLOAD_MULTIPLE_FILES: "T\xE9l\xE9charger plusieurs fichiers",
  SEND: "Envoyer",
  SEND_MESSAGE: "Envoyer",
  DATA_SOURCES: "Sources de donn\xE9es",
  SOURCES_CAN_UPDATE: "Les sources ci-dessous sont autoris\xE9es \xE0 mettre \xE0 jour votre",
  WHEN_MULTIPLE_SOURCES_AVAILABLE: "Lorsque plusieurs sources sont disponibles, la source de donn\xE9es ayant la plus grande valeur sera enregistr\xE9e \xE0 la fin de la journ\xE9e (23h59).",
  APPLE_HEALTH: "Apple Sant\xE9",
  GOOGLE_FIT: "Google Fit",
  FITBIT: "Fitbit",
  GARMIN: "Garmin",
  POLAR: "Polar",
  WITHINGS: "Withings",
  HEALTH_PLAN: "Plan de sant\xE9",
  OMRON: "Omron",
  STRAVA: "Strava",
  IHEALTH: "iHealth",
  UPDATE_UNITS_OF_MEASURE_MODAL_TITLE: "Mise \xE0 jour des unit\xE9s de mesure",
  UPDATE_UNITS_OF_MEASURE_MODAL_DESCRIPTION: "La modification de vos unit\xE9s affectera la fa\xE7on dont elles sont affich\xE9es dans l'application",
  DOCUMENTS: "Documents",
  DOCUMENTS_DOCUMENTS_LANDING_PAGE_TITLE: "Documents",
  SHOW_RESULTS: "Afficher les r\xE9sultats",
  AVERAGE: "Moyenne",
  VIEW_ALL_METRIC_DATA: "Afficher toutes les donn\xE9es relatives \xE0 la mesure {metric}",
  EDIT_METRIC_DATA: "Modifier les donn\xE9es {metric}",
  NEXT_WEEK: "Semaine prochaine",
  PREVIOUS_WEEK: "Semaine derni\xE8re",
  NEXT_30_DAYS: "30 prochains jours",
  PREVIOUS_30_DAYS: "30 jours pr\xE9c\xE9dents",
  UNABLE_TO_CREATE_TEAM: "Impossible de cr\xE9er une \xE9quipe. Veuillez r\xE9essayer. Si vous avez d\xE9j\xE0 rejoint une \xE9quipe, vous devrez la quitter avant d'en cr\xE9er une autre.",
  START_TRACKING_METRIC: "Commencer \xE0 suivre {metric}",
  CURRENTLY_NOT_SHARING_DATA: "Vous ne partagez actuellement aucune donn\xE9e pour {metric}",
  SUCCESSFULLY_LEFT_TEAM: "Vous avez quitter {teamName}",
  LEAVE_TEAM_FAILURE: "Une erreur est survenue. Veuillez r\xE9essayer!",
  VIEW_DATA_SOURCES: "Afficher les sources de donn\xE9es",
  OR_CALL_PHONE: "ou appelez le {phoneNumber}{extension}",
  DOCUMENTS_NO_FILTERED_RESULTS_EMPTY_STATE_HEADING: "Aucun document ne correspond \xE0 vos filtres",
  DOCUMENTS_NO_FILTERED_RESULTS_EMPTY_STATE_DESCRIPTION: "Essayez de supprimer certains de vos filtres pour obtenir plus de r\xE9sultats",
  DOCUMENTS_EMPTY_STATE_HEADING: "Aucun document ici (pour l'instant!)",
  DOCUMENTS_EMPTY_STATE_DESCRIPTION: "Un seul endroit pour visualiser et organiser tous vos documents",
  LEADERBOARD_CURRENT_TEAM_NAME: "{team} (Votre \xE9quipe)",
  YOUR_CARE_ADVISOR: "Votre conseiller en soins",
  COMPOSE: "Composer",
  COMPOSE_NEW_MESSAGE: "Composer un nouveau message",
  POLICY_INFORMATION_UNAVAILABLE: "Il n'y a pas d'information disponible pour cette p\xE9riode contractuelle.",
  POLICY_INFORMATION_UNAVAILABLE_DEPENDENTS: "Il n'y a aucune information pour ce membre. Veuillez essayer un autre membre.",
  MESSAGE_THREADS_LIST_SUBTITLE: "La r\xE9ponse de notre \xE9quipe peut prendre jusqu'\xE0 2 jours ouvrables. S'il s'agit d'une urgence m\xE9dicale, appelez le 911.",
  ALL_MESSAGES_FOR_THREAD_BANNER: "Veuillez ne pas nous envoyer d'informations sp\xE9cifiques sur votre \xE9tat de sant\xE9 par le biais de ce clavardage.",
  TROUBLE_DISPLAYING_DATA: "Nous avons des difficult\xE9s \xE0 afficher vos donn\xE9es",
  RETRY: "R\xE9essayer",
  YOU: "Vous",
  MESSAGES_IN_CONVERSATION_TITLED: "Messages dans la conversation intitul\xE9e {subject}",
  TEAM_AVERAGE: "Moyenne de l'\xE9quipe",
  YOUR_METRICS: "Mes mesures",
  YOUR_METRICS_SUBTITLE: "Les donn\xE9es de sant\xE9 les plus r\xE9centes de vos applis et appareils connect\xE9s.",
  APPS_AND_DEVICES: "Applis et appareils",
  APP_AND_DEVICE_METRICS: "Mesures de l\u2019appli et de l\u2019appareil",
  VIEW_ALL_METRICS: "Afficher les mesures des applis et des appareils",
  RENAME: "Renommer",
  ENTER_DOCUMENT_NAME: "Veuillez ajouter un nom pour ce document",
  LOW_PRIORITY_ACTIVITY_ALT_TEXT: "Il s'agit d'une activit\xE9 peu prioritaire",
  MEDIUM_PRIORITY_ACTIVITY_ALT_TEXT: "Il s'agit d'une activit\xE9 de priorit\xE9 moyenne",
  HIGH_PRIORITY_ACTIVITY_ALT_TEXT: "Il s'agit d'une activit\xE9 de haute priorit\xE9",
  ACTIVITY_EXPIRY_DATE: "Expire le {date}",
  GENERIC_MESSAGING_ERROR: "Il semble qu'il y ait eu un probl\xE8me, veuillez rafra\xEEchir la page et r\xE9essayer.",
  VIEW_THE_ACTIVITIES: "Voir les activit\xE9s",
  DRAG_FILES_HERE_OR: "Faites glisser les fichiers ici ou",
  ADD_A_DOCUMENT: "Ajouter un document",
  ADD_DOCUMENT: "Ajouter un document",
  REMOVE_FILE: "Supprimer le fichier",
  REMOVE_FILE_FILENAME: "Supprimer le fichier : {filename}{fileSize}",
  UNABLE_TO_SEND: "Impossible d'envoyer, veuillez r\xE9essayer",
  ERROR_HEADING: "Quelque chose a mal tourn\xE9 de notre c\xF4t\xE9.",
  FILE_TYPE_NOT_SUPPORTED: "Ce type de fichier n'est pas pris en charge",
  USE_FILE_IN_ONE_OF_THESE_FORMATS: "Utilisez un fichier dans l'un de ces formats : {fileTypes}",
  RECENT_MESSAGES: "Messages r\xE9cents",
  NO_MESSAGES_YET: "Vous n'avez aucun message (pour le moment!)",
  NO_MESSAGES_DETAIL: "Votre conseiller en soins vous aidera \xE0 prendre des d\xE9cisions plus avis\xE9es en mati\xE8re de soins de sant\xE9, \xE0 chaque \xE9tape du parcours.",
  START_A_NEW_MESSAGE: "Commencer un nouveau message",
  USER_ADDED_DOCUMENT: "{user} a ajout\xE9 un document",
  ERROR_SAVING_TRY_AGAIN: "Erreur de sauvegarde des modifications. Veuillez r\xE9essayer",
  MODIFIED_ON_DATE: "Modifi\xE9 le {date}",
  FILE_TYPE_TOO_LARGE: "La taille du fichier est trop grande",
  MAXIMUM_FILE_SIZE_IS: "La taille de fichier maximale est {fileSize}\xA0MB.",
  FILE_TOO_LARGE: "Oups. Ce fichier est trop volumineux.",
  FILE_SHOULD_BE_UNDER: "Votre fichier doit \xEAtre inf\xE9rieur \xE0 {fileSize}",
  ATTACHMENT_LIMIT_REACHED: "Oups. Il y a trop de fichiers.",
  MAXIMUM_NUM_OF_ATTACHMENTS_ALLOWED: "{maxNumberOfDocs, plural, one {Vous pouvez joindre jusqu'\xE0 {maxNumberOfDocs,number} file.} other {Vous pouvez joindre jusqu'\xE0 {maxNumberOfDocs,number} files.}}",
  OOPS_FILE_TYPE_ISNT_SUPPORTED: "Oups. Ce type de fichier n'est pas pris en charge.",
  ATTACHMENT_TYPES_ALLOWED: "Vous pouvez joindre votre fichier dans ces formats : {fileTypes}",
  MESSAGES_PAGINATION_ERROR: "Impossible de charger les messages. <button>Essayez \xE0 nouveau.</button>",
  TRANSACTION_TABLE_CAPTION: "Historique des transactions",
  SELECT_PARTICIPANT_ERROR: "S\xE9lectionnez une personne \xE0 qui envoyer un message",
  PREVIEW_OF_FILE: "Aper\xE7u de {fileName}",
  VIEW_DOCUMENT_ACTIONS: "Afficher les actions {documentName}.",
  VISIT_LINK: "Visitez le lien",
  COMPLETE_BY_DATE: "\xC0 terminer avant le {date}",
  ERROR_UPLOADING_YOUR_FILE: "Erreur de chargement de votre fichier. Essayez \xE0 nouveau.",
  DOCUMENT_SUBMITTED: "Document soumis",
  YOUR_DOCUMENT_WILL_BE_AVAILABLE_SOON: "Votre document sera bient\xF4t disponible. Veuillez patienter quelques instants.",
  ERROR_RENAMING_YOUR_DOCUMENT: "Erreur de renommage de votre document. Essayez \xE0 nouveau.",
  DOCUMENT_RENAMED_SUCCESSFULLY: "Document renomm\xE9 avec succ\xE8s.",
  ERROR_HEADING_GENERIC: "Une erreur est survenue",
  ERROR_HEADING_NO_CONNECTION: "Aucune connexion Internet",
  ERROR_CAPTION_BACKEND: "Un probl\xE8me est survenu lors de la connexion \xE0 notre serveur. \n Veuillez r\xE9essayer plus tard.",
  ERROR_CAPTION_NO_CONNECTION: "Un probl\xE8me est survenu lors du chargement de vos donn\xE9es. \n Veuillez v\xE9rifier votre Internet et r\xE9essayer.",
  SURE_YOU_WANT_TO_DELETE: "\xCAtes-vous certain de vouloir supprimer {name}",
  CANNOT_BE_UNDONE: "Cette action est irr\xE9versible",
  DELETE_DOCUMENT: "Supprimer le document",
  DOCUMENT_DELETED: "Document supprim\xE9",
  ERROR_DELETING_YOUR_DOCUMENT: "Erreur lors de la suppression de votre document",
  ABOUT_ME: "\xC0 propos de moi",
  SEE_MORE: "EN SAVOIR PLUS",
  UNABLE_TO_LOAD_PAGE_TRY_AGAIN: "Nous n'arrivons pas \xE0 charger cette page. V\xE9rifiez votre Internet et r\xE9essayez.",
  WHO_IS_THIS_DOCUMENT_ABOUT: "\xC0 qui s'adresse le document?",
  SELECT_A_USER: "S\xE9lectionnez un utilisateur",
  SELECT_DOCUMENT: "S\xE9lectionner le document",
  THIS_HELPS_IDENTIFY_PERSON_DOCUMENT_RELATES_TO: "Cela aide votre conseiller en soins \xE0 identifier la personne \xE0 laquelle se rapporte ce document.",
  VIEW_ALL_MESSAGE_THREADS: "Voir tous les messages",
  TOGGLE_MENU: "Afficher la liste des messages",
  METRICS: "Mesures",
  UNREAD_MESSAGES: "Messages non lus",
  WITH_DOCUMENT: "avec document",
  X_TOKENS: "{tokenCount, plural, one {{tokenCount,number} jeton} other {{tokenCount,number} jetons}}",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_EYEBROW: "Programmes et d\xE9fis",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_HEADING: "Pr\xEAt \xE0 commencer?",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_DESCRIPTION: "Parcourez notre biblioth\xE8que pour trouver les programmes et d\xE9fis de sant\xE9 qui correspondent \xE0 vos objectifs personnels.",
  EXPLORE_LIBRARY: "Parcourir la biblioth\xE8que",
  YOUVE_GOT_THIS: "Vous pouvez le faire!",
  YOUVE_GOT_THIS_NAME: "Vous pouvez le faire, {firstName}!",
  CONFIGURABLE_JOURNEY_HEADER_SUB_TITLE: "Bienvenue dans votre exp\xE9rience Parcours sant\xE9!",
  HEALTH_JOURNEY_PAGE: "Page du Parcours Sant\xE9",
  VIEW_DETAILS: "Consulter les d\xE9tails",
  NEXT_ACTIVITY: "Activit\xE9 suivante",
  X_OF_Y_ACTIVITIES: "{completed} sur {total} activit\xE9s",
  X_PERCENTAGE: "{percent}%",
  SOLUTIONS: "Solutions",
  EXPLORE: "Parcourir",
  DOCUMENT_NAME_TOO_LONG: "Vous avez d\xE9pass\xE9 la limite maximale de caract\xE8res ({maximum})",
  CLAIM_PATIENT_NAME: "Pour\xA0: {patientName}",
  STANDALONE_ACTIVITIES_DESCRIPTION: "Aucun programme. Aucun d\xE9fi. Juste des activit\xE9s de temps en temps.",
  FEEDBACK_LINK_LABEL: "\xC9valuez l'information {value} sur {maximum} en termes d'utilit\xE9",
  RECENT_ACHIEVEMENTS: "R\xE9alisations r\xE9centes",
  ACHIEVEMENTS_BANNER_HEADER: "F\xE9licitations pour l'obtention de ces badges!",
  SINGLE_ACHIEVEMENT_DESCRIPTION: "Nous aimons vous voir prioriser votre sant\xE9 et votre bien-\xEAtre! D\xE9couvrez les autres r\xE9alisations vers lesquelles vous travaillez.",
  MULTIPLE_ACHIEVEMENT_DESCRIPTION: "Nous aimons vous voir prioriser votre sant\xE9 et votre bien-\xEAtre! D\xE9couvrez les autres r\xE9alisations que vous avez obtenues et celles vers lesquelles vous travaillez.",
  ACHIEVEMENTS_EMPTY_STATE_HEADER: "Rien de r\xE9alis\xE9 (pour l'instant!)",
  ACHIEVEMENTS_EMPTY_STATE_DESCRIPTION: "Terminez les activit\xE9s de votre parcours pour commencer \xE0 accumuler des r\xE9alisations.",
  HISTORY_EMPTY_STATE_HEADER: "Il n'y a rien \xE0 voir ici!",
  HISTORY_EMPTY_STATE_DESCRIPTION: "Lorsque vous terminez une activit\xE9, un programme ou un d\xE9fi, il appara\xEEt ici.",
  INDIVIDUAL_BALANCE: "{balance} de {membersFullName}",
  FAMILY_BALANCE: "Famille {balance}",
  UPCOMING: "\xC0 venir",
  REMOVED: "Supprim\xE9",
  COMPLETED_TODAY: "Compl\xE9t\xE9",
  CLAIMS_BENEFIT_CARD_TITLE: "R\xE9clamations d\u2019assurance",
  CLAIMS_BENEFIT_CARD_SUBTITLE: "Suivez les sommes que vous devez payer pour vos soins et le montant que l'assurance couvrira.",
  CLAIMS_FILTER_PROPERTY_TYPE: "Type de service",
  CLAIMS_FILTER_PROPERTY_STATUS: "Statut de la demande",
  CLAIMS_FILTER_PROPERTY_PATIENTNAME: "Membre",
  CLAIMS_FILTER_VALUE_ORAL: "Soins dentaires",
  CLAIMS_FILTER_VALUE_INSTITUTIONAL: "Institutionnel",
  CLAIMS_FILTER_VALUE_VISION: "Vue",
  CLAIMS_FILTER_VALUE_PHARMACY: "Pharmacie",
  CLAIMS_FILTER_VALUE_PROFESSIONAL: "Professionnel",
  CLAIMS_FILTER_VALUE_APPROVED: "Nous jouerons notre r\xF4le",
  CLAIMS_FILTER_VALUE_PENDING: "Traitement",
  CLAIMS_FILTER_VALUE_PARTIALLY_PAID: "Partiellement couvert",
  CLAIMS_FILTER_VALUE_NOT_COVERED: "Non couvert",
  CLAIMS_FILTER_VALUE_ADJUSTED: "Ajust\xE9",
  DRINKS_PER_WEEK: "Boissons par semaine",
  OR_SELECT_BETWEEN_THESE: "ou s\xE9lectionnez l'une des options suivantes",
  CLAIMS_FILTER_PROPERTY_SERVICEDATE: "Fourchette de dates",
  CLAIMS_FILTER_VALUE_YEAR_TO_DATE: "Depuis le d\xE9but de l'ann\xE9e",
  CLAIMS_FILTER_VALUE_PRIOR_YEAR: "Ann\xE9e pr\xE9c\xE9dente",
  CLAIMS_FILTER_VALUE_LAST_12_MONTHS: "12 derniers mois",
  CLAIMS_FILTER_VALUE_LAST_2_YEARS: "2 derni\xE8res ann\xE9es",
  CHALLENGE_TYPE_GROUP_TAG: "Groupe",
  CHALLENGE_TYPE_SOLO_TAG: "Solo",
  VIEW_ALL_GROUP_CHALLENGES_HEADING: "D\xE9fis de groupe",
  VIEW_ALL_SOLO_CHALLENGES_HEADING: "D\xE9fis en solo",
  VIEW_ALL_CHALLENGES_DESCRIPTION_GROUP: "Restez responsable lorsque vous vous mettez au d\xE9fi avec un travail de pleine conscience, des initiatives en mati\xE8re d'alimentation saine, des comp\xE9titions de fitness, des activit\xE9s de r\xE9duction du stress, des d\xE9fis de pas, et bien plus encore.",
  VIEW_ALL_CHALLENGES_DESCRIPTION_SOLO: "Lancez-vous en solo et mettez-vous au d\xE9fi de r\xE9aliser des activit\xE9s ax\xE9es sur le conditionnement physique, la nutrition, la sant\xE9 mentale, la gestion du stress, et bien d'autres choses encore.",
  HELPFUL_LINKS: "Liens utiles",
  HOW_CLAIMS_WORK: "Comment fonctionnent les r\xE9clamations",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TITLE: "Comprendre le fonctionnement de vos r\xE9clamations",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TEXT: "<p>Lorsque vous consultez l'un des m\xE9decins de votre r\xE9seau, il demande \xE0 \xEAtre pay\xE9. Si vous devez payer une quote-part, il la per\xE7oit aupr\xE8s de vous et soumet ensuite une demande de remboursement \xE0 la compagnie d'assurance.</p><p>Nous examinons alors votre r\xE9gime d'assurance, \xE9galement appel\xE9 contrat de garanties, afin de d\xE9terminer si le service est couvert. Si c'est le cas, nous l'approuverons sur la base des termes du contrat de garanties. Si le service n'est pas couvert par votre r\xE9gime d'assurance, il vous incombe de le payer.</p>",
  CLAIMS_STATUS_DEFINITIONS: "D\xE9finitions de l\u2019\xE9tat de la demande",
  CLAIMS_STATUS_DEFINITION_APPROVED: '"Nous jouerons notre r\xF4le" signifie que la r\xE9clamation est approuv\xE9e et que nous acceptons de payer une partie ou la totalit\xE9 de la r\xE9clamation en fonction de votre r\xE9gime.',
  CLAIMS_STATUS_DEFINITION_PENDING: '"Traitement" signifie que nous sommes en train de d\xE9terminer qui doit quoi.',
  CLAIMS_STATUS_DEFINITION_PARTIALLY_PAID: '"Partiellement couvert" signifie que nous couvrirons une partie de votre r\xE9clamation.',
  CLAIMS_STATUS_DEFINITION_NOT_COVERED: `"Non couvert" signifie que le service n'est pas couvert par votre r\xE9gime d'avantages sociaux et que vous devrez le payer.`,
  CLAIMS_STATUS_DEFINITION_ADJUSTED: '"Ajust\xE9" signifie que quelque chose a chang\xE9 et que nous avons d\xFB r\xE9examiner cette demande.',
  YOUR_COST: "Votre co\xFBt :",
  CLAIMS_SERVICE_TYPE: "{type, select, institutional {R\xE9clamation m\xE9dicale} oral {R\xE9clamation dentaire} vision {R\xE9clamation pour les soins de la vue} pharmacy {R\xE9clamation pharmaceutique} professional {R\xE9clamation professionnelle} other {R\xE9clamation}}",
  FILTER_BY: "Filtrer par",
  CLAIMS_LIST_EMPTY_HEADING: "Rien ici pour l'instant!",
  CLAIMS_LIST_EMPTY_MESSAGE: "Les demandes soumises s'afficheront ici.",
  CLAIMS_GENERIC_ERROR_HEADING: "Une erreur est survenue",
  CLAIMS_GENERIC_ERROR_MESSAGE: "Il y a eu un probl\xE8me technique de notre c\xF4t\xE9.{br}Veuillez r\xE9essayer dans quelques minutes.",
  CLAIMS_SUMMARY_PAGE_SUB_HEADING: "V\xE9rifiez ce que votre assurance a pris en charge et ce que vous devez encore \xE0 votre prestataire. Vous pouvez acc\xE9der \xE0 vos demandes de remboursement soumises dans les deux ann\xE9es pr\xE9c\xE9dant la date d'aujourd'hui.",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING: "Aucun r\xE9sultats",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE: "{filterCount, plural, one {Aucune demande ne correspond au filter que vous avez choisi.} other {Aucune demande ne correspond au filters que vous avez choisi.}}",
  VIEW_MY_PROFILE: "Voir mon profil",
  PLAN_PROGRESS_COST_COVERAGE: "Progression et cotisation du r\xE9gime",
  PLAN_PROGRESS_POP_UP_LABEL: "Qu\u2019est-ce qu\u2019un {title}?",
  RECENT_CLAIMS_LIST_EMPTY: `Les demandes soumises au cours des 90 derniers jours s'affichent ici. Vous pouvez acc\xE9der \xE0 toutes les demandes en s\xE9lectionnant "Voir tout". `,
  DOWNLOAD_CLAIMS: "T\xE9l\xE9charger les demandes",
  PLAIN_SOMETHING_WENT_WRONG: "Une erreur est survenue",
  CLAIMS_SUMMARY_DOWNLOAD_ERROR: "Un probl\xE8me est survenu lors du t\xE9l\xE9chargement de vos demandes.",
  WALLET_WITH_CLAIMS_LANDING_TITLE: "Les informations sur vos avantages sociaux, vos r\xE9clamations et votre bien-\xEAtre r\xE9unis \xE0 un seul endroit.",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_HEADING: "Pr\xEAt \xE0 commencer?",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_BODY: "Parcourez notre biblioth\xE8que pour trouver les programmes et d\xE9fis de sant\xE9 qui correspondent \xE0 vos objectifs personnels.",
  USER_DROPDOWN_BTN_LABEL: "Menu du profil",
  PROVIDER_SERVICE_POPOVER_BUTTON_NAME: "Qu\u2019est-ce qu\u2019une quote-part et une coassurance?",
  ANSWERS_NOT_SAVED: "Nous ne sommes pas en mesure d'enregistrer vos r\xE9ponses pour le moment. Veuillez r\xE9essayer plus tard.",
  SESSION_ABOUT_TO_TIMEOUT: "Vous avez \xE9t\xE9 inactif pendant un certain temps et votre session est sur le point d'expirer. Voulez-vous continuer votre session?",
  SESSION_TIMEOUT: "Expiration de la session",
  CONTINUE_SESSION: "Continuer la session",
  SESSION_LOG_OUT: "Se d\xE9connecter",
  ORDER_NEW_CARD_ADDRESS_SELECT_HEADING: "S\xE9lectionnez une adresse de livraison",
  ORDER_NEW_CARD_MEMBER_SELECT_HEADING: "Qui a besoin d\u2019une nouvelle carte?",
  ORDER_NEW_CARD_MEMBER_SELECT_HELP_TEXT: "S\xE9lectionnez un ou plusieurs membres.",
  DEFAULT_ADDRESS: "Adresse par d\xE9faut",
  CHOOSE_NEW_ADDRESS: "Choisissez une nouvelle adresse",
  CHOOSE_NEW_ADDRESS_HINT: "Indiquez une autre adresse postale pour la livraison de la carte. Cela ne modifiera pas l'adresse par d\xE9faut de votre compte.",
  CARD_ACTIONS: "Actions de carte",
  EARN_ACHIEVEMENT_COMPLETING_ACTIVITIES_CHALLENGE: "Obtenez une r\xE9alisation en effectuant toutes les activit\xE9s de ce d\xE9fi.",
  CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER: "Il n'y a rien \xE0 voir ici!",
  CHALLENGE_ACTIVITY_UP_NEXT: "Suivant",
  CHALLENGE_ACTIVITY_UP_NEXT_EMPTY_STATE: "Rendez-vous ici lorsque le d\xE9fi commencera!",
  CHALLENGE_ACTIVITY_COMPLETED: "Termin\xE9es",
  CHALLENGE_ACTIVITY_COMPLETED_EMPTY_STATE: "Les activit\xE9s que vous avez termin\xE9es appara\xEEtront ici.",
  CHALLENGE_ACTIVITY_MISSED: "Manqu\xE9es",
  CHALLENGE_ACTIVITY_MISSED_EMPTY_STATE: "Les activit\xE9s que vous avez manqu\xE9es appara\xEEtront ici.",
  CHALLENGE_COMPLETED_TITLE: "Nous avons termin\xE9!",
  CHALLENGE_COMPLETED_BODY: "Il ne reste plus d'activit\xE9s \xE0 r\xE9aliser. Bon travail!",
  ACHIEVEMENT_EARNED: "C\xE9l\xE9bration de la r\xE9alisation",
  ACHIEVEMENT_PROGRESS: "Progression des r\xE9alisations",
  ADD_DATA: "Ajouter des donn\xE9es",
  CONFIRM_DETAILS: "Confirmez vos coordonn\xE9es",
  MEDICAL_ID_CARD: "Carte d'identit\xE9 m\xE9dicale",
  NEW_ADDRESS: "Nouvelle adresse de livraison",
  MESSAGE_CENTER: "Centre de messagerie",
  MESSAGING_MESSAGING_QUESTIONNAIRE_PAGE_TITLE: "Messagerie",
  CHOOSE_NEW_ADDRESS_DESC: "Indiquez une autre adresse postale pour la livraison de la carte. Cela ne modifiera pas l'adresse par d\xE9faut de votre compte. L'adresse postale doit \xEAtre situ\xE9e aux \xC9tats-Unis.",
  SELECT_STATE: "S\xE9lectionner un \xE9tat",
  REQUIRED_FIELD: "{field} est un champ obligatoire",
  CLAIMS_YOUR_COST: "Votre co\xFBt",
  CLAIMS_PROCESSING_DESCRIPTION: "Nous sommes en train de traiter cette demande. Vous serez inform\xE9 lorsqu'elle sera pr\xEAte \xE0 \xEAtre examin\xE9e.",
  DOWNLOAD_BENEFITS_EXPLANATION: "T\xE9l\xE9charger les d\xE9tails des avantages",
  DATA_COLLECTED: "Donn\xE9es collect\xE9es {date}",
  MEMBER_CARD_ON_ITS_WAY: "Votre nouvelle carte d'identit\xE9 de membre est en route.",
  MEMBER_CARD_ARRIVAL: "La nouvelle carte d'identit\xE9 de membre sera livr\xE9e dans un d\xE9lai d'environ 10 jours ouvrables.",
  TRY_LATER: "Veuillez r\xE9essayer plus tard",
  RESUBMIT: "Resoumettre",
  ORDER_NEW_CARD_HEADING: "Commander une nouvelle carte",
  CANCEL_ORDER_NEW_CARD_TITLE: "\xCAtes-vous s\xFBr de vouloir annuler votre commande?",
  CANCEL_ORDER_NEW_CARD_DESC: "Vous pouvez toujours revenir plus tard.",
  CANCEL_ORDER: "Annuler la commande",
  STEP: "\xC9tape",
  ORDER_CARD: "Carte de commande",
  PLEASE_MAKE_A_SELECTION: "Veuillez faire une s\xE9lection",
  TOTAL_COST_OVERVIEW: "Aper\xE7u du co\xFBt total",
  TOTAL_COST_DESCRIPTION: "La somme des co\xFBts des services de votre demande. Cela n\u2019inclut pas les paiements que vous avez effectu\xE9s \xE0 votre prestataire, comme les quotes-parts.",
  SUPPORT: "Soutien",
  GET_SUPPORT: "Obtenir de l\u2019aide",
  MESSAGE_WITH_A_MEMBER: "Envoyez un message \xE0 un conseiller pour obtenir de l\u2019aide relative aux questions sur vos demandes de r\xE8glement concernant vos prestations ou vos soins.",
  CLAIMS_SERVICE_DETAILS_HEADING: "D\xE9tails du service",
  CLAIMS_ADDITIONAL_RESOURCES_HEADING: "Ressources suppl\xE9mentaires",
  CLAIMS_SERVICE_DETAILS_SUBHEADING: "Une r\xE9partition des services individuels que vous avez re\xE7us et de leurs co\xFBts associ\xE9s.",
  CLAIMS_SERVICE_DETAILS_SERVICE: "Service",
  CLAIMS_SERVICE_DETAILS_PHARMACY_SERVICE: "Nom de Rx",
  CLAIMS_SERVICE_DETAILS_DATE: "Service",
  CLAIMS_SERVICE_DETAILS_SERVICE_PROCEDURE_CODE: "Code de proc\xE9dure",
  CLAIMS_SERVICE_DETAILS_SERVICE_RX_NUMBER: "Num\xE9ro Rx",
  CLAIMS_SERVICE_DETAILS_SERVICE_YOUR_COST: "Votre co\xFBt",
  CLAIMS_SERVICE_DETAILS_SERVICE_COST_DETAILS: "D\xE9tails des co\xFBts",
  CLAIMS_SERVICE_DETAILS_SHOW_COST_DETAILS: "Afficher les d\xE9tails des co\xFBts",
  CLAIMS_SERVICE_DETAILS_HIDE_COST_DETAILS: "Masquer les d\xE9tails des co\xFBts",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_HEADING: "R\xE9partition de votre co\xFBt",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_SUBHEADING: "Les montants ci-dessous servent \xE0 la progression de votre r\xE9gime",
  WALLET_ORDER_NEW_CARD_SELECT_MEMBER_ERROR: "S\xE9lectionnez un ou plusieurs membres pour continuer",
  WALLET_INVALID_CHARACTER_ERROR_MESSAGE: "Le champ contient des caract\xE8res non valides",
  CLAIMS_COST_DETAILS_PROVIDER_CHARGED: "Prestataire factur\xE9",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE: "Autre assurance a pay\xE9",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT: "Votre rabais de membre",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP: "Votre r\xE9gime a n\xE9goci\xE9 avec votre prestataire un tarif pr\xE9f\xE9rentiel.",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP_LABEL: "Explication de la r\xE9duction accord\xE9e aux membres",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP: "Le montant pay\xE9 par votre autre assurance.",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP_LABEL: 'Explication de "votre autre assurance a pay\xE9"',
  CLAIMS_COST_DETAILS_WE_PAID_ON: "{paymentDate, select, other {Nous avons pay\xE9 le {paymentDate}} undefined {Nous avons pay\xE9}}",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP: "Le montant couvert par votre r\xE9gime pour les services de soins de sant\xE9.",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP_LABEL: 'Explication de "votre r\xE9gime a pay\xE9"',
  CLAIMS_COST_DETAILS_YOUR_COST: "Votre co\xFBt",
  CLAIMS_SERVICE_DETAILS_SERVICE_REMARK: "Remarque sur le service",
  CLAIMS_SERVICE_NETWORK_IN_NETWORK: "En r\xE9seau",
  CLAIMS_SERVICE_NETWORK_OUT_OF_NETWORK: "Hors r\xE9seau",
  WALLET_ORDER_NEW_CARD_SELECT_ADDRESS_OPTION_ERROR: "S\xE9lectionnez une option d'adresse pour continuer",
  WALLET_ORDER_NEW_CARD_NO_CITY_NUMBERS_ERROR: "La ville ne peut pas contenir de chiffres",
  MESSAGE_CLOSED_TEXT: "Ce message a \xE9t\xE9 envoy\xE9.",
  CLAIMS_PLAN_PROGRESS_DESCRIPTION: "Obtenez un aper\xE7u de vos co\xFBts cumul\xE9s, de vos niveaux de couverture et plus encore.",
  VIEW_PLAN_PROGRESS: "Afficher la progression du plan",
  CLAIMS_BILL_PROVIDER_DESCRIPTION: "Vous recevrez une facture associ\xE9e \xE0 cette demande de la part de votre fournisseur.",
  CLAIMS_EXPLANATION_OF_BENEFITS_DOWNLOAD_ERROR: "Un probl\xE8me est survenu lors du t\xE9l\xE9chargement des d\xE9tails de vos avantages.",
  END_CHAT_MODAL_DESCRIPTION: "Continuer mettra fin au clavardage. Vous ne pourrez plus revenir sur cette conversation \xE0 l'avenir.",
  RETURN_TO_CHAT: "Retourner au clavardage",
  CHATS_IN_CONVERSATION: "Clavardages en direct",
  LIVE_CHAT_CHARACTER_LIMIT: "Limite de caract\xE8res atteinte ({characterLimit})",
  CHAT_MESSAGE_INPUT: "Saisie du message de clavardage",
  CLAIMS_SERVICE_LINE_ITEM_LABEL: "{code, select, deductible {Deductible} non_covered {Non couvert} copayment {Copayment} coinsurance {Coinsurance} may_be_billed {May Be Billed} amount_exceeding_maximum {Amount Exceeding Maximum} additional_member_liability {Additional Member Liability} special_processing {Special Processing} paid_to_member {Paid To Member} plan_paid_to_you {Plan Paid To You} other {Other}}",
  QUESTIONNAIRE_FLOW_NEW_MESSAGE: "Nouveau message",
  QUESTIONNAIRE_FLOW_CLOSE: "Fermer",
  QUESTIONNAIRE_FLOW_GO_BACK: "Retour",
  QUESTIONNAIRE_FLOW_CONTINUE: "Continuer",
  QUESTIONNAIRE_FLOW_RETRY: "R\xE9essayer",
  CLEAR_ALL: "Tout effacer",
  HEALTH_REPORT_PAGE_HEADING: "Votre rapport de sant\xE9",
  USERNAME_HAS_JOINED_THE_CHAT: "{username} a rejoint le clavardage",
  USERNAME_HAS_LEFT_THE_CHAT: "{username} a quitt\xE9 le clavardage",
  PERVIOUS_MONTH: "Mois pr\xE9c\xE9dent",
  NEXT_MONTH: "Mois prochain",
  CHAT_CLOSED: "Le clavardage est termin\xE9.",
  CONNECTING_YOU_WITH_AN_AGENT: "Vous mettre en relation avec un agent...",
  LAST_DAY_TO_USE_BALANCE: "Dernier jour pour utiliser le solde",
  LAST_DAY_TO_SUBMIT_CLAIMS: "Dernier jour pour soumettre des r\xE9clamations",
  LIVE_CHAT_GENERIC_ERROR_TITLE: "Une erreur est survenue",
  LIVE_CHAT_GENERIC_ERROR_DESCRIPTION: "Un probl\xE8me est survenu, veuillez r\xE9essayer.",
  LIVE_CHAT_GENERIC_TOAST_ERROR_TITLE: "Une erreur est survenue",
  LIVE_CHAT_GENERIC_TOAST_ERROR_DESCRIPTION: "Un probl\xE8me est survenu, veuillez r\xE9essayer.",
  LIVE_CHAT_GENERIC_ERROR_BUTTON: "Fermer",
  LIVE_CHAT_LANDING_PAGE_TITLE: "Clavardage",
  LIVE_CHAT_DELIVERY_FAILURE: "Non livr\xE9",
  LIVE_CHAT_RESEND_MESSAGE: "Renvoyer le message",
  LIVE_CHAT_MESSAGE_FAILED_TITLE: "Le message n'a pas pu \xEAtre envoy\xE9",
  LIVE_CHAT_MESSAGE_FAILED_BODY: "D\xE9sol\xE9, il semble que votre message n'ait pas \xE9t\xE9 transmis \xE0 notre \xE9quipe.",
  VIEW_TOOLTIP: "afficher l'info-bulle {tooltipLabel}",
  NO_DATA_SOURCES: "Aucune source de donn\xE9es",
  MAX_VALUE_ERROR_MESSAGE: "Veuillez saisir une valeur inf\xE9rieure \xE0 {max}",
  MIN_VALUE_ERROR_MESSAGE: "Veuillez saisir une valeur sup\xE9rieure \xE0 {min}",
  NO_VALUE_SELECTED_ERROR_MESSAGE: "Veuillez s\xE9lectionner une valeur",
  START_DATE_MUST_BE_EARLIER_ERROR_MESSAGE: "La date de d\xE9but doit \xEAtre ant\xE9rieure \xE0 la date de fin.",
  DURATION_EXCEEDS_24_HOURS_ERROR_MESSAGE: "La dur\xE9e ne peut exc\xE9der 24 heures",
  NO_FUTURE_DATES: "La date ne peut pas \xEAtre dans le futur",
  CLAIMS_REMOVE_FILTER: "Supprimer le filtre {label}.",
  REMOVE_X_FILTER: "Supprimer le filtre {label}.",
  WALLET_BENEFIT_STATUS_PENDING: "En attente",
  WALLET_BENEFIT_STATUS_ACTIVE: "Actif",
  WALLET_BENEFIT_STATUS_PAST: "Pass\xE9",
  WALLET_LANDING_BENEFITS_EMPTY_STATE_TITLE: "Rien ici pour l'instant!",
  WALLET_LANDING_BENEFITS_EMPTY_STATE_DESCRIPTION: "Les avantages actifs appara\xEEtront ici.",
  BENEFITS_BENEFITS_LANDING_PAGE_TITLE: "Avantages sociaux",
  CLAIMS_CLAIMS_SUMMARY_PAGE_TITLE: "Demandes",
  CLAIMS_CLAIMS_DETAIL_PAGE_TITLE: "D\xE9tails de la demande",
  CLAIMS_CLAIMS_DETAIL_WITH_TITLE_PAGE_TITLE: "D\xE9tails de la demande - {title}",
  SHOW: "Afficher",
  NUMBER_OF_ENTRIES: "{number}\xA0entr\xE9es",
  WAIST_CIRCUMFERENCE: "Tour de taille",
  BMI: "IMC",
  BLOOD_PRESSURE: "Pression sanguine",
  TOTAL_CHOLESTEROL: "Cholest\xE9rol total",
  TRIGLYCERIDES: "Triglyc\xE9rides",
  CHOLESTEROL_HDL: "Cholest\xE9rol HDL",
  CHOLESTEROL_LDL: "Cholest\xE9rol LDL",
  FASTING_BLOOD_GLUCOSE: "Glyc\xE9mie \xE0 jeun",
  NON_FASTING_BLOOD_GLUCOSE: "Glyc\xE9mie non \xE0 jeun"
};

// src/es-MX.json
var es_MX_default = {
  COMPOSE_NEW_MESSAGE: "Redactar un nuevo mensaje",
  SEND_MESSAGE: "Enviar mensaje",
  UPLOAD_MULTIPLE_FILES: "Subir varios archivos",
  ATTACHMENT_TYPES_ALLOWED: "Puedes adjuntar tu archivo en estos formatos: {fileTypes}",
  OOPS_FILE_TYPE_ISNT_SUPPORTED: "Ups. Ese tipo de archivo no es compatible.",
  FILE_SHOULD_BE_UNDER: "Tu archivo debe tener menos de {fileSize}",
  FILE_TOO_LARGE: "Ups. Ese archivo es demasiado grande.",
  NO_FUTURE_DATES: "La fecha no puede ser en el futuro",
  DURATION_EXCEEDS_24_HOURS_ERROR_MESSAGE: "La duraci\xF3n no puede exceder las 24 horas",
  START_DATE_MUST_BE_EARLIER_ERROR_MESSAGE: "La fecha de inicio debe ser anterior a la fecha de finalizaci\xF3n",
  NO_VALUE_SELECTED_ERROR_MESSAGE: "Selecciona un valor",
  MIN_VALUE_ERROR_MESSAGE: "Introduce un valor superior a {min}",
  MAX_VALUE_ERROR_MESSAGE: "Introduce un valor inferior a {max}",
  MAXIMUM_NUM_OF_ATTACHMENTS_ALLOWED: "Puedes adjuntar hasta {maxNumberOfDocs} archivos.",
  ATTACHMENT_LIMIT_REACHED: "Ups. Son demasiados archivos.",
  CS_ACTIVITY_OVERRIDE_DATE_PERIOD: "*Campo obligatorio, la fecha debe estar entre la fecha de inicio y la fecha de finalizaci\xF3n",
  BY_WAIVER_CREDIT_TOOL: "por Waiver Credit Tool",
  METRIC_INTEGER_INPUT_HINT: "El n\xFAmero debe ser el total de un per\xEDodo de 24 horas",
  NO_DATA_SOURCES: "Sin fuentes de datos",
  TOOLBOX_VALIDATION_MULTI_SELECT_REQUIRED: "Haz una selecci\xF3n",
  TOOLBOX_VALIDATION_DATE_INPUT_REQUIRED: "Haz una selecci\xF3n",
  CLAIMS_SERVICE_DETAILS_PHARMACY_SERVICE: "Nombre del recetario (Rx)",
  UPDATE_UNITS_OF_MEASURE_MODAL_DESCRIPTION: "El cambio de tus unidades afectar\xE1 a la forma en que se muestran en la aplicaci\xF3n",
  UPDATE_UNITS_OF_MEASURE_MODAL_TITLE: "Actualizaci\xF3n de unidades de medida",
  VIEW_TOOLTIP: "ver {tooltipLabel} tooltip",
  HEALTH_PLAN: "Plan de salud",
  CONNECTED_DEVICES_IMAGE_ALT: "Persona revisando los datos del dispositivo conectado",
  CONNECT_DEVICES_LEARN_MORE: "M\xE1s informaci\xF3n",
  PAGE_OF_TOTAL: "P\xE1gina {current} de {total}",
  LIVE_CHAT_GENERIC_TOAST_ERROR_DESCRIPTION: "Se ha producido un problema, int\xE9ntalo de nuevo",
  LIVE_CHAT_GENERIC_TOAST_ERROR_TITLE: "Algo sali\xF3 mal",
  LIVE_CHAT_MESSAGE_FAILED_BODY: "Lo sentimos, parece que tu mensaje no ha llegado a nuestro equipo.",
  LIVE_CHAT_MESSAGE_FAILED_TITLE: "Error al enviar el mensaje",
  LIVE_CHAT_RESEND_MESSAGE: "Reenviar mensaje",
  LIVE_CHAT_DELIVERY_FAILURE: "No entregado",
  LIVE_CHAT_LANDING_PAGE_TITLE: "Chat",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP_LABEL: "Explicaci\xF3n de tu plan pagado",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP_LABEL: "Explicaci\xF3n de otro seguro pagado",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP_LABEL: "Explicaci\xF3n del descuento para miembros",
  METRIC_DETAILS: "Detalles de m\xE9tricas",
  EDIT_METRIC_DATA: "Edit datos de {metric}",
  CLAIMS_SERVICE_DETAILS_SERVICE_RX_NUMBER: "N\xFAmero de receta",
  CLAIMS_SERVICE_NETWORK_OUT_OF_NETWORK: "Fuera de la red",
  CLAIMS_SERVICE_NETWORK_IN_NETWORK: "Dentro de la red",
  LIVE_CHAT_GENERIC_ERROR_BUTTON: "Cerrar",
  LIVE_CHAT_GENERIC_ERROR_DESCRIPTION: "Se ha producido un problema, int\xE9ntalo de nuevo",
  LIVE_CHAT_GENERIC_ERROR_TITLE: "Algo sali\xF3 mal",
  CS_EMPTY_CONSENT_FORMS: "El miembro no tiene ning\xFAn formulario de consentimiento.",
  CS_EXPIRED_DEFINITION: "El miembro no ha iniciado ni completado la tarea y el per\xEDodo de validaci\xF3n ha finalizado.",
  CS_STATUS_LABELS: "Etiquetas de estatus",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP: "El monto que paga su otro seguro.",
  CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE: "Otro seguro pagado",
  LAST_DAY_TO_SUBMIT_CLAIMS: "\xDAltimo d\xEDa para presentar reclamaciones",
  LAST_DAY_TO_USE_BALANCE: "\xDAltimo d\xEDa para utilizar el saldo",
  CHAT_CLOSED: "Este chat ha sido cerrado.",
  CONNECTING_YOU_WITH_AN_AGENT: "Conect\xE1ndote con un agente...",
  NEXT_MONTH: "Bot\xF3n del pr\xF3ximo mes",
  PERVIOUS_MONTH: "Bot\xF3n del mes anterior",
  USERNAME_HAS_LEFT_THE_CHAT: "{username} ha abandonado el chat",
  USERNAME_HAS_JOINED_THE_CHAT: "{username} se ha unido al chat",
  HEALTH_REPORT_PAGE_HEADING: "Tu informe de salud",
  CLAIMS_PLAN_PROGRESS_DESCRIPTION: "Obtenga una visi\xF3n general de sus costes acumulados, niveles de cobertura y mucho m\xE1s.",
  CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP: "El monto que tu plan cubri\xF3 por servicios de atenci\xF3n m\xE9dica.",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP: "Tu plan negoci\xF3 con tu proveedor para ofrecerte una tarifa con descuento.",
  CLAIMS_SERVICE_DETAILS_DATE: "Servicio",
  CLAIMS_ADDITIONAL_RESOURCES_HEADING: "Recursos adicionales",
  CLAIMS_SERVICE_TYPE: "{type, select, institutional {Reclamaciones m\xE9dicas} oral {Reclamaciones dentales} vision {Reclamaci\xF3n de asistencia oftalmol\xF3gica} pharmacy {Reclamaciones farmac\xE9uticas} professional {Reclamaciones profesionales} other {Reclamaciones}}",
  KG: "kg",
  LB: "lb",
  IN: "en",
  CM: "cm",
  CONNECT_A_DEVICE: "Conectar un dispositivo",
  INSIGHT_CARD_HEADER_WAIST_CIRCUMFERENCE: "Circunferencia de la cintura",
  CLEAR_ALL: "Limpiar todo",
  CLAIMS_SERVICE_TYPE_SUFFIX_PROFESSIONAL: "Reclamaci\xF3n profesional",
  QUESTIONNAIRE_FLOW_RETRY: "Reintentar",
  QUESTIONNAIRE_FLOW_CONTINUE: "Continuar",
  QUESTIONNAIRE_FLOW_GO_BACK: "Volver atr\xE1s",
  QUESTIONNAIRE_FLOW_CLOSE: "Cerrar",
  QUESTIONNAIRE_FLOW_NEW_MESSAGE: "Nuevo mensaje",
  REWARDS_ID_UNDERSCORE: "Rewards_ID: {rewardId}",
  VIEW_ALL_CHALLENGES_DESCRIPTION_SOLO: "Ve por libre y desaf\xEDate a ti mismo a completar grupos de actividades centradas en la forma f\xEDsica, la nutrici\xF3n, la salud mental, la gesti\xF3n del estr\xE9s y mucho m\xE1s.",
  VIEW_ALL_CHALLENGES_DESCRIPTION_GROUP: "Mantente responsable mientras te retas a ti mismo con trabajo de atenci\xF3n plena, iniciativas de alimentaci\xF3n sana, competiciones de fitness, actividades de reducci\xF3n del estr\xE9s, retos de pasos y mucho m\xE1s.",
  LATEST_INSIGHTS_METRICS_AND_MORE: "\xDAltimas observaciones, m\xE9tricas y m\xE1s",
  VIEW_MY_HEALTH_DASHBOARD: "Ver mi panel de salud",
  CLAIMS_SERVICE_LINE_ITEM_LABEL: "{code, select, deductible {Deducible} copayment {Copago} coinsurance {Coaseguro} may_be_billed {Se puede facturar} amount_exceeding_maximum {Cantidad que supera el m\xE1ximo} additional_member_liability {Responsabilidad adicional del miembro} special_processing {Procesamiento especial} medicare_paid {Pagado por Medicare} paid_to_member {Pagado al miembro} paid_by_other_insurance {Pagado por otro seguro} plan_paid_to_you {Plan pagado a ti} other {Otros}}",
  CHAT_MESSAGE_INPUT: "Entrada de mensajes de chat",
  LIVE_CHAT_CHARACTER_LIMIT: "L\xEDmite de caracteres alcanzado ({characterLimit})",
  ENTER_YOUR_HEIGHT_IN_INCHES: "Introduce tu altura en pulgadas",
  ENTER_YOUR_HEIGHT_IN_FEET: "Introduce tu altura en pies",
  ENTER_YOUR_HEIGHT_IN_CENTIMETERS: "Introduce tu altura en cent\xEDmetros",
  ENTER_YOUR_WEIGHT_IN_POUNDS: "Introduce tu peso en libras",
  ENTER_YOUR_WEIGHT_IN_KILOGRAMS: "Introduce tu peso en kilogramos",
  TOOLBOX_VALIDATION_HEIGHT_MAXIMUM: "La altura debe ser como m\xE1ximo de {value}{unit}",
  TOOLBOX_VALIDATION_HEIGHT_MINIMUM: "La altura debe ser al menos {value}{unit}",
  TOOLBOX_VALIDATION_WEIGHT_MAXIMUM: "El peso debe ser como m\xE1ximo de {value}{unit}",
  TOOLBOX_VALIDATION_WEIGHT_MINIMUM: "El peso debe ser al menos {value}{unit}",
  RETURN_TO_CHAT: "Volver al chat",
  END_CHAT_MODAL_DESCRIPTION: "Continuar finalizar\xE1 el chat. No podr\xE1s volver a esta conversaci\xF3n en el futuro.",
  CHATS_IN_CONVERSATION: "Chats en conversaci\xF3n",
  CLAIMS_SERVICE_BANNER_REMARKS_CODE_IN_EOB: "C\xF3digo de comentarios en EOB: {code}",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_SUBHEADING: "Los montos a continuaci\xF3n se destinan al progreso de tu plan.",
  CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_HEADING: "Desglose de tu coste",
  CLAIMS_EXPLANATION_OF_BENEFITS_DOWNLOAD_ERROR: "Hubo un problema al descargar tu explicaci\xF3n de beneficios.",
  "SUPPORT_AGENT_NOT_FOUND ": "Ha ocurrido un problema al descargar tu explicaci\xF3n sobre los beneficios.",
  WALLET_ORDER_NEW_CARD_NO_CITY_NUMBERS_ERROR: "La ciudad no puede contener n\xFAmeros",
  CLAIMS_BILL_PROVIDER_DESCRIPTION: "Recibir\xE1s de tu proveedor una factura asociada a esta reclamaci\xF3n.",
  VIEW_PLAN_PROGRESS: "Ver el progreso del plan",
  MESSAGE_CLOSED_TEXT: "Este mensaje ha sido entregado.",
  CLAIMS_COST_DETAILS_WE_PAID: "Pagamos",
  CLAIMS_SERVICE_DETAILS_SERVICE_REMARK: "Observaci\xF3n de servicio",
  CLAIMS_SERVICE_BANNER_VIEW_BENEFITS_BOOKLET: "Ver folleto de beneficios",
  WALLET_INVALID_CHARACTER_ERROR_MESSAGE: "El campo contiene caracteres no v\xE1lidos",
  WALLET_ORDER_NEW_CARD_SELECT_ADDRESS_OPTION_ERROR: "Selecciona una opci\xF3n de direcci\xF3n para continuar",
  WALLET_ORDER_NEW_CARD_SELECT_MEMBER_ERROR: "Selecciona uno o m\xE1s miembros para continuar",
  CLAIMS_COST_DETAILS_YOUR_COST: "Tu coste",
  CLAIMS_COST_DETAILS_WE_PAID_ON: "{paymentDate, select, other {Pagamos el {paymentDate, date, medium}} undefined {Pagamos}}",
  CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT: "Tu descuento de miembro",
  CLAIMS_COST_DETAILS_PROVIDER_CHARGED: "Proveedor cobrado",
  CLAIMS_SERVICE_DETAILS_HIDE_COST_DETAILS: "Ocultar detalles de costes",
  CLAIMS_SERVICE_DETAILS_SHOW_COST_DETAILS: "Mostrar detalles de costes",
  CLAIMS_SERVICE_DETAILS_SERVICE_COST_DETAILS: "Detalles de coste",
  CLAIMS_SERVICE_DETAILS_SERVICE_YOUR_COST: "Tu coste",
  CLAIMS_SERVICE_DETAILS_SERVICE_PROCEDURE_CODE: "C\xF3digo de procedimiento",
  CLAIMS_SERVICE_DETAILS_SERVICE: "Servicio",
  CLAIMS_SERVICE_DETAILS_SUBHEADING: "Un desglose de los servicios individuales que recibiste y los costes asociados a ellos.",
  CLAIMS_SERVICE_DETAILS_HEADING: "Detalles del servicio",
  MESSAGE_WITH_A_MEMBER: "Habla con un asesor de miembros para que te ayude con las reclamaciones sobre tus beneficios o cuidados.",
  GET_SUPPORT: "Obtener apoyo",
  SUPPORT: "Apoyo",
  TOTAL_COST_DESCRIPTION: "La suma de los costes de los servicios de tu reclamaci\xF3n. No incluye los pagos que hiciste a tu proveedor, como los copagos.",
  TOTAL_COST_OVERVIEW: "Resumen del coste total",
  ORDER_CARD: "Tarjeta de pedido",
  STEP: "Paso",
  DATA_TYPE_HINT_STRING: "El punto de datos espera un string (texto)",
  DATA_TYPE_HINT_NUMBER: "El punto de datos espera un n\xFAmero o decimal",
  DATA_TYPE_HINT_INT: "El punto de datos espera un n\xFAmero entero (integer)",
  DATA_TYPE_HINT_BOOLEAN: "El punto de datos espera que sea verdadero o falso (booleano)",
  DATA_TYPE_HINT_DATETIME: "El punto de datos espera una fecha y/o una hora",
  PLEASE_MAKE_A_SELECTION: "Haz una selecci\xF3n",
  CANCEL_ORDER: "Cancelar pedido",
  CANCEL_ORDER_NEW_CARD_DESC: "Siempre puedes volver m\xE1s tarde.",
  CANCEL_ORDER_NEW_CARD_TITLE: "\xBFEst\xE1s seguro de que deseas cancelar tu pedido?",
  ORDER_NEW_CARD_HEADING: "Pedir una nueva tarjeta",
  RESUBMIT: "Reenviar",
  TRY_LATER: "Intenta de nuevo m\xE1s tarde.",
  MEMBER_CARD_ARRIVAL: "La(s) nueva(s) tarjeta(s) de identificaci\xF3n de miembro llegar\xE1(n) en aproximadamente 10 d\xEDas laborables.",
  MEMBER_CARD_ON_ITS_WAY: "Tu nueva tarjeta de identificaci\xF3n de miembro est\xE1 en camino.",
  X_OF_Y_COMPLETED_WITH_UNIT: "<span>{progress}</span> / {goal} {unit}",
  REWARDS_PROGRAM_ELIGIBLE: "Programa de recompensas elegible",
  DATA_COLLECTED: "Datos recogidos el {date}",
  DOWNLOAD_BENEFITS_EXPLANATION: "Descargar Explicaci\xF3n de beneficios",
  CLAIMS_BILL_DESCRIPTION: "Recibir\xE1s de tu proveedor una factura asociada a esta reclamaci\xF3n.",
  CLAIMS_PROCESSING_DESCRIPTION: "Todav\xEDa estamos procesando esta reclamaci\xF3n. Te avisaremos cuando est\xE9 lista para que la revises.",
  CLAIMS_YOUR_COST: "Tu coste",
  REQUIRED_FIELD: "{field} es un campo obligatorio",
  SELECT_STATE: "Selecciona un estado",
  CHOOSE_NEW_ADDRESS_DESC: "Proporciona una direcci\xF3n postal diferente para la entrega de la tarjeta. Esto no cambiar\xE1 la direcci\xF3n predeterminada de tu cuenta. La direcci\xF3n postal debe estar dentro de Estados Unidos.",
  NEW_ADDRESS: "Nueva direcci\xF3n de entrega",
  MEDICAL_ID_CARD: "Tarjeta de identificaci\xF3n m\xE9dica",
  CONFIRM_DETAILS: "Confirma tus datos",
  ENTER_VALID_DATA_POINT: "Introduce un punto de datos v\xE1lido",
  CHOOSE_NEW_ADDRESS_HINT: "Proporciona una direcci\xF3n postal diferente para la entrega de la tarjeta. Esto no cambiar\xE1 la direcci\xF3n predeterminada de tu cuenta.",
  CHOOSE_NEW_ADDRESS: "Elige una nueva direcci\xF3n",
  DEFAULT_ADDRESS: "Direcci\xF3n predeterminada",
  TEAM_AVERAGE: "Promedio del equipo",
  LEAVE_TEAM_DESCRIPTION: "\xBFSeguro que quieres dejar {teamName}? Tu puntuaci\xF3n ya no se contar\xE1 en el promedio del equipo.",
  MESSAGE_CENTER: "Centro de mensajes",
  CARD_ACTIONS: "Acciones de tarjeta",
  MINDFUL_MINUTES_HIGHLIGHT: "<strong>\xA1Completado {total} minutos!</strong>",
  COMPLETE_BY_DATE: "Completa antes del {date}",
  PART_OF_REWARDS_PROGRAM: "Parte del programa de recompensas",
  X_LEAGUE_POINTS: "{points} Puntos League",
  X_REWARD_POINTS: "{points} Puntos de recompensa",
  TOOLTIP_ACTION_DESCRIPTION: "Ver el criterio de clasificaci\xF3n",
  ADD_DATA: "A\xF1adir datos",
  EARN_ACHIEVEMENT_COMPLETING_ACTIVITIES_CHALLENGE: "Consigue un logro por completar todas las actividades de este reto",
  ACHIEVEMENT_PROGRESS: "Progreso de logros",
  ACHIEVEMENT_EARNED: "Celebraci\xF3n de logros obtenidos",
  CHALLENGE_COMPLETED_BODY: "No hay m\xE1s actividades que completar. \xA1Bien hecho!",
  CHALLENGE_COMPLETED_TITLE: "\xA1Se acab\xF3!",
  CHALLENGE_ACTIVITY_MISSED_EMPTY_STATE: "Las actividades que te pierdas aparecer\xE1n aqu\xED.",
  CHALLENGE_ACTIVITY_MISSED: "Perdido/s ({count})",
  CHALLENGE_ACTIVITY_COMPLETED_EMPTY_STATE: "Las actividades que completes aparecer\xE1n aqu\xED.",
  CHALLENGE_ACTIVITY_COMPLETED: "Completado/s ({count})",
  CHALLENGE_ACTIVITY_UP_NEXT_EMPTY_STATE: "\xA1Vuelve cuando empiece el reto!",
  CHALLENGE_ACTIVITY_UP_NEXT: "A continuaci\xF3n ({count})",
  CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER: "No hay nada aqu\xED... \xA1todav\xEDa!",
  ACTIVITY_COUNT_EDIT: "Editar {unit}",
  ORDER_NEW_CARD_ADDRESS_SELECT_HEADING: "Selecciona una direcci\xF3n de env\xEDo",
  REQUEST_WAIT: "Espera mientras completamos tu solicitud",
  RECOMMENDED_DEVICE_DESCRIPTION: "Aseg\xFArate de que los miembros en la web utilizan la versi\xF3n m\xE1s reciente de Chrome, Firefox, Safari y Microsoft Edge, y la \xFAltima versi\xF3n de la aplicaci\xF3n de iOS v2.13.4 y Android v2.14.8.",
  ORDER_NEW_CARD_MEMBER_SELECT_HELP_TEXT: "Selecciona uno o varios miembros.",
  ORDER_NEW_CARD_MEMBER_SELECT_HEADING: "\xBFQui\xE9n necesita una nueva tarjeta?",
  SESSION_LOG_OUT: "Cerrar sesi\xF3n",
  CONTINUE_SESSION: "Continuar sesi\xF3n",
  SESSION_TIMEOUT: "L\xEDmite de tiempo de la sesi\xF3n",
  SESSION_ABOUT_TO_TIMEOUT: "Has estado inactivo durante un tiempo y tu sesi\xF3n est\xE1 a punto de finalizar. \xBFQuieres continuar la sesi\xF3n?",
  COMPLETED_ACTIVITY_HIGHLIGHT: "\xA1Completaste una actividad!",
  ANSWERS_NOT_SAVED: "No podemos guardar tus respuestas en este momento. Vuelve a intentarlo m\xE1s tarde",
  PROVIDER_SERVICE_POPOVER_BUTTON_NAME: "\xBFQu\xE9 es un copago y un coseguro?",
  CHANGE_TEAM_AVATAR: "Cambiar avatar de equipo",
  SELECT_TEAM_AVATAR: "Seleccionar avatar de equipo",
  BENEFIT_DEPENDENTS: "Dependientes del beneficio",
  CHAR_LIMIT_EXCEEDED: "Se ha superado el l\xEDmite de caracteres ({maximum})",
  USER_DROPDOWN_BTN_LABEL: "Men\xFA de perfil",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_BODY: "Navega por nuestra biblioteca para encontrar Programas y Retos de salud que se ajusten a tus objetivos personales.",
  NO_CHALLENGES_PROGRAMS_EMPTY_STATE_HEADING: "\xBFListo para empezar?",
  WALLET_WITH_CLAIMS_LANDING_TITLE: "Tus beneficios, reclamaciones e informaci\xF3n sobre bienestar, todo en un solo lugar.",
  NO_BENEFITS_AVAILABLE_BODY: "El miembro no tiene beneficios en este momento.",
  CLAIMS_SUMMARY_DOWNLOAD_ERROR: "Se ha producido un problema al descargar tus reclamaciones.",
  PLAIN_SOMETHING_WENT_WRONG: "Algo sali\xF3 mal",
  HEALTH_PROGRAM: "Programa de salud",
  REQUIRED: "Requerido",
  REWARD_POINTS_MISSED: "Puntos de recompensa perdidos",
  REWARD_POINTS_EARNED: "Puntos de recompensa ganados",
  REWARD_POINTS: "Puntos de recompensa",
  ENDED_DAY_AT_TIME: "Termin\xF3 el {day}",
  DOWNLOAD_CLAIMS: "Descargar reclamaciones",
  SIGN_UP_PERIOD_PASSED_DETAIL: "Ya no puedes inscribirte en este desaf\xEDo porque el per\xEDodo de inscripci\xF3n ha pasado.",
  ENDED_ON_DATE: "Termin\xF3 el {date}",
  SIGN_UP_PERIOD_PASSED: "Periodo de inscripci\xF3n superado",
  AVAILABLE: "Disponible",
  VIEW_THE_ACTIVITIES: "Ver las actividades",
  SPONSOR_LOGO: "{name} logotipo",
  ENDED: "Terminado",
  PROGRAM_CREATED_BY: "Programa creado por",
  RECENT_CLAIMS_LIST_EMPTY: 'Las reclamaciones enviadas en los \xFAltimos 90 d\xEDas aparecer\xE1n aqu\xED. Puedes acceder a todas las reclamaciones seleccionando "Ver todo". ',
  PLAN_PROGRESS_POP_UP_LABEL: "\xBFQu\xE9 es un/a {title}?",
  PLAN_PROGRESS_COST_COVERAGE: "Progreso y costes del plan",
  TOOLBOX_VALIDATION_FIELD_CANNOT_BE_EMPTY: "El campo no puede estar vac\xEDo cuando se selecciona",
  TOOLBOX_VALIDATION_SELECT_OPTIONS_TO_CONTINUE: "Selecciona las opciones {integer} para continuar",
  TOOLBOX_VALIDATION_SELECT_MAX_SELECTION: "Selecciona un m\xE1ximo de {integer} opciones",
  TOOLBOX_VALIDATION_ENTER_WHOLE_NUMBER: "Introduce un n\xFAmero entero",
  DISCLAIMER: "Descargo de responsabilidad",
  TOOLBOX_VALIDATION_SELECT_DATE_EARLIER: "Selecciona una fecha anterior al {date, date, medium}",
  TOOLBOX_VALIDATION_SELECT_DATE_LATER: "Selecciona una fecha posterior al {date, date, medium}",
  TOOLBOX_VALIDATION_SELECTION_REQUIRED: "Haz una selecci\xF3n",
  VIEW_MY_PROFILE: "Ver mi perfil",
  TOOLBOX_VALIDATION_REQUIRED_FIELD: "Este es un campo obligatorio",
  TOOLBOX_VALIDATION_NUMBER_MAXIMUM: "Introduce un n\xFAmero igual o inferior a {value}",
  TOOLBOX_VALIDATION_NUMBER_MINIMUM: "Introduce un n\xFAmero igual o superior a {value}",
  TOOLBOX_VALIDATION_MAXIMUM_CHARACTERS: "El l\xEDmite de caracteres es {limit}",
  THREAD_SUBJECT_MAX_LENGTH_ERROR: "Has superado el l\xEDmite m\xE1ximo de caracteres ({maximum})",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE: "Ninguna reclamaci\xF3n coincide con {filterCount, plural, one {filtro} other {filtros}} que has elegido",
  CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING: "Sin resultados",
  HISTORY_EMPTY_STATE_DESCRIPTION: "Cuando completes una actividad, programa o reto, aparecer\xE1 aqu\xED.",
  HISTORY_EMPTY_STATE_HEADER: "No hay nada aqu\xED... \xA1todav\xEDa!",
  TOOLBOX_VALIDATION_MONTH_YEAR: "Selecciona un mes y un a\xF1o",
  TOOLBOX_VALIDATION_DAY_MONTH_YEAR: "Selecciona un d\xEDa, un mes y un a\xF1o",
  COMPLETED_ON_DATE: "Completado el {date}",
  THIS_CHALLENGE_HAS_ENDED: "Este reto ha terminado",
  CLAIMS_SUMMARY_PAGE_SUB_HEADING: "Ve lo que tu seguro ha cubierto y lo que a\xFAn puedes deber a tu proveedor. Puedes acceder a tus reclamaciones enviadas en los dos a\xF1os anteriores a la fecha de hoy.",
  THIS_CHALLENGE_RUNS_YEAR_ROUND: "Este reto dura todo el a\xF1o",
  CLAIMS_GENERIC_ERROR_MESSAGE: "Se ha producido un problema por nuestra parte.{br}Por favor, int\xE9ntalo de nuevo en unos minutos.",
  CLAIMS_GENERIC_ERROR_HEADING: "Algo sali\xF3 mal",
  CLAIMS_LIST_EMPTY_MESSAGE: "Las reclamaciones que se env\xEDen aparecer\xE1n aqu\xED.",
  CLAIMS_LIST_EMPTY_HEADING: "\xA1Nada por aqu\xED todav\xEDa!",
  CLAIMS_SERVICE_TYPE_SUFFIX_ORAL: "Reclamaci\xF3n dental",
  CLAIMS_SERVICE_TYPE_SUFFIX_INSTITUTIONAL: "Reclamaci\xF3n m\xE9dica",
  CLAIMS_FILTER_VALUE_ORAL: "Dental",
  CHECK_CHALLENGE_DETAILS: "Consulta los detalles del reto para familiarizarte con las actividades",
  YOURE_GOOD_TO_GO: "\xA1Ya est\xE1s listo!",
  LEARN_MORE_ABOUT_PRIVACY_POLICY: "Aprende m\xE1s sobre c\xF3mo League gestiona y utiliza tus datos en nuestra <a>pol\xEDtica de privacidad.</a>",
  SHARE_CHALLENGE_PROGRESS_WITH_EMPLOYER: "Comparta el progreso de su desaf\xEDo con su empleador",
  TRACK_MANUALLY_CONFIRM_CONNECT_LATER_DESCRIPTION: "A\xFAn puedes conectar un dispositivo m\xE1s adelante",
  TRACK_CHALLENGE_MANUALLY_CHANGE_LATER: "Si eliges rastrear manualmente, a\xFAn puedes conectar un dispositivo m\xE1s adelante. {learnMoreLink} sobre el seguimiento manual de tu progreso.",
  FILTER_BY: "Filtrar por",
  CLAIMS_SERVICE_TYPE_SUFFIX_PHARMACY: "Reclamaci\xF3n de farmacia",
  CLAIMS_SERVICE_TYPE_SUFFIX_VISION: "Reclamaci\xF3n de visi\xF3n",
  CLAIMS_SERVICE_TYPE_SUFFIX_DENTAL: "Reclamaci\xF3n dental",
  CLAIMS_SERVICE_TYPE_SUFFIX_MEDICAL: "Reclamaci\xF3n m\xE9dica",
  YOUR_COST: "Tu coste:",
  VIEW_ALL_SOLO_CHALLENGES_DESCRIPTION: "Ponte a prueba yendo solo y completando grupos de actividades diarias por tu cuenta.",
  VIEW_ALL_GROUP_CHALLENGES_DESCRIPTION: "\xBFTe sientes motivado? Ponte a prueba siendo responsable de estas ofertas.",
  VIEW_ALL_SOLO_CHALLENGES_HEADING: "Retos individuales",
  VIEW_ALL_GROUP_CHALLENGES_HEADING: "Retos de grupo",
  CHALLENGE_TYPE_SOLO_TAG: "Individual",
  CHALLENGE_TYPE_GROUP_TAG: "Grupo",
  CLAIMS_STATUS_DEFINITION_ADJUSTED: "Ajustado significa que algo ha cambiado aqu\xED, as\xED que tuvimos que echar otro vistazo a esta reclamaci\xF3n.",
  CLAIMS_STATUS_DEFINITION_NOT_COVERED: "Sin cobertura significa que el servicio no est\xE1 cubierto por tu plan de beneficios y tendr\xE1s que pagarlo.",
  CLAIMS_STATUS_DEFINITION_PARTIALLY_PAID: "Cobertura parcial significa que cubriremos una parte de tu reclamaci\xF3n.",
  CLAIMS_STATUS_DEFINITION_PENDING: "Procesando significa que estamos averiguando qui\xE9n debe qu\xE9.",
  CLAIMS_STATUS_DEFINITION_APPROVED: "Cumpliremos nuestra parte significa que la reclamaci\xF3n se aprueba y que aceptamos pagar una parte o la totalidad de la reclamaci\xF3n en funci\xF3n de tu plan.",
  CLAIMS_STATUS_DEFINITIONS: "Definiciones del estatus de reclamaci\xF3n",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TEXT: "<p>Cuando visitas a uno de los m\xE9dicos de tu red, te solicitan el pago. Si tienes un copago, te lo cobran y luego env\xEDan la reclamaci\xF3n a la compa\xF1\xEDa de seguros.</p><p>A continuaci\xF3n, revisamos tu plan de seguro, tambi\xE9n conocido como contrato de beneficios, para determinar si el servicio est\xE1 cubierto. Si lo est\xE1, lo aprobaremos seg\xFAn las condiciones del contrato de prestaciones. Si no est\xE1 cubierto como parte de tu plan de beneficios, eres responsable de pagar el servicio.</p>",
  UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TITLE: "Entender c\xF3mo funcionan tus reclamaciones",
  X_PERCENT_COMPLETE: "{number}% Completo",
  CHALLENGE_PROGRESS: "Progreso del reto",
  SOLO_CHALLENGE: "Reto individual",
  GROUP_CHALLENGE: "Reto grupal",
  ACTIVITY_INPUT_FREE_TEXT: "Introduce tu propio valor",
  CLAIMS_BENEFIT_CARD_SUBTITLE: "Lleva la cuenta de lo que debes por tu asistencia y cu\xE1nto cubrir\xE1 el seguro",
  CLAIMS_BENEFIT_CARD_TITLE: "Reclamaciones de seguros",
  HOW_CLAIMS_WORK: "C\xF3mo funcionan las reclamaciones",
  HELPFUL_LINKS: "Enlaces \xFAtiles",
  CLAIMS_FILTER_VALUE_LAST_2_YEARS: "\xDAltimos 2 a\xF1os",
  CLAIMS_FILTER_VALUE_LAST_12_MONTHS: "\xDAltimos 12 meses",
  CLAIMS_FILTER_VALUE_PRIOR_YEAR: "A\xF1o anterior",
  CLAIMS_FILTER_VALUE_YEAR_TO_DATE: "A\xF1o hasta la fecha",
  CLAIMS_FILTER_PROPERTY_SERVICEDATE: "Rango de fechas",
  CLAIMS_FILTER_VALUE_ADJUSTED: "Ajustado",
  CLAIMS_FILTER_VALUE_NOT_COVERED: "Sin cobertura",
  CLAIMS_FILTER_VALUE_PARTIALLY_PAID: "Cobertura parcial",
  CLAIMS_FILTER_VALUE_PENDING: "Procesando",
  CLAIMS_FILTER_VALUE_APPROVED: "Haremos nuestra parte",
  CLAIMS_FILTER_VALUE_PROFESSIONAL: "Profesional",
  CLAIMS_FILTER_VALUE_INSTITUTIONAL: "Institucional",
  CLAIMS_FILTER_VALUE_PHARMACY: "Farmacia",
  CLAIMS_FILTER_VALUE_VISION: "Visi\xF3n",
  CLAIMS_FILTER_VALUE_MEDICAL: "M\xE9dico",
  CLAIMS_FILTER_VALUE_DENTAL: "Dental",
  CLAIMS_FILTER_PROPERTY_PATIENTNAME: "Miembro",
  CLAIMS_FILTER_PROPERTY_STATUS: "Estatus de reclamaci\xF3n",
  CLAIMS_FILTER_PROPERTY_TYPE: "Tipo de servicio",
  DRINKS_PER_WEEK: "Bebidas por semana",
  OR_SELECT_BETWEEN_THESE: "o seleccionar entre estos",
  LATEST_APP_VERSION: "\xDAltima versi\xF3n de la aplicaci\xF3n",
  DISMISS_TOAST: "Descartar notificaci\xF3n",
  COMPLETED_TODAY: "Completado",
  REMOVED: "Remoto",
  UPCOMING: "Por venir",
  VIEW_ALL_STANDALONE_ACTIVITIES: "Ver todas las actividades independientes",
  FAMILY_BALANCE: "Familia {balance}",
  INDIVIDUAL_BALANCE: "{balance} de {membersFullName}",
  SEE_MORE_MISSED_ACTIVITIES_ARIA_LABEL: "Ver m\xE1s actividades perdidas",
  SEE_MORE_COMPLETED_ACTIVITIES_ARIA_LABEL: "Ver m\xE1s actividades completadas",
  SEE_MORE_ACTIVITIES: "Ver m\xE1s",
  ACHIEVEMENTS_EMPTY_STATE_DESCRIPTION: "Completa las actividades de tu Trayectoria para empezar a conseguir logros.",
  ACHIEVEMENTS_EMPTY_STATE_HEADER: "Sin logros (\xA1todav\xEDa!)",
  MULTIPLE_ACHIEVEMENT_DESCRIPTION: "\xA1Nos encanta ver que das prioridad a tu salud y bienestar! \xC9chale un vistazo a otros logros que has ganado y a aquellos en los que est\xE1s trabajando.",
  SINGLE_ACHIEVEMENT_DESCRIPTION: "\xA1Nos encanta ver que das prioridad a tu salud y bienestar! \xC9chale un vistazo a otros logros en los que est\xE1s trabajando.",
  ACHIEVEMENTS_BANNER_HEADER: "\xA1Felicitaciones por ganar estas insignias!",
  RECENT_ACHIEVEMENTS: "Logros recientes",
  SESSION_TIME: "Duraci\xF3n de la sesi\xF3n (minutos/segundos)",
  LOG_IN_HISTORY: "historial de inicio de sesi\xF3n",
  MEMBER_DEVICE_OS: "Dispositivo o sistema operativo",
  STANDALONE_ACTIVITIES_EMPTY_STATE: "\xA1Nada que hacer aqu\xED todav\xEDa! Vuelve m\xE1s tarde.",
  DOLLAR_AMOUNT: "${amount}",
  CLAIM_PATIENT_NAME: "Para: {patientName}",
  FEEDBACK_LINK_LABEL: "Califica la informaci\xF3n de {value} sobre {maximum} en utilidad",
  STANDALONE_ACTIVITIES_DESCRIPTION: "Sin Programas. Ni Retos. S\xF3lo actividades puntuales.",
  VIEW_ALL_MISSED_ACTIVITIES_ARIA_LABEL: "Ver todas las actividades perdidas",
  VIEW_ALL_COMPLETED_ACTIVITIES_ARIA_LABEL: "Ver todas las actividades completadas",
  EXPLORE: "Explorar",
  DOCUMENT_NAME_TOO_LONG: "Has superado el l\xEDmite m\xE1ximo de caracteres ({maximum})",
  STANDALONE_ACTIVITIES: "Actividades independientes",
  DISPLAYING_ACTIVITIES_FROM_DATE: "Mostrando actividades desde {date}",
  SOLUTIONS: "Soluciones",
  X_PERCENTAGE: "{percent}%",
  X_OF_Y_ACTIVITIES: "{completed} de {total} actividades",
  NEXT_ACTIVITY: "Siguiente actividad",
  VIEW_DETAILS: "Ver detalles",
  HEALTH_JOURNEY_PAGE: "P\xE1gina de Trayectoria de salud",
  YOUVE_GOT_THIS_NAME: "\xA1Lo tienes, {firstName}!",
  YOUVE_GOT_THIS: "\xA1Lo tienes!",
  MISSED_ACTIVITIES_EMPTY_STATE: "Cuando te pierdas actividades, \xA1aparecer\xE1n aqu\xED!",
  MISSED_ACTIVITIES: "Actividades perdidas",
  COMPLETED_ACTIVITIES_EMPTY_STATE: "Cuando completes actividades, \xA1aparecer\xE1n aqu\xED!",
  COMPLETED_ACTIVITIES: "Actividades completadas",
  EXPLORE_LIBRARY: "Explorar la biblioteca",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_DESCRIPTION: "Navega por nuestra biblioteca para encontrar Programas y Retos de salud que se ajusten a tus objetivos personales.",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_HEADING: "\xBFListo para empezar?",
  NO_CONFIGURABLE_ACTIVITIES_EMPTY_STATE_EYEBROW: "Programas y retos",
  X_TOKENS: "{tokenCount, plural, one {# ficha} other {# fichas}}",
  WITH_DOCUMENT: "con documento",
  REMOVE_FILE_FILENAME: "Eliminar archivo: {filename}",
  START_X_MORE_PROGRAMS_PLURALIZED: "Inicia {duration, plural, one {# programa m\xE1s} other {# programas m\xE1s}}. Mant\xE9n el impulso.",
  UNREAD_MESSAGES: "Mensajes no le\xEDdos",
  METRICS: "M\xE9tricas",
  TOGGLE_MENU: "Alternar lista de mensajes",
  VIEW_ALL_MESSAGE_THREADS: "Ver todos los hilos de mensajes",
  LINK_OUT_MESSAGE: "Debes ver",
  THIS_HELPS_IDENTIFY_PERSON_DOCUMENT_RELATES_TO: "Esto ayuda a tu Asesor de atenci\xF3n a identificar a la persona a la que se refiere este documento.",
  SELECT_DOCUMENT: "Seleccionar documento",
  SELECT_A_USER: "Selecciona un usuario",
  WHO_IS_THIS_DOCUMENT_ABOUT: "\xBFDe qui\xE9n trata este documento?",
  SEE_MORE: "VER M\xC1S",
  UNABLE_TO_LOAD_PAGE_TRY_AGAIN: "No podemos cargar esta p\xE1gina. Comprueba tu Internet e int\xE9ntalo de nuevo.",
  ERROR_CAPTION_NO_CONNECTION: "Se present\xF3 un problema cargando los datos.\n Verifica tu conexi\xF3n a internet y vuelve a intentarlo.",
  ERROR_CAPTION_BACKEND: "Se ha producido un problema al conectar con nuestro servidor.\n Vuelve a intentarlo m\xE1s tarde.",
  ERROR_HEADING_NO_CONNECTION: "No hay conexi\xF3n a Internet",
  ERROR_HEADING_GENERIC: "Algo sali\xF3 mal",
  ABOUT_ME: "Acerca de m\xED",
  ERROR_DELETING_YOUR_DOCUMENT: "Error al borrar tu documento",
  DOCUMENT_DELETED: "Documento eliminado",
  ACTIVITIES_PLURALIZATION: "{count, plural, one {Actividad} other {Actividades}}",
  DELETE_DOCUMENT: "Borrar documento",
  CANNOT_BE_UNDONE: "Esta acci\xF3n no se puede deshacer",
  SURE_YOU_WANT_TO_DELETE: "Est\xE1s seguro de que quieres eliminar {name}",
  DOCUMENT_RENAMED_SUCCESSFULLY: "Documento renombrado con \xE9xito.",
  ERROR_RENAMING_YOUR_DOCUMENT: "Error al renombrar tu documento. Vuelve a intentarlo.",
  INSIGHT_CARD_UNIT_FLOORS_CLIMBED_OLD: "pisos",
  INSIGHT_CARD_UNIT_STEPS_OLD: "pasos",
  KM: "km",
  CAL: "Cal",
  MIN: "min",
  YOUR_DOCUMENT_WILL_BE_AVAILABLE_SOON: "Tu documento estar\xE1 disponible en breve. Por favor, espera unos momentos",
  DOCUMENT_SUBMITTED: "Documento enviado",
  ERROR_UPLOADING_YOUR_FILE: "Error al subir tu archivo. Int\xE9ntalo de nuevo.",
  VISIT_LINK: "Visitar enlace",
  QUESTION_PROGRESS: "PREGUNTA {questionNumber} DE {totalQuestions}",
  AMOUNT_QUESTIONS: "{amount} preguntas",
  VIEW_DOCUMENT_ACTIONS: "Ver acciones de {documentName}.",
  PREVIEW_OF_FILE: "Vista previa de {fileName}",
  SELECT_PARTICIPANT_ERROR: "Selecciona a alguien a quien enviar un mensaje",
  TRANSACTION_TABLE_CAPTION: "Historial de transacciones",
  MESSAGES_PAGINATION_ERROR: "No se han podido cargar los mensajes. <button>Int\xE9ntalo de nuevo.</button>",
  MAXIMUM_FILE_SIZE_IS: "El tama\xF1o m\xE1ximo del archivo es {fileSize}.",
  FILE_TYPE_TOO_LARGE: "El tama\xF1o del archivo es demasiado grande",
  MODIFIED_ON_DATE: "Modificado el {date}",
  ERROR_SAVING_TRY_AGAIN: "Error al guardar los cambios. Int\xE9ntalo de nuevo",
  USER_ADDED_DOCUMENT: "{user} agreg\xF3 un documento",
  START_A_NEW_MESSAGE: "Iniciar un nuevo mensaje",
  NO_MESSAGES_DETAIL: "Tu Asesor de atenci\xF3n asignado te ayudar\xE1 a tomar decisiones de atenci\xF3n sanitaria m\xE1s inteligentes, en cada paso del camino.",
  NO_MESSAGES_YET: "No tienes mensajes (\xA1todav\xEDa!)",
  RECENT_MESSAGES: "Mensajes recientes",
  USE_FILE_IN_ONE_OF_THESE_FORMATS: "Usa un archivo en uno de estos formatos: {fileTypes}",
  FILE_TYPE_NOT_SUPPORTED: "Tipo de archivo no compatible",
  ERROR_HEADING: "Algo sali\xF3 mal por nuestra parte.",
  UNABLE_TO_SEND: "No se puede enviar, int\xE9ntalo de nuevo",
  APP_AND_DEVICE_METRICS: "M\xE9tricas de aplicaciones y dispositivos",
  REMOVE_FILE: "Eliminar archivo",
  ADD_A_DOCUMENT: "Agregar un documento",
  DRAG_FILES_HERE_OR: "Arrastra archivos aqu\xED o",
  LAST_30_DAYS: "\xDAltimos 30 d\xEDas",
  LAST_7_DAYS: "\xDAltimos 7 d\xEDas",
  GENERIC_MESSAGING_ERROR: "Parece que ha habido un problema, actualiza la p\xE1gina e int\xE9ntalo de nuevo.",
  ACTIVITY_EXPIRY_DATE: "Expira el {date}",
  HIGH_PRIORITY_ACTIVITY_ALT_TEXT: "Esta es una actividad de alta prioridad",
  MEDIUM_PRIORITY_ACTIVITY_ALT_TEXT: "Esta es una actividad de prioridad media",
  LOW_PRIORITY_ACTIVITY_ALT_TEXT: "Esta es una actividad de baja prioridad",
  ENTER_DOCUMENT_NAME: "Por favor, introduce el nombre del documento",
  RENAME: "Cambiar el nombre",
  VIEW_ALL_METRICS: "Ver m\xE9tricas de aplicaciones y dispositivos",
  APPS_AND_DEVICES: "Aplicaciones y dispositivos",
  YOUR_METRICS_SUBTITLE: "Los datos de salud m\xE1s recientes de las aplicaciones y dispositivos conectados.",
  YOUR_METRICS: "Mis m\xE9tricas",
  ASSIGNED: "Asignado",
  MESSAGES_IN_CONVERSATION_TITLED: "Mensajes en la conversaci\xF3n titulada {subject}",
  YOU: "T\xFA",
  USER_COLON: "{user}:",
  ADD_DOCUMENT: "Agregar un documento",
  RETRY: "Reintentar",
  TROUBLE_DISPLAYING_DATA: "Tenemos problemas para mostrar tus datos",
  ALL_MESSAGES_FOR_THREAD_BANNER: "Por favor, no nos env\xEDes informaci\xF3n espec\xEDfica sobre tus condiciones de salud a trav\xE9s de este chat.",
  MESSAGE_THREADS_LIST_SUBTITLE: "Nuestro equipo puede tardar hasta 2 d\xEDas laborables en responder. Si se trata de una emergencia m\xE9dica, llama al 911.",
  POLICY_INFORMATION_UNAVAILABLE_DEPENDENTS: "No hay informaci\xF3n para este miembro. Por favor, intenta con otro miembro.",
  POLICY_INFORMATION_UNAVAILABLE: "No hay informaci\xF3n disponible para este periodo de la p\xF3liza.",
  INSIGHT_CHART_MINDFUL_DURATION_DATUM_LABEL: "Tuviste {value} minutos conscientes el {date}",
  INSIGHT_CHART_MINDFUL_DURATION_MONTH_DESCRIPTION: "El n\xFAmero de minutos conscientes cada d\xEDa del mes.",
  INSIGHT_CHART_MINDFUL_DURATION_WEEK_DESCRIPTION: "El n\xFAmero de minutos conscientes para cada d\xEDa de la semana.",
  INSIGHT_CHART_FLOORS_CLIMBED_DATUM_LABEL: "Has subido {value} pisos de escaleras el {date}",
  INSIGHT_CHART_FLOORS_CLIMBED_MONTH_DESCRIPTION: "El n\xFAmero de pisos que has subido cada d\xEDa del mes.",
  INSIGHT_CHART_FLOORS_CLIMBED_WEEK_DESCRIPTION: "El n\xFAmero de pisos que has subido cada d\xEDa de la semana.",
  INSIGHT_CHART_ACTIVE_DURATION_DATUM_LABEL: "Tuviste {value} minutos activos el {date}",
  INSIGHT_CHART_ACTIVE_DURATION_MONTH_DESCRIPTION: "El n\xFAmero de minutos activos cada d\xEDa del mes.",
  INSIGHT_CHART_ACTIVE_DURATION_WEEK_DESCRIPTION: "El n\xFAmero de minutos activos para cada d\xEDa de la semana.",
  INSIGHT_CHART_ENERGY_BURNED_DATUM_LABEL: "Has quemado {energy} {unit} el {date}",
  INSIGHT_CHART_ENERGY_BURNED_MONTH_DESCRIPTION: "El n\xFAmero de {unit} que has quemado cada d\xEDa del mes.",
  INSIGHT_CHART_ENERGY_BURNED_WEEK_DESCRIPTION: "El n\xFAmero de {unit} que has quemado cada d\xEDa de la semana.",
  INSIGHT_CHART_STEPS_DATUM_LABEL: "Has caminado {distance} {unit} el {date}",
  INSIGHT_CHART_STEPS_MONTH_DESCRIPTION: "El n\xFAmero de pasos que has caminado cada d\xEDa del mes.",
  INSIGHT_CHART_STEPS_WEEK_DESCRIPTION: "El n\xFAmero de pasos que has caminado cada d\xEDa de la semana.",
  INSIGHT_CHART_MONTH_TITLE: "Gr\xE1fico de barras mensual {type}",
  INSIGHT_CHART_WEEK_TITLE: "Gr\xE1fico de barras semanal {type}",
  INSIGHT_CARD_HEADER_MINDFUL_DURATION: "Minutos de atenci\xF3n plena",
  COMPOSE: "Componer",
  YOUR_CARE_ADVISOR: "Tu asesor de atenci\xF3n",
  VIEW_DATA_SOURCES: "Ver fuentes de datos",
  INSIGHT_CHART_DISTANCE_DATUM_LABEL: "Has caminado {distance} {unit} el {date}",
  INSIGHT_CHART_DISTANCE_MONTH_DESCRIPTION: "El n\xFAmero de {unit} que has caminado cada d\xEDa del mes.",
  INSIGHT_CHART_DISTANCE_MONTH_TITLE: "Gr\xE1fico de barras mensual de distancia",
  INSIGHT_CHART_DISTANCE_WEEK_DESCRIPTION: "El n\xFAmero de {unit} que has caminado cada d\xEDa de la semana.",
  INSIGHT_CHART_DISTANCE_WEEK_TITLE: "Gr\xE1fico de barras semanal de distancia",
  DAY_OF_THE_MONTH: "D\xCDA DEL MES",
  DAY_OF_THE_WEEK: "D\xCDA DE LA SEMANA",
  LEADERBOARD_CURRENT_TEAM_NAME: "{team} (Tu equipo)",
  NO_DOCUMENTS_DESCRIPTION: "Puedes a\xF1adir documentos para compartirlos con tu asesor asistencial y mantenerlos organizados en un solo lugar.",
  NO_DOCUMENTS: "No hay documentos aqu\xED (todav\xEDa)",
  OR_CALL_PHONE: "o llama a {phoneNumber}",
  LEAVE_TEAM_FAILURE: "Algo ha ido mal, por favor, int\xE9ntalo de nuevo.",
  SUCCESSFULLY_LEFT_TEAM: "Has abandonado con \xE9xito {teamName}",
  CANT_JOIN_TEAM_JOIN_CHALLENGE_DETAIL: "Parece que a\xFAn no te has inscrito en el reto. Tendr\xE1s que inscribirte antes de poder unirte a {teamName}.",
  JOIN_TEAM_SUCCESS_BUTTON: "Ir a Detalles del equipo",
  JOIN_TEAM_SUCCESS_DETAIL: "Vamos a conquistar estas actividades juntos.",
  JOIN_TEAM_SUCCESS_TITLE: "\xA1Bienvenido al equipo!",
  VIEW_DOCUMENT: "Ver documento:",
  UPLOADED_DOCUMENT: "Subido {date} \u2022 Subido por {user}",
  INDIVIDUAL_CAP: "Individual",
  CURRENTLY_NOT_SHARING_DATA: "Actualmente no est\xE1s compartiendo ning\xFAn dato para {metric}",
  START_TRACKING_METRIC: "Empieza a rastrear {metric}",
  ACTIVITIES_PILL: "Actividades",
  INSIGHT_CARD_UNIT_FLOORS_CLIMBED: "{count, plural, one {piso} other {pisos}}",
  INSIGHT_CARD_UNIT_STEPS: "{count, plural, one {paso} other {pasos}}",
  UNABLE_TO_CREATE_TEAM: "No fue posible crear un equipo nuevo: intenta de nuevo. Si ya te uniste a un equipo, necesitar\xE1s dejar el equipo actual antes de crear uno nuevo.",
  REVIEW_FAQ: "revisa nuestras preguntas frecuentes",
  BACK_TO_LOGIN: "Volver al inicio de sesi\xF3n",
  ASSIGNED_TODAY: "hoy",
  ASSIGNED_ON: "el {date}",
  PREVIOUS_30_DAYS: "\xDAltimos 30 d\xEDas",
  NEXT_30_DAYS: "Pr\xF3ximos 30 d\xEDas",
  PREVIOUS_WEEK: "Semana pasada",
  NEXT_WEEK: "Pr\xF3xima semana",
  VIEW_ALL_METRIC_DATA: "Ver todos los datos de {metric}",
  AVERAGE: "Promedio",
  DOCUMENTS: "Documentos",
  BROWSE_SUPPORTED_DATA: "\xBFQu\xE9 puedo rastrear?",
  START_TRACKING_HEALTH_BODY: "Sigue f\xE1cilmente tus m\xE9tricas a lo largo del tiempo para ver hasta d\xF3nde has llegado y c\xF3mo puedes trabajar para alcanzar tus objetivos de salud.",
  START_TRACKING_HEALTH_HEADER: "Empieza a rastrear tu salud",
  DATA_AND_INSIGHTS: "Datos y observaciones",
  SPENDING_ACCOUNTS_PILOT: "Conocimientos de la cuenta de gastos (Piloto)",
  CARE_COLLECTIONS: "Colecciones de atenci\xF3n m\xE9dica",
  MANAGE_UNITS_CHANGES_SAVED: "Cambios guardados a las {time}",
  MANAGE_UNITS_APPLYING_CHANGES: "Aplicando cambios...",
  DATAPOINT_CATEGORY_BODY: "Cuerpo",
  DATAPOINT_CATEGORY_ACTIVITY: "Actividad",
  MEMBER_LABEL: "Miembro",
  IHEALTH: "iHealth",
  STRAVA: "Strava",
  OMRON: "Omron",
  WITHINGS: "Withings",
  POLAR: "Polar",
  GARMIN: "Garmin",
  FITBIT: "Fitbit",
  GOOGLE_FIT: "Google Fit",
  APPLE_HEALTH: "Salud de Apple",
  WHEN_MULTIPLE_SOURCES_AVAILABLE: "Cuando haya varias fuentes disponibles, la fuente de datos con el mayor valor se registrar\xE1 al final del d\xEDa (11:59pm).",
  SOURCES_CAN_UPDATE: "Se permiten las siguientes fuentes para actualizar tu",
  DATA_SOURCES: "Fuentes de datos",
  GET_ASSISTANCE_NOW_SUBHEADING: "Habla con nuestros profesionales de salud certificados y nuestro personal de servicio, quienes pueden ayudarte a ahorrar dinero al recomendarte los recursos m\xE1s accesibles y de mejor calidad en tu \xE1rea, as\xED como brindarte respuestas a todas las preguntas sobre tus beneficios.",
  SEND: "Enviar",
  WRITE_A_MESSAGE: "Escribir un mensaje...",
  NO_CARE_COLLECTIONS: "Lo sentimos, no hay colecciones de cuidados disponibles.",
  TOKENS_YESTERDAY_HIGHLIGHT: " \xA1ayer!",
  EARNED_ACHIEVEMENT_HIGHLIGHT: "<strong>Logro {achievement} Ganado</strong>",
  ACTIVE_MINUTES_HIGHLIGHT: "<strong>Hoy has movido {total} de minutos</strong>",
  STEPS_WALKED_HIGHLIGHT: "<strong>Ayer has caminado {total} de pasos</strong>",
  JOINED_TEAM_HIGHLIGHT: "\xA1Se ha unido <strong>{teamName}</strong>!",
  CREATED_TEAM_HIGHLIGHT: "\xA1Se ha creado <strong>{teamName}</strong>!",
  JOINED_CHALLENGE_HIGHLIGHT: "\xA1Se ha unido <strong>{challengeTitle}</strong>!",
  YOU_SENT: "T\xFA enviaste:",
  RESULT_COUNT: "{count, plural, one {# resultado} other {# resultados}}",
  ANIMATION_ACCESSIBILITY_PLAYBACK: "Reproducir o pausar la animaci\xF3n actualmente seleccionada",
  JOURNEY_DELIGHT_3: "Los peque\xF1os pasos pueden marcar una gran diferencia. T\xFA est\xE1s dando ese paso.",
  JOURNEY_DELIGHT_2: "Activo. Centrado. Manteni\xE9ndote en tu carril. Nos encanta verlo.",
  JOURNEY_DELIGHT_1: "La motivaci\xF3n te hace empezar. El h\xE1bito te mantiene en marcha. Ya lo tienes.",
  CREATE_MESSAGE: "Crear mensaje",
  TO: "Para",
  MESSAGE_SUBJECT_PLACEHOLDER: "Establecer el tema del mensaje",
  MESSAGE_SUBJECT: "Asunto del mensaje (opcional)",
  NEW_MESSAGE: "Nuevo mensaje",
  ALL_RECORDED_DATA: "Todos los datos registrados",
  CHALLENGES_LEGAL_DISCLAIMER: "Este Reto pretende ser una forma divertida de que todos participen y tengan una oportunidad justa de ganar. En ocasiones, el organizador del Reto puede ofrecer premios en efectivo o de otro tipo. League no dise\xF1a la estructura del Reto ni decide si se ofrecen premios. Si tienes dudas sobre la estructura de este Reto o crees que has sido excluido de la posibilidad de ganar, habla con el organizador del Reto.",
  NO_RECOMENDATIONS: "Lo sentimos, no tenemos ninguna recomendaci\xF3n para esta \xE1rea de salud en este momento.",
  FEEDBACK_TITLE: "\xBFQu\xE9 tan \xFAtil fue esta informaci\xF3n?",
  RETURN_TO: "Volver a {location}",
  NO_MESSAGES_DESCRIPTION: "\xA1Comienza enviando un nuevo mensaje!",
  NO_MESSAGES_HEADING: "Todav\xEDa no hay mensajes",
  UNREAD: "No le\xEDdo",
  CURRENT_PAGE: "p\xE1gina actual",
  NEW_MESSAGE_DEFAULT: "Este es el comienzo de un nuevo mensaje",
  CARD_BACK_FILENAME: "{benefitName}-reverso",
  CARD_FRONT_FILENAME: "{benefitName}-anverso",
  START_A_VISIT: "Iniciar una visita",
  NETWORK_MISSING_COVERAGE: "Tu plan no tiene ninguna cobertura de {network}",
  SEND_NEW_MESSAGE: "Enviar un nuevo mensaje",
  MESSAGES: "Mensajes",
  LIKED: "Me gusta",
  LIKE: "Me gusta",
  CHANGING_YOUR_UNITS: "El cambio de tus unidades afectar\xE1 a la forma en que se muestran en la aplicaci\xF3n.",
  UPDATING_UNITS_OF_MEASURE: "Actualizaci\xF3n de las unidades de medida",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NOR_POINTS: "S\xF3lo te faltan unas cuantas preguntas para completar la evaluaci\xF3n.",
  YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NUMBER: "S\xF3lo te faltan unas cuantas preguntas para ganar {points} puntos.",
  LIVE_BALANCE_REMAINING: "{amount} restante",
  LIVE_BALANCE_SPEND: "{spentAmount} de {totalAmount} gastado",
  APPS_AND_DEVICES_CURRENTLY_SUPPORTED: "aplicaciones y dispositivos compatibles actualmente",
  CONNECTING_UNAVAILABLE_DETAILS_WITH_LINK: "Por ahora, visita la aplicaci\xF3n m\xF3vil de League para conectar tus aplicaciones y dispositivos de salud favoritos. Si quieres saber m\xE1s, puedes encontrar una lista completa de las",
  HOW_CAN_WE_HELP: "\xBFC\xF3mo podemos ayudar?",
  GET_ASSISTANCE_NOW: "Obt\xE9n asistencia ahora",
  OLDER: "M\xE1s antiguo",
  PAST_30_DAYS: "\xDAltimos 30 d\xEDas",
  PAST_7_DAYS: "\xDAltimos 7 d\xEDas",
  NO_DATA_AVAILABLE: "No hay datos disponibles",
  MANAGE_UNITS: "Cambiar las unidades de medida",
  ADD_APPS_DEVICES: "Ver aplicaciones y dispositivos",
  ACCUMULATION_PERIOD: "Per\xEDodo de acumulaci\xF3n: {start} - {end}",
  LAST_UPDATED_CARRIER_DATE: "\xDAltima actualizaci\xF3n: {date} de {carrier}",
  INSIGHT_CARD_HEADER_MINDFULNESS: "Conciencia plena",
  INSIGHT_CARD_HEADER_HEIGHT: "Altura",
  INSIGHT_CARD_HEADER_WEIGHT: "Peso",
  INSIGHT_CARD_HEADER_ENERGY_BURNED: "Energ\xEDa quemada",
  INSIGHT_CARD_HEADER_ACTIVE_DURATION: "Minutos activos",
  INSIGHT_CARD_HEADER_FLOORS_CLIMBED: "Pisos subidos",
  INSIGHT_CARD_HEADER_STEPS: "Pasos",
  INSIGHT_CARD_HEADER_DISTANCE: "Distancia",
  SINCE_LAST_WEEK: "desde la semana pasada",
  PLAN_PROGRESS: "Progreso del plan",
  CHALLENGE_LETS_START_TEAMS_ENABLED: "Est\xE1s preparado para empezar tu reto. \xBFQuieres unirte o crear un equipo?",
  RECOMMENDED_NEXT_STEP: "Pr\xF3ximo paso recomendado",
  VIEW_THIS_RESOURCE: "Ver este recurso",
  YOUVE_EARNED_ACHIEVEMENT_BADGE: "Has obtenido una insignia de logro",
  TAKE_ME_BACK: "Ll\xE9vame de vuelta",
  VIEW_ALL_ACHIEVEMENTS: "Ver todos los logros",
  SEE_ALL_ACHIEVEMENTS: "Ver todos los logros",
  CHALLENGE_FAQ_CONTENT: "Consulta nuestro {helpCenterLink} para todas tus preguntas m\xE1s frecuentes.",
  CHALLENGE_FAQ_HEADING: "\xBFTienes preguntas sobre los Retos?",
  FEATURES_HIGHLIGHT_CAROUSEL_LABEL: "Carrusel de caracter\xEDsticas destacadas",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_OR_FUTURE_HEADING: "No hay nada planeado - \xA1todav\xEDa!",
  NO_HIGHLIGHTS_ACTIVITY_DESCRIPTION: "Vuelve aqu\xED para ver pronto los aspectos m\xE1s destacados del reto.",
  NO_ACTIVITY_TITLE: "No hay nada que ver aqu\xED (\xA1todav\xEDa!)",
  VIEW_TEAM_DETAILS: "Ver detalles del equipo",
  CREATE_TEAM_SUCCESS_DESCRIPTION: "Empieza a formar tu equipo. Comparte este enlace con otros para que puedan completar las actividades juntos.",
  CREATE_TEAM_SUCCESS: "\xA1Tu equipo est\xE1 listo!",
  TEAMS_SELECT_AVATAR_DESCRIPTION: "Este avatar aparece en el perfil de tu equipo y en la tabla de clasificaci\xF3n.",
  SEARCH_FOR_TEAM: "Buscar un equipo",
  ACTIVITY_DISMISS_ERROR: "No hemos podido eliminar la actividad en este momento. Por favor, int\xE9ntalo de nuevo.",
  ACTIVITY_COMPLETE_ERROR: "No hemos podido completar la actividad en este momento. Por favor, int\xE9ntalo de nuevo.",
  NO_SOLUTIONS_AVAILABLE: "Lo sentimos, no hay soluciones disponibles en este momento.",
  DATAPOINT_SYNC_ISSUE: "Hubo un problema al sincronizar tu {dataPoint}.",
  FIX_SYNC_ISSUE: "Resolver problema",
  SYNC_ISSUE: "PROBLEMA DE SINCRONIZACI\xD3N",
  SET_TEAM_PHOTO: "Establecer foto de equipo",
  SLIDE_OF_TOTAL: "Diapositiva {key} de {total}",
  TEAM_NAME_ERROR: "Por favor, introduce un nombre para tu equipo.",
  TEAM_NAME_LABEL: "Nombre del equipo",
  CHANGE_TEAM_PHOTO: "Cambiar la foto del equipo",
  SELECT_TEAM_PHOTO: "Seleccionar la foto del equipo",
  CREATE_A_TEAM: "Crear un equipo",
  DATE_AND_TIME: "Fecha y hora",
  PROGRAM_REMOVE_ERROR: "No hemos podido eliminar el programa en este momento. Por favor, int\xE9ntalo de nuevo.",
  PROGRAM_ADD_ERROR: "No hemos podido agregar el programa en este momento. Por favor, int\xE9ntalo de nuevo o elige otro programa.",
  INVITE_LINK_COPIED_TO_CLIPBOARD: "\xA1Enlace de invitaci\xF3n copiado al portapapeles!",
  TEAM_INVITE_LINK: "Enlace de invitaci\xF3n al equipo",
  GET_AVATARS_ERROR: "\xA1Oops! Se ha producido un problema al cargar los avatares. Por favor, actualiza e int\xE9ntalo de nuevo.",
  LEADERBOARD_USERNAME: "Nombre de usuario",
  LEADERBOARD_RANKING: "Clasificaci\xF3n",
  XTH_PLACE: "{currentRank, selectordinal, one {#st} two {#nd} few {#rd} other {#th} } puesto",
  SELECT_UP_TO: "Seleccionar hasta {number}",
  WORD_WITH_EXCLAMATION_POINT: "\xA1{word}!",
  TOKENS: "fichas",
  EARN: "Gana",
  UP_YOUR_GAME_DESCRIPTION: "\xDAnete a un equipo o crea uno para enfrentaros juntos al reto.",
  UP_YOUR_GAME: "\xA1Sube de nivel!",
  CREATE_TEAM_DESCRIPTION: "Personaliza el nombre y el avatar de tu equipo. \xA1Invita a otros a unirse!",
  CREATE_TEAM: "Crea un equipo",
  JOIN_TEAM_DESCRIPTION: "Busca un equipo para unirte y competir con tus compa\xF1eros.",
  JOIN_A_TEAM: "\xDAnete a un equipo",
  CHALLENGE_TEAMS_DESCRIPTION: "\xDAnete a un equipo existente o crea el tuyo para competir juntos en retos.",
  TEAMS: "Equipos",
  JOIN_OR_CREATE_TEAM: "Unirse a/crear un equipo",
  YOUR_TEAM: "Tu equipo",
  SHOW_MY_ACTIVITY: "Mostrar mi actividad",
  CHALLENGE_ACTIVITY_DETAIL: "Aqu\xED los usuarios pueden ver cuando completas una actividad u obtienes un logro mientras participas en un reto.",
  LEAVE_TEAM_DETAIL: "\xBFSeguro que quieres eliminar {teamName}? Tus puntos ya no se contar\xE1n en el promedio del equipo.",
  LEAVE_TEAM_QUESTION: "\xBFSalir de {teamName}?",
  CANT_JOIN_TEAM_DETAIL: "Reg\xEDstrate para el reto para unirte a {teamName}.",
  CANT_JOIN_TEAM_TITLE: "A\xFAn no puedes unirte a {teamName}",
  PRIVACY: "Privacidad",
  INVITE_FRIENDS: "Invitar a amigos",
  LEAVE_TEAM: "Salir del equipo",
  INVITE: "Invitar",
  TEAM_INVITE_LINK_DESCRIPTION: "\xA1Cuantos m\xE1s, mejor! Comparte el enlace con tus amigos para que se puedan unir a tu equipo.",
  TEAM_INVITE_DESCRIPTION: "Invita a tus amigos al equipo para completar actividades juntos.",
  TEAM_INVITE_HEADING: "\xA1La uni\xF3n hace la fuerza!",
  X_LIKES: '{activityLikes} "Me gusta"',
  TOTAL_TOKENS: "Total de fichas",
  CURRENT_RANK: "Puntuaci\xF3n actual",
  HIGHLIGHTS: "Destacados",
  X_SPOTS_AVAILABLE: "{spotsAvailable} puestos disponibles",
  X_TEAM_MEMBERS: "{memberTotal} miembros del equipo",
  JOIN_TEAM: "Unirte a un equipo",
  SIGN_UP_BEGINS_DATE: "El registro empieza el {date}",
  SUCCESSFULLY_LEFT_CHALLENGE: "Abandonaste el desaf\xEDo correctamente",
  UNABLE_TO_JOIN_CHALLENGE: "No puedes unirte al desaf\xEDo. Int\xE9ntalo de nuevo m\xE1s tarde.",
  UNABLE_TO_LEAVE_CHALLENGE: "No puedes dejar el desaf\xEDo. Int\xE9ntalo de nuevo m\xE1s tarde.",
  DEPENDENT_NOTIFICATION_MESSAGE: "Se podr\xEDa invitar a nuevos dependientes",
  LEAGUE_FAMILY_EDUCATION_BANNER_SUBHEADER: "Tus dependientes pueden acceder a League y disfrutar tambi\xE9n de una vida m\xE1s saludable.",
  LEAGUE_FAMILY_EDUCATION_BANNER_HEADER: "\xBFTe preguntas por qu\xE9 es beneficioso a\xF1adir a tus dependientes?",
  GOAL_REACHED: "\xA1Has llegado a la meta!",
  ACTIVITY_COMPLETE_LATER_PROMPT: 'Para seguir adelante, haz clic en "Volver a trayectoria" y vuelve m\xE1s tarde para marcarlo como listo.',
  RELOAD_MY_SUGGESTIONS: "Recargar mis sugerencias",
  OUTCOMES_FRICTION_SCREEN_DESCRIPTION: "Danos un momento para encontrar algunos recursos \xFAtiles para ti basados en tus respuestas",
  OUTCOMES_FRICTION_SCREEN_TITLE: "Personalizando sugerencias...",
  LEADERBOARD: "Tabla de clasificaci\xF3n",
  VIEW_CHALLENGE_DETAILS: "Ver detalles del reto",
  TOP_RANKED: "Mejor clasificado",
  LEADERBOARD_CURRENT_USER_NAME: "{user} (T\xFA)",
  LEADERBOARD_ALL_TIME_RANKING: "Clasificaci\xF3n de todos los tiempos",
  ACTIVE_CHALLENGE: "{length, plural, one {Reto activo} other {Retos activos}}",
  PROGRESS_RECORD_ERROR: "Hubo un problema al registrar tu \xFAltimo progreso.",
  GOAL_INCOMPLETE: "Debes completar el objetivo antes de continuar.",
  YOUR_RANKING: "Tu clasificaci\xF3n",
  ENERGY_BURNED: "calor\xEDas quemadas",
  DISTANCE: "distancia recorrida",
  NO_LEADERBOARD_ACTIVITY_DESCRIPTION: "Vuelve aqu\xED para ver tu clasificaci\xF3n cuando comience el reto.",
  ACTIVITY_COMPLETE_PROMPT: 'Esta actividad no se completar\xE1 hasta que hagas clic en "Marcar como listo".',
  CLOSE_ACTIVITY: "Cerrar actividad",
  MARK_AS_DONE: "Marcar como listo",
  MODULE_TEMPLATE_BUTTON: "Bot\xF3n de la plantilla del m\xF3dulo",
  EXIT: "Salir",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_DESCRIPTION: "Si eliges salir, es posible que tus cambios no se guarden.",
  EXIT_CHALLENGE_SIGN_UP_CONFIRM_TITLE: "\xBFEst\xE1s seguro de que quieres salir?",
  YOUR_PROGRESS_IN_NUMBERS: "{current} de {total} {unit} o {percentage} por ciento completado",
  YOUR_PROGRESS: "Tu progreso",
  UPDATED: "Se ha actualizado",
  TRACK_CHALLENGE_MANUALLY_LEARN_MORE: "M\xE1s informaci\xF3n",
  TRACK_CHALLENGE_AUTOMATICALLY_INSTRUCTION: "sigue estos pasos",
  TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION: "Si eliges dar seguimiento de forma autom\xE1tica despu\xE9s de registrarte, {instructionsLink} para conectar tu dispositivo con la aplicaci\xF3n m\xF3vil de League.",
  DEVICES_UNCONNECTED_DESCRIPTION: "Conecta tus aplicaciones y dispositivos de salud favoritos para que marquen las actividades como completas de forma autom\xE1tica.",
  DEVICES_UNCONNECTED_TRACK_MANUALLY_SUBTITLE: "Seguir manualmente",
  DEVICES_UNCONNECTED_TRACK_AUTOMATICALLY_SUBTITLE: "Seguir autom\xE1ticamente",
  DEVICES_UNCONNECTED_TITLE: "\xA1Conectemos tu dispositivo!",
  TRACK_MANUALLY_CONFIRM_TITLE: "\xBFEst\xE1s seguro de que quieres dar seguimiento de forma manual?",
  TRACK_HEALTH_DATA_ALT: "El panel de control graficar\xE1 los datos de seguimiento de salud",
  COVERAGE_SEARCH_TRY_AGAIN: "Prueba nuevamente usando diferentes palabras clave.",
  COVERAGE_SEARCH_QUERY_NOT_FOUND: '"{query}" no pudo ser encontrado.',
  TRACK_CHALLENGE_MANUALLY: "Seguir de forma manual en su lugar",
  TRACK_CHALLENGE_AUTOMATICALLY: "Seguir autom\xE1ticamente",
  DEVICES_CONNECTED_DESCRIPTION: "Ya sincronizamos tus datos. Si as\xED lo eliges, podemos marcar las actividades autom\xE1ticamente como completadas con el {dataPoint} de tu dispositivo.",
  DEVICES_CONNECTED_TITLE: "\xA1Tal parece que ya est\xE1s conectado!",
  TRACK_WEARABLES_ALT_TEXT: "Persona buscando datos de un reloj inteligente",
  ACTIVITY_COUNT_GOAL: "Objetivo: {goal} {unit}",
  NO_CHALLENGE_ACTIVITIES_TODAY: "No hay actividades de retos para ti este d\xEDa.",
  ACTIVITIES_APPEAR_HERE_WHEN_CHALLENGE_STARTS: "Las actividades diarias aparecer\xE1n aqu\xED cuando inicie tu reto el <strong>{date}</strong>.",
  CHALLENGE_ABOUT_TO_START: "\xA1Tu reto est\xE1 a punto de comenzar!",
  FLOORS_CLIMBED: "pisos subidos",
  MINDFUL_DURATION: "minutos conscientes",
  LEAVE: "Salir",
  LEAVE_CHALLENGE_DETAIL: "\xBFEst\xE1s seguro de que deseas eliminar este reto de tu trayectoria? Se restablecer\xE1 cualquier progreso que tengas en este reto.",
  LEAVE_CHALLENGE_QUESTION: "\xBFAbandonar el reto?",
  SELECT_AVATAR_ERROR: "Debes elegir un avatar antes de continuar.",
  CHALLENGE_PROGRAM_LIBRARY_DESCRIPTION: "Reg\xEDstrate en un reto para completar actividades diarias y competir con tus compa\xF1eros.",
  CHALLENGES: "Retos",
  SIGN_UP_BY: "Inscr\xEDbete antes del {date}",
  SELECT_AVATAR: "Seleccionar avatar",
  PROFILE_PHOTO_DESCRIPTION: "Esta foto aparece en tu perfil de usuario y en tu perfil de salud",
  CHECK_TO_CONFIRM_PRIVACY_POLICY: "Al marcar esta casilla, expresas tu acuerdo con la <a>pol\xEDtica de confidencialidad</a>.",
  ACCEPT_BEFORE_CONTINUE: "Debes aceptar antes de continuar.",
  DETERMINE_CHALLENGE_WINNERS: "Elegir los ganadores del reto",
  RANK_SCORE: "Clasifica tu puntuaci\xF3n en un panel",
  SHARE_CHALLENGE_PROGRESS: "Comparte tu progreso en el reto con tus compa\xF1eros (y empleador)",
  COMPLETE_ACTIVITIES_SHORT: "Completar actividades",
  CHALLENGE_USING_DATA_TO: "Cuando te registras para un reto, esto es para lo que usamos tus datos:",
  CHALLENGE_SENSITIVE_DATA: "Tus datos de salud y tu informaci\xF3n personal son altamente sensibles y es nuestra responsabilidad mantenerlos privados y seguros. Nos tomamos esta responsabilidad muy en serio.",
  SIGN_UP_FOR_THE_CHALLENGE: "Reg\xEDstrate para el Reto",
  REFERENCES: "Referencias",
  MEMBERS: "Miembros",
  ACTIVITY_COMPLETE: "Actividad completa",
  EXPIRES_TODAY: "Caduca hoy",
  YOUVE_COMPLETED: "Completaste",
  YOUVE_EARNED_GRAND_TOTAL: "Ganaste un gran total de",
  VIEW_ACHIEVEMENTS: "Ver logros",
  YOU_EARNED: "Acumulaste",
  UNLOCK_ACHIEVEMENTS: "Desbloquea un logro por completar todas las actividades de este programa.",
  GO_TO_JOURNEY: "Ir a Trayectoria",
  SIGN_UP_DATE_PASSED: "La fecha de registro ya transcurri\xF3",
  LEAVE_CHALLENGE: "Abandonar el reto",
  CHALLENGE: "Reto",
  RULES: "Reglas",
  PRIZE: "Premio",
  SIGN_UP_FOR_CHALLENGE: "Inscr\xEDbete para el reto",
  CHALLENGE_DETAILS: "Detalles del reto",
  SIGN_UP_BY_DATE: "Inscr\xEDbete antes del {date}",
  START_AND_END_DATES: "Comienza {startDate} \u2022 Termina {endDate}",
  COMPLETED_X_TIMES: "Se complet\xF3 {amount} veces",
  EARNED_X_TIMES: "Se gan\xF3 {amount} veces",
  COME_BACK_COMPLETE_ACTIVITY_LATER: "Vuelve m\xE1s tarde para completar esta actividad.",
  PERCENTAGE_USED: "{percentage} utilizado.",
  PROMO_CODE: "C\xF3digo de promoci\xF3n",
  SUGGESTED_FOR_YOU: "Sugerido para ti",
  YOUR_JOURNEY: "Tu trayectoria",
  EARNED: "ganados",
  ACTIVITY_PROGRESS: "Progreso de la actividad",
  NO_ACHIEVEMENTS_DESCRIPTION: "Completa las actividades de tu Trayectoria para empezar a desbloquear logros.",
  MISSED: "Perdida",
  IMG_ALT_EMPTY_STATE_REST: "Hombre descansando en una silla c\xF3moda con una taza caliente y aud\xEDfonos",
  IMG_ALT_EMPTY_STATE_PROGRAMS: "Mujer de pie y desplazando una lista de programas enorme",
  ACHIEVEMENTS: "Logros",
  NO_PROGRAMS: "No hay nada que ver aqu\xED todav\xEDa",
  IMG_ALT_HIGH_FIVE_HANDS: "Dos manos chocando los cinco",
  NO_ACTIVITIES_COMPLETED_TODAY_DESCRIPTION: "Vuelve ma\xF1ana para obtener m\xE1s informaci\xF3n o explorar las actividades sugeridas.",
  NO_ACTIVITIES_COMPLETED_TODAY_HEADING: "\xA1Bien hecho, est\xE1s en una buena racha!",
  YOU_SKIPPED_THIS_ACTIVITY: "Te has saltado esta actividad.",
  LOOKS_LIKE_THIS_WASNT_MEANT_FOR_YOU: "Parece que este no estaba destinado a ti",
  THIS_ACTIVITY_EXPIRED_ON_DATE: "Esta actividad expir\xF3 el {date}.",
  LOOKS_LIKE_YOU_MISSED_THIS_ONE: "\xA1Parece que te has perdido esto!",
  COME_BACK_COMPLETE_ACTIVITY_ON_DATE: "Vuelve y completa esta actividad el {date}.",
  THIS_IS_JUST_A_SNEAK_PEAK: "\xA1Esto es solo un adelanto!",
  BUTTON_BROWSE_PROGRAMS: "Examinar los programas",
  NO_ACTIVITIES_PAST_DESCRIPTION: "Parece que aprovechaste este d\xEDa para relajarte y recuperarte.",
  NO_ACTIVITIES_PAST_HEADING: "D\xEDa de descanso",
  NO_ACTIVITIES_FUTURE_DESCRIPTION: "No tienes ninguna actividad programada para este d\xEDa.",
  NO_ACTIVITIES_HAS_PROGRAMS_TODAY_DESCRIPTION: "Toca el bot\xF3n 'Agregar' para buscar nuevos programas o navegar por una lista de actividades elegidas solo para ti.",
  DISCOVER_ACTIVITIES_CAPTION: "Navega por las actividades que creemos que te encantar\xE1n",
  DISCOVER_ACTIVITIES: "Descubre nuevas actividades",
  INVALID_ZIP_CODE_NO_FORMAT: "C\xF3digo postal no v\xE1lido",
  ACTIVITY_STATUS_UPCOMING: "Disponible pronto",
  ACTIVITY_STATUS_REMOVED: "Saltado",
  ACTIVITY_STATUS_EXPIRED: "Vencido",
  ACTIVITY_STATUS: "Estatus de actividad:",
  NEXT_DAY: "Siguiente d\xEDa",
  PREVIOUS_DAY: "D\xEDa anterior",
  BACK_TO_TODAY: "Volver al d\xEDa de hoy",
  YESTERDAY: "Ayer",
  TOMORROW: "Ma\xF1ana",
  X_MISSED: "{missed} perdida(s)",
  X_OF_Y_COMPLETE: "{completed}/{total} completada(s)",
  WHAT_DEVICES_CAN_CONNECT: "\xBFQu\xE9 aplicaciones y dispositivos son compatibles?",
  DONT_HAVE_THE_APP: "\xBFNo tienes la aplicaci\xF3n m\xF3vil de League?",
  CONNECTING_UNAVAILABLE_DETAILS: "Por ahora, visite la aplicaci\xF3n m\xF3vil de League para conectar sus aplicaciones y dispositivos de salud favoritos.",
  CONNECTING_UNAVAILABLE: "La conexi\xF3n de aplicaciones y dispositivos no est\xE1 disponible en la web",
  DONT_CONNECT_APPS_DEVICES: "No rastrear mi progreso autom\xE1ticamente",
  CONNECT_APPS_DEVICES: "Conectar aplicaciones y dispositivos",
  CONNECT_TO_TRACK: "Conecta tus aplicaciones y dispositivos de salud favoritos para marcar autom\xE1ticamente las actividades como completas.",
  TRACK_AUTOMATICALLY: "Rastrea tu progreso autom\xE1ticamente",
  HEALTH_PROGRAMS_CONNECTED_PROGRAM: "Programa de salud conectado",
  HEALTH_PROGRAMS_SYNC_DEVICE: "Sincroniza tu {device} para una experiencia \xF3ptima del programa.",
  ACTIVE_DURATION: "minutos activos",
  STEPS: "pasos",
  X_OF_Y: "{current} de {total}",
  DOWNLOAD_PLAY_STORE: "Obtener en Google Play",
  DOWNLOAD_APP_STORE: "Descargar en la App Store",
  CREATE: "Crea {label}",
  EXIT_ACTIVITY_CTA: "Salir de la actividad",
  EXIT_ACTIVITY_BODY: "Tu progreso no se guardar\xE1 y tendr\xE1s que volver a empezar la actividad desde el principio.",
  EXIT_ACTIVITY_TITLE: "\xBFEst\xE1s seguro de que deseas salir de esta actividad?",
  NEXT_STEP: "Etapa siguiente",
  DEPENDENT_COVERED_BY_HSA_ONLY: "Nota Este dependiente solo estar\xE1 cubierto por tu cuenta de gastos m\xE9dicos.",
  MAIN_NAVIGATION_LIST_LABEL: "Elementos de navegaci\xF3n de League",
  YOU_EARNED_X_POINTS: "\xA1Ganaste {points} puntos!",
  PAGE_TITLE_HEALTH_PROGRAM_CATEGORY: "Categor\xEDa del programa de salud",
  PAGE_TITLE_ACTIVITY_DETAILS: "Detalles de la actividad",
  VIEW_CARD_FOR_DEPENDENT: "Ver tarjeta de {dependentName}",
  SKIP_TO_CONTENT_MESSAGE: "Saltar al contenido",
  COVERAGE_SEARCH_BEHAVIOUR_DESCRIPTION: "Los resultados de la b\xFAsqueda se actualizar\xE1n autom\xE1ticamente a medida que escribes",
  WALLET_LANDING_NAV_LABEL: "Navegaci\xF3n por la cartera",
  END_CHAT: "Finalizar chat",
  PROFILE_PHOTO: "Foto de perfil",
  PROFILE_UPDATE_FAILED: "Error al actualizar el perfil",
  THE_PROGRAM_WILL_APPEAR_IN_JOURNEY: "Ahora el programa aparecer\xE1 en tu trayectoria",
  PROGRAM_ADDED: "Programa agregado",
  PROGRAM_REMOVED: "Programa eliminado",
  ARE_YOU_SURE_REMOVE_PROGRAM: "\xBFEst\xE1s seguro de que deseas eliminar este programa de tu recorrido? Cualquier progreso en este programa se reiniciar\xE1 y tendr\xE1s que empezar de nuevo desde el principio.",
  REMOVE_PROGRAM: "\xBFEliminar programa?",
  YOU_WILL_NO_LONGER_SEE_IN_JOURNEY: "Ya no se ver\xE1 en tu trayectoria",
  QLE_LINK_LABEL: "Conoce m\xE1s informaci\xF3n sobre los eventos de vida calificados",
  PREVIOUS: "Previo",
  COMPLETE_ACTIVE_PROGRAM_BEFORE_NEW_ONE: "Termina un programa activo antes de agregar uno nuevo. <strong>{ctaText}</strong>",
  LOOKS_LIKE_REACHED_PROGRAM_LIMIT: "\xA1Parece que llegaste al l\xEDmite de tu programa!",
  SHOW_LESS: "Mostrar menos",
  COMPLETED: "Completado",
  VIEW_CLAIM_LABEL_HIDDEN: "Ver reclamaci\xF3n {referenceId} de {vendor}",
  COMPLETE_ONE_OF_ACTIVE_PROGRAMS: "Completa uno de tus programas activos para agregarlo a tu trayectoria.",
  OPENS_IN_A_NEW_TAB: "Se abre en una pesta\xF1a nueva",
  OK: "De acuerdo",
  START_X_MORE_PROGRAMS: "Inicia {duration} m\xE1s programas. Mant\xE9n el impulso.",
  YOUVE_REACHED_PROGRAM_LIMIT: "\xA1Llegaste a tu l\xEDmite de programas!",
  TAP_ADD_PROGRAM_BUTTON: "Toca el bot\xF3n 'Agregar programa' para buscar programas.",
  ADD_PROGRAM: "Agregar programa",
  YOU_HAVENT_STARTED_PROGRAMS: "No has iniciado ning\xFAn programa de salud",
  SCROLL_CAROUSEL_LEFT: "Desplaza el carrusel hacia la izquierda",
  SCROLL_CAROUSEL_RIGHT: "Desplaza el carrusel hacia la derecha",
  DOCUMENT_TITLE: "{title} - League",
  PROGRESS: "Progreso",
  PROGRAM_DETAILS: "Detalles del programa",
  EARN_UP_TO_X_POINTS: "Gana hasta {points} puntos",
  POUNDS: "Libras",
  KILOGRAMS: "Kilogramos",
  INCHES: "Pulgadas",
  FEET: "Pies",
  CENTIMETERS: "Cent\xEDmetros",
  LEARN_MORE_LEAGUE_FAMILY: "acerca de League Family para tus dependientes",
  LINK_TO_TRANSACTION_DETAILS: "Enlace a detalles",
  GO_TO_RECEIPT: "Ver recibo de {title}",
  GO_TO_CLAIM: "Ver detalles de reclamaci\xF3n de {title}",
  GO_TO_LIFEMARKET: "Ve a Lifemarket para ver el n\xFAmero de pedido {invoiceId}",
  ADD_TO_JOURNEY: "Agregar a trayectoria",
  BACK_TO_JOURNEY: "Volver a trayectoria",
  ARE_YOU_SURE_REMOVE_ACTIVITY: "\xBFEst\xE1s seguro de que deseas eliminar esta actividad de tu trayectoria? Esta acci\xF3n no se puede deshacer.",
  REMOVE_ACTIVITY: "\xBFEliminar actividad?",
  GO_TO_HEALTH_JOURNEY: "Ir a la trayectoria de salud",
  BROWSE_PROGRAMS: "Examinar los programas",
  PROGRAM_LIBRARY: "Biblioteca de programas",
  ACTIVITIES: "Actividades",
  HEALTH_JOURNEY: "Trayectoria de salud",
  REDEEMABLE: "Canjeable por {value} .",
  VIEW_YOUR_REWARDS: "Ver tus recompensas",
  REDEEM_NEXT_TIER_POINTS: "Est\xE1s a {points} de canjear {value}.",
  POINTS_BALANCE: "Saldo de puntos",
  ABOUT_THIS_PROGRAM: "Acerca de este programa",
  REMOVE_FROM_JOURNEY: "Quitar de la trayectoria",
  HEALTH_PROFILE_COMPLETION_POINTS: "Ganaste {points} puntos",
  UPDATE_HEALTH_PROFILE: "Actualizar tu Perfil de salud",
  LAST_UPDATED_DATE: "\xDAltima actualizaci\xF3n el {date}",
  ANY_HEALTH_CHANGES: "\xBFHa habido alg\xFAn cambio reciente en tu salud?",
  WARNING_OPENS_NEW_TAB: "Se abre en una pesta\xF1a nueva",
  TRY_AGAIN: "Int\xE9ntalo de nuevo",
  THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM: "Vaya, parece que ha habido un problema.",
  SHOW_MORE: "Mostrar m\xE1s",
  LOAD_MORE: "Cargar m\xE1s",
  AFTER_EXPIRY_YOU_HAVE_UNTIL_DATE_TO_SUBMIT: "Luego de vencido, tienes hasta el <strong>{inactiveDate}</strong> para enviar reclamaciones con fecha de compra/servicio del <strong>{endDate}</strong> o antes",
  YOU_HAVE_X_DAYS_BEFORE_EXPIRY: "Te restan {days} d\xEDas para usar este beneficio antes del vencimiento de tu periodo de p\xF3liza.",
  EXPIRES_ON_DATE: "Vence en {date}",
  YOU_HAVE_UNTIL_DATE_TO_SUBMIT_PAST_CLAIMS: "Tienes hasta el <strong>{inactiveDate}</strong> para enviar reclamaciones pasadas con fecha de compra/servicio del <strong>{endDate}</strong> o antes",
  THIS_POLICY_EXPIRES_TOMORROW: "El periodo de esta p\xF3liza ha vencido, pero hoy es el \xFAltimo d\xEDa para enviar reclamaciones pasadas de este beneficio",
  THIS_POLICY_HAS_EXPIRED: "El periodo de esta p\xF3liza ha vencido, pero te restan {days} d\xEDas para enviar reclamaciones pasadas de este beneficio",
  SUBMIT_PAST_CLAIMS_BY_DATE: "Env\xEDa tus reclamaciones pasadas hasta el {date}",
  YOU_CAN_ONLY_SUBMIT_CLAIMS_IN_DATE_RANGE: "\xDAnicamente puedes enviar reclamaciones de este beneficio con una fecha de compra/servicio entre <strong>{dateRange}</strong>. Ve los detalles de tu cobertura para obtener m\xE1s informaci\xF3n.",
  BECOMES_ACTIVE_IN_X_DAYS: "El beneficio se activar\xE1 en {days} d\xEDas",
  BECOMES_ACTIVE_ON_DATE: "Se activar\xE1 el {date}",
  CHAT: "Chat",
  TOP_MATCH: "Combinaci\xF3n \xF3ptima",
  HISTORY: "Historial",
  MORE_GREAT_RESOURCES: "M\xE1s recursos excelentes",
  HEALTH_PROGRAMS: "Programas de salud",
  HEALTH_PROFILE: "Perfil de salud",
  CAROUSEL_WALLET_DESCRIPTION: "Una cartera digital personalizada con tus tarjetas de beneficios.",
  CAROUSEL_WALLET_HEADING: "Cartera",
  CAROUSEL_HEALTH_PROGRAMS_DESCRIPTION: "Descubre los cambios que puedes realizar para mejorar tu salud ",
  CAROUSEL_HEALTH_PROGRAMS_HEADING: "Programas de salud",
  COVERAGE: "Cobertura",
  MULTI_SELECT_DEFAULT_PLACEHOLDER: "Selecciona tus opciones",
  MULTI_SELECT_DEFAULT_CAN_CREATE: "\xA1Tambi\xE9n puedes escribir para crear una nueva opci\xF3n!",
  PROGRAM_PROGRESS: "Progreso del programa",
  ACTIVE_PROGRAM: "Programa en curso",
  CATEGORIES: "Categor\xEDas",
  HELP_CENTER: "Centro de ayuda",
  NEXT: "Siguiente",
  BACK: "Atr\xE1s",
  YEAR: "A\xF1o",
  MONTH: "Mes",
  DAY: "D\xEDa",
  SEARCH: "Buscar",
  HRA: "HRA",
  VIEW_ALL: "Ver todo",
  CLAIM_REF_NUMBER: "Reclamaci\xF3n #",
  LAST_UPDATED: "\xDAltima Actualizaci\xF3n",
  VIEW_MORE_DETAILS_SENTENCE_CASE: "Ver m\xE1s detalles",
  SAVE: "Guardar",
  GOT_IT: "Entendido",
  WELCOME: "Bienvenido",
  IDENTIFICATION_TYPE_TWO_FILES: "Los documentos de identificaci\xF3n solo pueden tener hasta 2 im\xE1genes de apoyo.",
  ADD_IMAGE: "Agrega m\xE1s p\xE1ginas a este documento (si corresponde)",
  DRAG_OR_UPLOAD_PHOTO: "Carga una foto de este documento",
  COMPLETED_STATE_TITLE: "Completado",
  UNIQUE_IDENTIFIER_MAX_LENGTH_ERROR: "Debe tener como m\xE1ximo {length} caracteres",
  INVALID_DAY_ERROR_MESSAGE: "La fecha seleccionada no es v\xE1lida.",
  THIS_FIELD_IS_REQUIRED: "Este campo es obligatorio",
  OVERVIEW: "Resumen",
  ERROR: "Error",
  SUCCESS: "\xA1Bien hecho!",
  REQUIRED_FORM: "Requerido",
  UPLOAD_DOCUMENT: "Cargar documento",
  CHANGE_PLAN_LINK: "Cambiar elecciones de planes",
  CHANGE_PLAN_DESCRIPTION: "\xBFDeseas realizar cambios a tu plan o a tu informaci\xF3n personal?",
  CHANGE_PLAN_LABEL: "Cambiar las elecciones del plan",
  TOTAL_REWARDS_LINK: "Ver el resumen de la cobertura",
  TOTAL_REWARDS_DESCRIPTION: "Revisa las elecciones del plan realizadas durante la inscripci\xF3n.",
  TOTAL_REWARDS_LABEL: "Resumen de la cobertura",
  SELECTIONS_FINALIZED_SUCCESS: "\xA1Elecciones finalizadas!",
  ERROR_FINALIZING_SELECTIONS_INVALID_SELECTIONS: "Parece que tus elecciones est\xE1n incompletas. Completa por favor la inscripci\xF3n y vuelve a intentar.",
  ERROR_FINALIZING_SELECTIONS: "Se produjo un error al enviar tus elecciones.",
  FINALIZE_PLAN_SELECTIONS: "Finalizar elecciones del plan",
  FINALIZE_SELECTIONS_ACKNOWLEDGEMENT: "Entiendo que no podr\xE9 cambiar mis elecciones",
  FINALIZE_SELECTIONS_COPY_2: "Tambi\xE9n significa que no podr\xE1s realizar ning\xFAn cambio a tu plan luego de hacer clic en enviar.",
  FINALIZE_SELECTIONS_COPY_1: "Al finalizar tus elecciones, podr\xE1s enviar inmediatamente el plan a tu compa\xF1\xEDa de seguros. Esto quiere decir que no tendr\xE1s que esperar hasta el fin de tu periodo para ver tu cartera.",
  FINALIZE_SELECTIONS_HEADER_COPY: "\xBFQuieres tener acceso a tus beneficios anticipadamente?",
  HEALTH_PROGRAM_LINK_COPY: "prueba uno de nuestros programas de salud",
  WALLET_DESCRIPTION: "Tu cartera es donde podr\xE1s acceder a tus beneficios, enviar reclamaciones y verificar tu cobertura. Podr\xE1s enviar reclamaciones por costos incurridos durante el periodo de inscripci\xF3n una vez que tu cartera se active. \xA1Mientras tanto, {healthProgramLink}!",
  WALLET_WELCOME: "\xA1Bienvenido a tu cartera!",
  LAST_DAY_OF_ENROLLMENT: "\xDAltimo d\xEDa del periodo de inscripci\xF3n: {lastDay}",
  WHY_DO_YOU_ASK: "\xBFPor qu\xE9 preguntas?",
  NO: "No",
  YES: "S\xED",
  DOMESTIC_PARTNERSHIP: "En pareja de hecho",
  ADDRESS_LINE_2: "Direcci\xF3n l\xEDnea 2",
  ADDRESS_LINE_1: "Direcci\xF3n l\xEDnea 1",
  TOTAL: "Total",
  MEDICAL: "M\xE9dico",
  LEFTOVER_FLEX_DOLLAR_INFO_TEXT_SINGLE: "<strong>{percent}%</strong> ser\xE1 agregado a tu <strong>{benefitName}</strong>.",
  FLEX_DOLLAR_INFO_TEXT_MULTIPLE: "<strong>{percent}%</strong> ser\xE1 agregado a tu <strong>{benefitName}</strong>",
  FLEX_DOLLAR_INFO_TEXT_SINGLE: "ser\xE1n autom\xE1ticamente agregados a tu {benefitName}.",
  VENDOR: "Vendedor",
  MORE_OPTIONS: "M\xE1s opciones",
  SELECT_ONE: "Selecciona una",
  DEPENDENTS: "Dependientes",
  INDIVIDUAL: "individuo",
  SEARCH_COVERAGE: "Buscar tu cobertura",
  RESTRICTIONS: "Restricciones",
  EXAMPLES: "Ejemplos: ",
  COLLAPSE_ALL: "Colapsar todo",
  EXPAND_ALL: "Expandir todo",
  COVERED_WITH_RESTRICTIONS: "Cubierto con restricciones",
  NOT_COVERED: "No cubierto",
  COVERED: "Cubierto",
  ALLOCATION: "Asignaci\xF3n",
  CONFIRM: "Confirmar",
  CANCEL: "Cancelar",
  DOCUMENT_NAME: "Nombre del documento",
  ENTER_CODE: "Ingresar c\xF3digo",
  CREDIT_INFORMATION: "Informaci\xF3n del cr\xE9dito",
  TOTAL_CREDIT: "Cr\xE9dito total:",
  PROMO_CODE_SUCCESS: "\xA1C\xF3digo de promoci\xF3n canjeado!",
  PROMO_CODE_NOT_FOUND: "C\xF3digo de promoci\xF3n no v\xE1lido",
  NO_MORE_TRANSACTIONS: "No m\xE1s transacciones",
  NO_TRANSACTIONS_YET: "A\xFAn no hay transacciones",
  CGA: "CDC (Cuenta donaciones a instituciones de caridad)",
  CREDIT_CARD: "Tarjeta de cr\xE9dito",
  LEAGUE_CREDIT: "Cr\xE9dito League",
  REFUND: "Reembolso",
  ADJUSTMENT: "Ajuste",
  TOP_UP: "Recargar",
  CLAIM: "Reclamaci\xF3n",
  ID: "ID",
  TYPE: "Tipo",
  DESCRIPTION: "Descripci\xF3n",
  DATE: "Fecha",
  DEPENDENT_CARD_HOLDER: "Tarjeta para {dependentName}",
  OTHER: "Otro/a",
  SIBLING: "Hermano/a",
  INELIGIBLE_CHILD: "Hijo/a no elegible",
  NEPHEW_NIECE: "Sobrino/a",
  UNCLE_AUNT: "T\xEDo/a",
  GRANDCHILD: "Nieto/a",
  GRANDPARENT: "Abuelo/a",
  PARENT: "Padre/madre",
  CHILD: "Hijo/a",
  COMMON_LAW: "Pareja de hecho",
  SPOUSE: "C\xF3nyuge",
  MEMBER_ID: "ID de miembro",
  VIEW_CARD: "Ver tarjeta",
  MANAGE_DEPENDENTS: "Gestionar dependientes",
  PLEASE_TRY_AGAIN_SHORTLY: "Por favor, vuelve a intentarlo en unos instantes",
  YOUR_ACCOUNT_IS_ACTIVE_AND_IN_THE_PROCESS_OF_BEING_SET_UP: "Tu cuenta est\xE1 activa y en proceso de configuraci\xF3n.",
  EXPIRED: "Vencido",
  ACTIVATION_PENDING: "Activaci\xF3n pendiente",
  NO_EXPIRY_DATE: "No tiene fecha de vencimiento",
  EXPIRY_DATE: "Fecha de vencimiento",
  PAGE_NOT_FOUND_BUTTON: "Volver a Inicio",
  PAGE_NOT_FOUND_CONTENT_SECONDARY: "Permite que te ayudemos a ubicarte.",
  PAGE_NOT_FOUND_CONTENT: "\xA1Parece que est\xE1s un poco confundido!",
  PAGE_NOT_FOUND_HEADER: "P\xE1gina no encontrada",
  START_DAY_AT_TIME: "Inicia el {day}",
  END_DAY_AT_TIME: "Finaliza el {day}",
  CLOSE: "Cerrar",
  EARN_NUMBER_POINTS_FULL: "Gana {points} puntos",
  SUBMIT: "Enviar",
  HELP_EMAIL: "ayuda@league.com",
  ERROR_STATE_TITLE: "Algo sali\xF3 mal",
  LOADING: "Cargando",
  PENDING: "Pendiente",
  SUSPENDED: "Suspendido",
  ACTIVE: "Activo",
  SETTINGS: "Configuraci\xF3n",
  HEALTH_INSURANCE: "Seguro de salud",
  TRAVEL: "Viajes",
  DRUGS: "Medicamentos",
  HEALTH_REIMBURSEMENT_ARRANGEMENT: "Acuerdo de reembolso de gastos de salud",
  LSA: "CGB",
  LIFESTYLE_SPENDING_ACCOUNT: "Cuenta gastos bienestar",
  HSA: "CGS",
  HEALTH_SPENDING_ACCOUNT: "Cuenta gastos de salud",
  REMOVE: "Quitar",
  STATE: "Estado",
  CITY: "Ciudad",
  ZIP_CODE: "C\xF3digo postal",
  GROUP_ID: "ID del grupo",
  CLAIMS: "Reclamaciones",
  TODAY: "Hoy",
  AND: "y",
  DETAILS: "Detalles",
  EDIT: "Editar",
  ADD: "Agregar",
  AMOUNT: "Monto",
  WALLET: "Cartera",
  SUBMITTED: "Enviado",
  SUBMITTED_FOR_PREAPPROVAL: "Enviado para preaprobaci\xF3n",
  REJECTED: "Denegado",
  PREAPPROVED: "Preaprobado",
  PREAPPROVAL_REJECTED: "Preaprobaci\xF3n denegada",
  PREAPPROVAL_MORE_INFORMATION_NEEDED: "M\xE1s informaci\xF3n sobre preaprobaci\xF3n",
  PENDING_EXTERNAL_REVIEW: "Enviado para revisi\xF3n externa",
  PAID: "Pagado",
  MORE_INFORMATION_NEEDED: "Necesita informaci\xF3n",
  CANCELLED: "Cancelado",
  APPROVED: "Aprobado",
  STARTED: "Iniciado",
  STATUS: "Estatus",
  COPY: "Copiar",
  PLEASE_NOTE: "Por favor, toma nota",
  THIS_BOX_MUST_BE_CHECKED_TO_CONTINUE: "Este casillero debe ser marcado para continuar",
  VIEW_ALL_CLAIMS: "Ver todas las reclamaciones",
  ACTIONS: "Acciones",
  VAL_POINTS: "{points} puntos",
  NOT_NOW: "No en este momento",
  ARIA_CIRCLED_CHECKMARK: "Marca de verificaci\xF3n blanca dentro de un c\xEDrculo",
  CONTINUE: "Continuar",
  VIEW_ACTIVITY: "Ver actividad",
  LEARN_MORE: "M\xE1s informaci\xF3n",
  DID_YOU_RECENTLY: "\xBFTe casaste o tuviste un beb\xE9 recientemente? Algunos eventos de vida pueden calificar para una reinscripci\xF3n.",
  HAVE_YOU_RECENTLY_EXPERIENCED_CHANGES: "\xBFHas experimentado cambios recientes en tu vida o en tu familia?",
  FEEDBACK_MAX_SCALE: "Muy \xFAtil",
  FEEDBACK_MIN_SCALE: "Poco \xFAtil",
  CONGRATS_COMPLETED: "\xA1Felicitaciones! Has completado",
  YOUVE_EARNED_TOTAL: "Has ganado un total de",
  WE_RE_SORRY_REQUESTED_PAGE_EXPIRED_OR_NOT_VALID: "Lo sentimos, la p\xE1gina que solicitaste ha vencido o ya no es v\xE1lida.",
  VIEW_MORE: "Ver m\xE1s",
  COMPLETE: "Completar",
  SELECT_ALL_THAT_APPLY: "Selecciona todo lo que aplique.",
  PRESS_ENTER: "Siguiente",
  WEVE_PICKED_UP: "Se ha retomado desde donde te quedaste.",
  FOR_PROVIDERS_AND_PHARMACISTS: "Para Proveedores/Farmac\xE9uticos",
  HP_ONBOARDING_SUBMIT: "Comencemos",
  SKIP: "Saltar",
  KEEP_GOING: "Contin\xFAa",
  LETS_BEGIN: "\xA1Comencemos!",
  FT: "ft",
  YOUR_HEALTH_PROFILE_IS: "Tu Perfil de salud es como un panorama general de tu salud, h\xE1bitos y objetivos. Usamos 6 aspectos de la salud para brindarte una perspectiva adecuada, contenidos y programas que te permitan lograr tus objetivos personales.",
  WHY_COMPLETE: "\xBFPor qu\xE9 completar tu Perfil de salud?",
  COMPLETE_ACTIVITIES: "Completa actividades para alcanzar tus objetivos de salud. Recomendadas en base a tu Perfil de salud.",
  HEALTH_PROGRAMS_FOR_YOU: "Programas de salud para ti",
  READ_OUR_ARTICLE: "Lee nuestro art\xEDculo",
  READING_MORE_ABOUT_DIMENSIONS: "\xBFTe interesa leer sobre c\xF3mo los diferentes aspectos de la salud repercuten en tu salud general?",
  DIMENSION_OF_HEALTH: "ASPECTOS DE LA SALUD",
  TOP_FOCUS_AREA: "\xC1rea de enfoque principal",
  PROGRAMS: "Programas",
  OUT_OF_NETWORK: "Fuera de la red",
  IN_NETWORK: "En la red",
  WERE_HAVING_TROUBLE: "Estamos teniendo problemas para cargar esta informaci\xF3n, por favor, trata de actualizar la p\xE1gina. Si el problema persiste, {custCareLink}.",
  UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG: "Uh, oh, parece que algo sali\xF3 mal",
  CONTACT_CUSTOMER_CARE: "contactar con atenci\xF3n al cliente",
  REMAINING_BALANCE: "Saldo restante",
  POLICY_ACTIVE: "Reglamento vigente",
  WALLET_LANDING_BODY: "Tu cartera digital es el espacio de tus beneficios de empleado, programas y detalles de tu cobertura. Encuentra lo que necesitas en un instante.",
  WALLET_LANDING_TITLE: "Tus beneficios y la informaci\xF3n sobre tu cobertura, todo en un mismo lugar.",
  GO_BACK: "Regresar",
  WALLET_FEEDBACK_SUBTITLE_OTHER: "\xBFQu\xE9 tan \xFAtil es la informaci\xF3n brindada por tu {cardName}?",
  WALLET_FEEDBACK_SUBTITLE_BENEFIT: "\xBFQu\xE9 tan \xFAtil es la informaci\xF3n brindada sobre tu beneficio \u201C{benefitName}\u201D?",
  WALLET_FEEDBACK_TITLE: "Ay\xFAdanos a mejorar la experiencia con la cartera",
  ADD_A_DEPENDENT_CAPITAL: "Agregar un dependiente",
  HAS_NO_DEPENDENTS_DESCRIPTION: "No tienes ning\xFAn dependiente asociado a este beneficio. Si recientemente viviste alg\xFAn cambio importante, posiblemente seas elegible para agregar o cambiar tus dependientes. Presiona el bot\xF3n de abajo para verificar en solo unos pasos si calificas.",
  HAS_DEPENDENTS_DESCRIPTION: "Tus dependientes para este beneficio est\xE1n listados a continuaci\xF3n. Si recientemente viviste alg\xFAn cambio importante, posiblemente seas elegible para cambiar tus dependientes. Presiona el bot\xF3n de abajo para verificar en solo unos pasos si calificas.",
  ID_LIKE_TO_DOTDOTDOT: "Quisiera...",
  ABOUT_THIS_BENEFIT_DESCRIPTION: "Este beneficio te fue otorgado por tu empleador. Para preguntas o informaci\xF3n detallada, comun\xEDcate con tu administrador de RR. HH.",
  ABOUT_THIS_BENEFIT: "Acerca de este beneficio",
  IF_YOU_HAVE_AN_URGENT_CLAIM_PLEASE_CONTACT_CUSTOMER_SUPPORT: "Si tienes alguna reclamaci\xF3n urgente, comun\xEDcate con <a>Servicio al cliente</a>.",
  RECENT_CLAIMS: "Reclamaciones recientes",
  NEED_MORE_INFO_MULTIPLE_CLAIMS: "Tus reclamaciones necesitan m\xE1s informaci\xF3n para ser procesadas. Ve los detalles a continuaci\xF3n,",
  NEED_MORE_INFO_SINGLE_CLAIM: "Tu reclamaci\xF3n necesita m\xE1s informaci\xF3n para ser procesada. Ve los detalles a continuaci\xF3n.",
  ROLLED_OVER: "Omitir",
  JOINED: "Ingresado",
  GET_CARE: "Cu\xEDdate",
  DID_YOU_GET_A_PROMO_CODE_DESCRIPTION: "Si has recibido un cr\xE9dito de la tienda o un c\xF3digo de promoci\xF3n, puedes introducirlo aqu\xED para recibir los cr\xE9ditos. Una vez introducidos se aplicar\xE1n autom\xE1ticamente a tu cuenta.",
  DID_YOU_GET_A_PROMO_CODE: "\xBFRecibiste un c\xF3digo de promoci\xF3n?",
  LEAGUE_CREDIT_DESCRIPTION_2: 'Para utilizar tu Cr\xE9dito League, selecciona "Cr\xE9dito League" en la lista de opciones de pago cuando realices la compra en Lifemarket. {learnMoreLink}',
  LEAGUE_CREDIT_DESCRIPTION_1: 'Puedes gastar el Cr\xE9dito League en {lifemarketLink} en una variedad de productos y servicios de estilo de vida y bienestar. Lo \xFAnico en lo que no puedes gastarlo es en cualquier cosa marcada como "Oferta de Socio de League".',
  ABOUT: "Acerca de",
  LIFEMARKET: "Lifemarket",
  TOTAL_BALANCE: "Saldo total",
  BROWSE_FILES: "Navegar archivos",
  PLEASE_CALL: "Llama al {phoneNumber}",
  WALLET_BENEFIT_STATUS_PENDING: "Pendiente",
  WALLET_BENEFIT_STATUS_ACTIVE: "Activo",
  WALLET_BENEFIT_STATUS_PAST: "Pasado"
};

// src/hooks/use-intl.tsx
import React, { useMemo } from "react";
import { genesisStyled, Box } from "@leagueplatform/genesis-commons";
import { useIntl as useReactIntl } from "react-intl";
var MessageContainer = genesisStyled(Box)`
  p:last-of-type {
    margin-bottom: 0;
  }
`;
var useIntl = () => {
  const intl = useReactIntl();
  return useMemo(
    () => __spreadProps(__spreadValues({}, intl), {
      $tmap: (map) => (
        /**
         * There is currently no way to retain the overloaded funtions'
         * parameter and return types from `react-intl` when wrapping them in
         * the alternative forms $tmap and $tifelse.
         *
         * For now, the type safety from the perspective of the consumer's end
         * is worth the TS error supression comments are worth
         *
         * See source for context https://github.com/formatjs/formatjs/blob/main/packages/intl/src/create-intl.ts#L143-L145
         */
        // @ts-expect-error
        (key, ...restArgs) => (
          // @ts-expect-error
          // we suppress the rule here, since this "the one internal use"
          // eslint-disable-next-line @leagueplatform/literal-i18n-message-id
          intl.$t({ id: map[key] || key }, ...restArgs)
        )
      ),
      // @ts-expect-error
      $tifelse: (condition, thenId, elseId, ...restArgs) => condition ? (
        // we suppress the rule here, since this "the one internal use"
        // eslint-disable-next-line @leagueplatform/literal-i18n-message-id
        intl.$t({ id: thenId }, ...restArgs)
      ) : (
        // eslint-disable-next-line @leagueplatform/literal-i18n-message-id
        intl.$t({ id: elseId }, ...restArgs)
      ),
      formatMoney: ({ F = 0, C = "USD" } = {}, {
        minimumFractionDigits = 2,
        style = "currency",
        currencyDisplay = "symbol"
      } = {}) => intl.formatNumber(F, {
        currency: C,
        minimumFractionDigits,
        style,
        currencyDisplay
      }),
      formatHTMLMessage: (props, values) => /* @__PURE__ */ React.createElement(
        MessageContainer,
        {
          as: "span",
          dangerouslySetInnerHTML: {
            // we suppress the rule here, since this "the one internal use"
            // eslint-disable-next-line @leagueplatform/literal-i18n-message-id
            __html: intl.formatMessage(props, values)
          }
        }
      )
    }),
    [intl]
  );
};

// src/utils/cookie-utils.ts
import cookie from "cookie";
var internalSetCookie = (name, value) => {
  const rawCookie = {};
  rawCookie[name] = value;
  if (typeof value === "object") {
    rawCookie[name] = JSON.stringify(value);
  }
  document.cookie = cookie.serialize(name, rawCookie[name], { path: "/" });
  return document.cookie;
};
var getCookie = (name) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return null;
  }
  const cookies = cookie.parse(document.cookie);
  const value = cookies && cookies[name];
  let parsedValue = null;
  try {
    parsedValue = JSON.parse(value);
  } catch (e) {
  }
  return parsedValue || value;
};

// src/constants.ts
var DEFAULT_MESSAGES = {
  default: en_default,
  en: en_default,
  fr: fr_CA_default,
  es: es_MX_default
};
var supportedLocaleList = ["en", "fr", "es"];
var CA_COUNTRY_CODE = "CA";
var US_COUNTRY_CODE = "US";
var supportedLocaleMapping = {
  [CA_COUNTRY_CODE]: ["en", "fr"],
  [US_COUNTRY_CODE]: ["en", "es-MX"]
};
var DEFAULT_LOCALE = "en";
var LANGUAGE_COOKIE_NAME = "league_current_language";

// src/get-current-locale.ts
var getCurrentLocale = (defaultLocale = DEFAULT_LOCALE) => getCookie(LANGUAGE_COOKIE_NAME) || typeof navigator !== "undefined" && (navigator == null ? void 0 : navigator.language) || defaultLocale;

// src/get-react-intl-props.ts
import { isProduction } from "@leagueplatform/app-environment";
import { getConfig } from "@leagueplatform/config";

// src/register-messages.tsx
import merge from "lodash/merge";
var registeredMessages = { default: {} };
function registerMessages(messages) {
  merge(registeredMessages, messages);
}

// src/get-react-intl-props.ts
var getReactIntlProps = (defaultLocale, supportedLocaleList2, locale = defaultLocale) => {
  var _a, _b;
  const language = locale.split("-")[0];
  const localeMessages = DEFAULT_MESSAGES[locale] || DEFAULT_MESSAGES[language];
  const registeredMessagesForLocale = registeredMessages[language] || registeredMessages.default;
  const customLocalesDeprecated = (_a = getConfig().config.core.i18n) == null ? void 0 : _a.stringOverrides;
  const customLocales = ((_b = getConfig().config.core.i18n) == null ? void 0 : _b.strings) || customLocalesDeprecated;
  const customLocaleMessages = (customLocales == null ? void 0 : customLocales[language]) || (customLocales == null ? void 0 : customLocales.default);
  const messages = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, DEFAULT_MESSAGES.default), localeMessages), registeredMessagesForLocale), customLocaleMessages);
  if (!isProduction() && typeof window !== "undefined" && localStorage.getItem("LEAGUE_SHOW_LOCALE_KEYS")) {
    Object.keys(messages).forEach((key) => messages[key] = `<${key}>`);
  }
  return {
    locale: supportedLocaleList2.includes(language) ? locale : defaultLocale,
    messages
  };
};

// src/get-app-supported-locale.ts
var getAppSupportedLocale = (defaultLocale, supportedLocaleList2) => {
  var _a;
  const languageLocale = (_a = navigator == null ? void 0 : navigator.language) == null ? void 0 : _a.split("-")[0];
  if (languageLocale && supportedLocaleList2.includes(languageLocale))
    return languageLocale;
  return defaultLocale;
};

// src/intl-shape.ts
import PropTypes from "prop-types";
var intlShape = PropTypes.shape({
  formatMessage: PropTypes.func,
  formatHTMLMessage: PropTypes.func,
  formatNumber: PropTypes.func,
  formatDate: PropTypes.func
});

// src/is-french.ts
var isFrench = (defaultLocale = DEFAULT_LOCALE) => getCurrentLocale(defaultLocale).includes("fr");

// src/is-spanish.ts
var isSpanish = (defaultLocale = DEFAULT_LOCALE) => getCurrentLocale(defaultLocale).includes("es");

// src/league-intl-provider/league-intl-provider.component.tsx
import React3 from "react";

// src/league-intl-provider/intl-provider-wrapper.component.tsx
import React2, { useContext } from "react";
import { IntlProvider } from "react-intl";
import { isNodeTestEnv } from "@leagueplatform/app-environment";
var defaultRichTextElements = Object.fromEntries(
  ["strong", "p", "em", "li", "ul", "br", "span", "button"].map((tag) => {
    const formatter = (chunks) => chunks.length ? `<${tag}>${chunks}</${tag}>` : `<${tag} />`;
    return [tag, formatter];
  })
);
var LocaleContext = React2.createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {
  }
});
var onWarn = isNodeTestEnv() ? () => {
} : void 0;
var IntlProviderWrapper = ({ children }) => {
  const { locale } = useContext(LocaleContext);
  const intlProps = getReactIntlProps(
    DEFAULT_LOCALE,
    supportedLocaleList,
    locale
  );
  return /* @__PURE__ */ React2.createElement(
    IntlProvider,
    {
      onWarn,
      locale: intlProps.locale,
      messages: intlProps.messages,
      defaultRichTextElements
    },
    children
  );
};

// src/hooks/use-cookie/use-cookie-hook.ts
import { useState, useEffect } from "react";
var useCookie = (cookieName) => {
  const initialCookieValue = getCookie(cookieName);
  const [cookie2, setCookieState] = useState();
  const setCookie = (value) => {
    internalSetCookie(cookieName, value);
    setCookieState(value);
  };
  useEffect(() => {
    setCookieState(initialCookieValue);
  }, [initialCookieValue]);
  return { cookie: cookie2, setCookie };
};

// src/league-intl-provider/league-intl-provider.component.tsx
var LeagueIntlProvider = ({ children }) => {
  const { cookie: cookieLocale, setCookie: setLocale } = useCookie(LANGUAGE_COOKIE_NAME);
  const currentLocale = getCurrentLocale(DEFAULT_LOCALE);
  const locale = cookieLocale || currentLocale;
  return /* @__PURE__ */ React3.createElement(LocaleContext.Provider, { value: { locale, setLocale } }, /* @__PURE__ */ React3.createElement(IntlProviderWrapper, null, children));
};

// src/formatted-html-message.component.tsx
import React4 from "react";
var FormattedHTMLMessage = ({
  id,
  description,
  defaultMessage,
  values,
  ignoreTag,
  tagName = "span",
  children
}) => {
  const { formatMessage } = useIntl();
  const descriptor = {
    id,
    description,
    defaultMessage
  };
  const nodes = formatMessage(descriptor, values, { ignoreTag });
  if (children) {
    return children(Array.isArray(nodes) ? nodes : [nodes]);
  }
  const Tag = tagName;
  return /* @__PURE__ */ React4.createElement(
    Tag,
    {
      dangerouslySetInnerHTML: {
        __html: nodes
      }
    }
  );
};
export {
  CA_COUNTRY_CODE,
  DEFAULT_LOCALE,
  DEFAULT_MESSAGES,
  en_default as EN,
  es_MX_default as ES,
  fr_CA_default as FR,
  FormattedHTMLMessage,
  LeagueIntlProvider,
  LocaleContext,
  US_COUNTRY_CODE,
  defaultRichTextElements,
  getAppSupportedLocale,
  getCurrentLocale,
  getReactIntlProps,
  intlShape,
  isFrench,
  isSpanish,
  registerMessages,
  supportedLocaleList,
  supportedLocaleMapping,
  useIntl
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/locales'] = window.leagueSDKsPresent['@leagueplatform/locales'] || [];
    window.leagueSDKsPresent['@leagueplatform/locales'].push('2.8.2');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/locales'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/locales module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
